import React, {useEffect, useMemo, useRef, useState} from 'react'
import {KTSVG} from '../../../../_metronic/helpers/components/KTSVG'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import {Link, useLocation, useNavigate, useParams} from 'react-router-dom'
import Select from 'react-select'
import axios from 'axios'
import moment from 'moment-timezone'
import clsx from 'clsx'
import {Dropdown, OverlayTrigger, Tooltip} from 'react-bootstrap'
import {
  getAssignStatusBadge,
  getAssignStatusName,
  getFileType,
  isApiSuccess,
  isInterpreterAvailableForAssignment,
  isInterpreterManuallyUnavailable,
  resolveAssignStatus,
  statusMapping,
} from '../../../../Utils/commonData'
import {useAuth} from '../../../modules/auth'
import toaster from '../../../../Utils/toaster'
import {
  fetchRecallSession,
  RecallBotLeaveReason,
  RecallCheckInSource,
  RecallMeetingEndSource,
  RecallRejoinReason,
  RecallSessionDto,
} from '../_requests'
import {Form, Formik} from 'formik'
import * as Yup from 'yup'
import {CommonPaginationModel} from '../../../../Utils/commonPagination'
import {DocumentViewModal} from '../../../../Utils/documentViewModal'
import {CommonLoading} from '../../../../Utils/commonLoading'
import AddOSIDetails from './AddOSIDetails'
import {EditWithoutUnlinkingWarningModal} from './EditWithoutUnlinkingWarningModal'
import {InterpreterJoinNameHint} from './InterpreterJoinNameHint'
import {Modal} from 'bootstrap'
import {OSIDocumentViewModal} from '../../../../Utils/osiDocumentViewModal'
import OSIDocumentViewer from '../../../common/componenets/documentViewer/documentViewer'
import {exportManualVosPdf} from './digital-vos-form/exportManualVosPdf'
import {getActive as getActiveUnassignmentReasons} from '../../master-data/unassignment-reason-management/list/core/_requests'
import {UnassignmentReasonShort} from '../../master-data/unassignment-reason-management/list/core/_models'
import {readOsiBreakTimeMinutes} from './vosDurationUtils'
import {CancelConfirmationModal} from '../../../common/Models/cancel-confirmation-modal/CancelConfirmationModal'
import {CancelSeriesSelectionModal} from '../../../common/Models/cancel-series-selection-modal/CancelSeriesSelectionModal'
import {
  RecurringSeriesSelectionModal,
  RecurringSeriesSelectionMode,
} from '../../../common/Models/recurring-series-selection-modal/RecurringSeriesSelectionModal'
import CCPStatusButton from '../../Common/components/Appointments/CCPStatusButton'
import {ProfileImg} from '../../../../Utils/fileUrlHelper'
import {InterpreterNameWithCaseCount} from './InterpreterNameWithCaseCount'
import {
  AiRecommendedTag,
  InterpreterScoreBadge,
  InterpreterTag,
  ScoreColumnHeader,
} from './InterpreterScoreBadge'
import {BestMatchesSection, getAiBadge} from './BestMatchesSection'
import {SuboptimalAssignmentModal} from './SuboptimalAssignmentModal'
import RebroadcastModal from './RebroadcastModal'
import AiAgentBanner, {AiAssignmentSummary, isAiAssignmentInScope} from './AiAgentBanner'
import SmsActivityModal from './SmsActivityModal'
import MarkUnavailableModal from './MarkUnavailableModal'
import AppointmentActionsDropdown from './AppointmentActionsDropdown'
import ProfileNotesModal from './ProfileNotesModal'
import InterpreterNotesButton from './InterpreterNotesButton'
import AccountNotesView from '../../customers-management/notes/AccountNotesView'
import LinguistNotesView from '../../configuration-management/components/LinguistNotesView'
import {VOSSignatureImage} from './OSISignatureImages'
import {OSISubmissionDetailsCard} from './OSISubmissionDetailsCard'
import {MeetingSummaryExtensionsCard} from './MeetingSummaryExtensionsCard'
import {DigitalVosFormViewer} from './digital-vos-form/DigitalVosFormViewer'
import {
  ManualVosInvoiceVoucherLines,
  ManualVosMeetingSummaryCard,
} from './ManualVosMeetingSummaryCard'
import {
  ExtensionRequestListItem,
  normalizeExtensionRequestsList,
} from './extensionRequestUtils'
import {
  isAppointmentCancelled,
  isMeetingSummaryTabVisible,
} from '../../../../Utils/appointmentStatusUtils'
import {
  getVosDisputeFieldDiffs,
  isVosDisputeStatus,
  vosDisputeRowClassName,
  type VosDisputeFieldKey,
} from './vosDisputeHighlight'
import {
  formatVosTravelTime,
  resolveAppointmentChargeRateHours,
  resolveOsiBillingFlags,
} from './vosFormatters'

const API_URL = process.env.REACT_APP_API_URL
const Uploads_URL = process.env.REACT_APP_IMG_URL
const itemsPerPage = Number(process.env.REACT_APP_PAGINATION_ITEMS_PER_PAGE) || 10
const CLIENT_CANCELLATION_THRESHOLD_HOURS = 72

const isClientCancellationEligible = (appointmentDetails: any) => {
  if (typeof appointmentDetails?.canClientSelfCancel === 'boolean') {
    return appointmentDetails.canClientSelfCancel
  }
  return (
    !!appointmentDetails?.startTime &&
    moment(appointmentDetails.startTime).diff(moment(), 'hours', true) >=
      CLIENT_CANCELLATION_THRESHOLD_HOURS
  )
}

const documentUploadSchemaSchema = Yup.object().shape({
  name: Yup.string().required('Required'),
  description: Yup.string(),
  file: Yup.string().required('Required'),
})
const addnoteSchema = Yup.object().shape({
  note: Yup.string().required('Required'),
  chatwith: Yup.string().required('Required'),
})

const unAssignConfirmedInterpreterSchema = Yup.object().shape({
  reason: Yup.string().required('Required'),
})

const ADDITIONAL_INFO_MAX_LENGTH = 500

const addRejectNoteSchema = Yup.object().shape({
  reason: Yup.string().required('Required'),
})

function mapOsiExpensesFromApi(osiExpensesList: any[] | undefined | null) {
  if (!osiExpensesList?.length) return []
  return osiExpensesList.map((item) => ({
    description: item.description,
    amount: item.amount,
    file: item.fileName,
    dataUrl: item.fileName,
    code: item.code,
    isExpensesPayableForInterpreter: item.isExpensesPayableForInterpreter ?? true,
    isExpensesChargeableForClient: item.isExpensesChargeableForClient ?? true,
  }))
}

export function AssignAppointmentView() {
  const location = useLocation()
  const chat = [
    {value: 1, label: 'User'},
    {value: 2, label: 'Requester Content Admin'},
    {value: 3, label: 'Interpreter'},
    {value: 4, label: 'Manager'},
    {value: 5, label: 'Admin'},
    {value: 6, label: 'All'},
  ]

  const category = [
    {value: 'option1', label: 'Fuel/Mileage'},
    {value: 'option2', label: 'Parking/Tolls'},
    {value: 'option3', label: 'Public Transportation'},
    {value: 'option4', label: 'Taxi/Uber/Back car'},
    {value: 'option5', label: 'Internet/Phone'},
    {value: 'option6', label: 'Meals/Foods'},
    {value: 'option7', label: 'Hotel/Accommodation'},
    {value: 'option8', label: 'Airfare'},
    {value: 'option9', label: 'Travel Time'},
    {value: 'option10', label: 'Other'},
  ]

  const {currentUser} = useAuth()
  const [activeTab, setActiveTab] = useState(currentUser?.result?.userType === 'SYSTEM' ? 1 : 2)
  const initialValues = {
    name: '',
    description: '',
    file: '',
  }
  const initialValue = {
    chatwith: 0,
    note: '',
  }

  const handleTabClick = (tabNumber: React.SetStateAction<number>) => {
    navigate(`/appointmentViewer/${id}?tab=${tabNumber}`)
    //setActiveTab(tabNumber)
  }
  const [selectedRecurrence, setSelectedRecurrence] = useState('1')
  const [isOsiEdit, setOsiEdit] = useState<boolean>(false)
  const [showOsiReadOnly, setShowOsiReadOnly] = useState(false)
  const [showEditWithoutUnlinkingWarning, setShowEditWithoutUnlinkingWarning] = useState(false)
  const [isEditWithoutUnlinking, setIsEditWithoutUnlinking] = useState(false)

  const handleRecurrenceChange = (event: any) => {
    setSelectedRecurrence(event.target.value)
  }
  const [rows, setRows] = useState([{}])

  const addRow = () => {
    if (rows.length < 2) {
      setRows([...rows, {}])
    }
  }
  const removeRow = (index: number) => {
    const newRows = rows.filter((_, i) => i !== index)
    setRows(newRows)
  }
  const [isChecked, setIsChecked] = useState(false)
  const [isChecked2, setIsChecked2] = useState(false)

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked)
  }
  const handleCheckboxChange2 = () => {
    setIsChecked2(!isChecked2)
  }
  const [isRatePerMile, setIsRatePerMile] = useState(true)

  const [isTravelTime, setIsTravelTime] = useState(true)
  const [selectedOption, setSelectedOption] = useState('')

  const handleSelectChange = (event: any) => {
    setSelectedOption(event.target.value)
  }

  //use states
  const [updatedRate, setUpdatedRate] = useState<any>('')
  const [appointmentDetails, setAppointmentDetails] = useState<any>({})
  const [interpreters, setInterpreters] = useState<any>([])
  const [notMatchInterpreters, setNotMatchInterpreters] = useState<any>([])
  const [unavailableInterpreters, setUnavailableInterpreters] = useState<any>([])
  const [ipiRecommendationEnabled, setIpiRecommendationEnabled] = useState(false)
  const [activities, setActivities] = useState<any>([])
  const [notes, setNotes] = useState<any>([])
  const [osiNotes, setOSINotes] = useState<any>([])
  const [documents, setDocuments] = useState<any>([])
  const [customerDocuments, setCustomerDocuments] = useState<any>([])
  const {id} = useParams()
  const navigate = useNavigate()
  const [isLoading, setIsLoading] = useState(false)
  const [isAssignUnassignInProgress, setIsAssignUnassignInProgress] = useState(false)
  const [recurringModalLoadingAction, setRecurringModalLoadingAction] = useState<'only' | 'all' | null>(null)
  const [isOpenCancelConfirmationModal, setIsOpenCancelConfirmationModal] = useState(false)
  const [isOpenCancelSeriesSelectionModal, setIsOpenCancelSeriesSelectionModal] = useState(false)
  const [selectedAppointmentIdsForCancel, setSelectedAppointmentIdsForCancel] = useState<number[]>([])
  const [message, setMessage] = useState('')
  const [isBulkCancalation, setIsBulkCancalation] = useState(false)
  const [showConsumerCancelModal, setShowConsumerCancelModal] = useState(false)
  const [showConsumerCancelSuccessModal, setShowConsumerCancelSuccessModal] = useState(false)
  const [isRebroadcastModalOpen, setIsRebroadcastModalOpen] = useState(false)
  const [aiAssignmentSummary, setAiAssignmentSummary] = useState<AiAssignmentSummary | null>(null)
  const [aiAssignmentSummaryRefreshKey, setAiAssignmentSummaryRefreshKey] = useState(0)
  const [isSmsActivityOpen, setIsSmsActivityOpen] = useState(false)
  const [markUnavailableTarget, setMarkUnavailableTarget] = useState<any>(null)
  const [isRevertUnavailableInProgress, setIsRevertUnavailableInProgress] = useState(false)
  const [cancelledAppointmentSnapshot, setCancelledAppointmentSnapshot] = useState<any>(null)
  const [meetingSummary, setMeetingSummary] = useState<any>({})
  const [recallSession, setRecallSession] = useState<RecallSessionDto | null>(null)

  const formatBotTime = (v: string | null | undefined, format = 'MM/DD/YYYY h:mm A') => {
    if (!v) return '-'
    return moment(v).format(format)
  }
  // Bot had a successful meeting: terminal 'done' status, actually joined, no fallback (no-show/kicked/etc.)
  const isBotMeetingSuccessful =
    recallSession?.botStatus === 'done' &&
    !recallSession.fallbackTriggered &&
    !!recallSession.botJoinedAtUtc

  const renderBotAttendanceCard = () => {
    if (!recallSession) return null
    if (recallSession.hasSession === false) {
      if (recallSession.botEnabledForClient === false) {
        return (
          <div className='row g-3 mb-3'>
            <div className='col-12'>
              <div className='card border rounded p-3'>
                <div className='fw-bold mb-2'>Bot-Verified Attendance</div>
                <span className='d-flex text-muted' style={{fontSize: '13px'}}>
                  <i className='fa-solid fa-robot me-2 align-self-center' style={{fontSize: '12px'}} />
                  Not applicable — bot not enabled for this client.
                </span>
              </div>
            </div>
          </div>
        )
      }
      return null
    }
    const fmt = (v: any) => formatBotTime(v)
    const isBotAdmission = recallSession.checkInSource === RecallCheckInSource.BotAdmission
    const interpreterFmt = (v: any) => (isBotAdmission ? '—' : fmt(v))
    const botStatusLabel = (sess: RecallSessionDto) => {
      const raw = sess?.botStatus
      if (!raw) return '-'
      if (raw === 'rejoining') return 'Re-joining after removal'
      if (raw === 'done' && !sess.fallbackTriggered && sess.botJoinedAtUtc) {
        return 'Joined'
      }
      return raw
    }
    const fmtDuration = (secs: any) => {
      if (secs == null || secs < 0) return '-'
      const s = Math.round(secs)
      const h = Math.floor(s / 3600)
      const m = Math.floor((s % 3600) / 60)
      const sec = s % 60
      if (h > 0) return `${h}h ${m}m`
      if (m > 0) return `${m}m ${sec}s`
      return `${sec}s`
    }
    
    const totalMeetingSeconds =
      recallSession.meetingStartedAtUtc && recallSession.meetingEndedAtUtc
        ? moment(recallSession.meetingEndedAtUtc).diff(moment(recallSession.meetingStartedAtUtc), 'seconds')
        : null
    const meetingEndSourceLabel = !recallSession.meetingEndedAtUtc
      ? null
      : recallSession.meetingEndSource === RecallMeetingEndSource.LastParticipantLeave
      ? 'last participant left'
      : recallSession.meetingEndSource === RecallMeetingEndSource.BotCallEnded
      ? 'bot left the call'
      : recallSession.meetingEndSource === RecallMeetingEndSource.BotDone
      ? 'bot finished processing'
      : recallSession.meetingEndSource === RecallMeetingEndSource.ApiStatus
      ? 'Recall status check'
      : null
    const botLeftOnInterpreterAbsence =
      recallSession.botLeaveReason === RecallBotLeaveReason.InterpreterAbsent

    const attemptCount = recallSession.attemptCount ?? 1
    const bridgedSeconds = recallSession.bridgedSeconds ?? 0
    const coverageGapSeconds = recallSession.coverageGapSeconds ?? 0
    const excursions = recallSession.waitingRoomExcursions ?? 0
    const rejoinReasonLabel = (reason?: string | null) =>
      reason === RecallRejoinReason.KickedInCall
        ? 'removed from the call by the host'
        : reason === RecallRejoinReason.KickedWaitingRoom
        ? 'removed from the waiting room by the host'
        : reason === RecallRejoinReason.WaitingRoomTimeout
        ? 'never admitted from the waiting room'
        : 'removed from the meeting'

    return (
      <div className='row g-3 mb-3'>
        <div className='col-12'>
          <div className='card border rounded p-3'>
            <div className='d-flex align-items-center justify-content-between mb-3'>
              <div className='fw-bold'>
                Bot-Verified Attendance
                {appointmentDetails?.timeZoneName && (
                  <span className='ms-2 text-muted fw-normal' style={{fontSize: '11px'}}>
                    (times in {appointmentDetails.timeZoneName})
                  </span>
                )}
              </div>
              {recallSession.needsIdentityReview && (
                <span className='badge bg-warning text-dark'>Identity review needed</span>
              )}
            </div>
            <span className='d-flex mb-2'>
              <i className='fa-solid fa-robot me-2 text-muted align-self-center' style={{fontSize: '12px'}} />
              <span className='me-2 fw-bold'>Bot status:</span> {botStatusLabel(recallSession)}
            </span>
            <span className='d-flex mb-2'>
              <i className='fa-solid fa-robot me-2 text-muted align-self-center' style={{fontSize: '12px'}} />
              <span className='me-2 fw-bold'>Bot joined:</span> {fmt(recallSession.botJoinedAtUtc)}
            </span>
            <span className='d-flex mb-2'>
              <i className='fa-solid fa-right-to-bracket me-2 text-muted align-self-center' style={{fontSize: '12px'}} />
              <span className='me-2 fw-bold'>Interpreter checked in:</span> {interpreterFmt(recallSession.interpreterCheckInAtUtc)}
            </span>
            <span className='d-flex mb-2'>
              <i className='fa-solid fa-right-from-bracket me-2 text-muted align-self-center' style={{fontSize: '12px'}} />
              <span className='me-2 fw-bold'>Interpreter checked out:</span> {interpreterFmt(recallSession.interpreterCheckOutAtUtc)}
            </span>
            {isBotAdmission && (
              <span className='d-flex mb-2 text-muted' style={{fontSize: '12px'}}>
                <i className='fa-solid fa-circle-info me-2 align-self-center' style={{fontSize: '12px'}} />
                Interpreter join/leave not captured — bot admission window only.
              </span>
            )}
            <span className='d-flex mb-2'>
              <i className='fa-solid fa-hourglass-half me-2 text-muted align-self-center' style={{fontSize: '12px'}} />
              <span className='me-2 fw-bold'>Interpreter In Call Duration:</span> {fmtDuration(recallSession.interpreterMeetingSeconds)}
              {bridgedSeconds > 0 && (
                <span className='text-muted ms-2 align-self-center' style={{fontSize: '11px'}}>
                  (includes {fmtDuration(bridgedSeconds)} while no bot was in the call)
                </span>
              )}
            </span>
            {coverageGapSeconds > 0 && (
              <span className='d-flex mb-2 text-muted' style={{fontSize: '12px'}}>
                <i className='fa-solid fa-circle-info me-2 align-self-center' style={{fontSize: '12px'}} />
                {fmtDuration(coverageGapSeconds)} not captured — no bot was in the call and the interpreter
                could not be confirmed present.
              </span>
            )}
            {excursions > 0 && (
              <span className='d-flex mb-2 text-muted' style={{fontSize: '12px'}}>
                <i className='fa-solid fa-door-closed me-2 align-self-center' style={{fontSize: '12px'}} />
                Bot moved to the waiting room {excursions} time{excursions === 1 ? '' : 's'} during the meeting.
              </span>
            )}
            {recallSession.rejoinPending && (
              <span className='d-flex mb-2 text-muted' style={{fontSize: '12px'}}>
                <i className='fa-solid fa-rotate me-2 align-self-center' style={{fontSize: '12px'}} />
                The bot was removed from the meeting — a replacement is being sent to rejoin.
              </span>
            )}
            {recallSession.identityDriftSuspected && (
              <span className='d-flex mb-2 text-warning'>
                <i className='fa-solid fa-triangle-exclamation me-2 align-self-center' style={{fontSize: '12px'}} />
                One bot could not identify the interpreter — the duration above may be incomplete.
              </span>
            )}
            {attemptCount > 1 && (
              <div className='mt-2 pt-2 border-top'>
                <span className='d-flex mb-2'>
                  <i className='fa-solid fa-robot me-2 text-muted align-self-center' style={{fontSize: '12px'}} />
                  <span className='me-2 fw-bold'>Bots used:</span> {attemptCount}
                </span>
                {(recallSession.attempts ?? []).map((attempt) => (
                  <span
                    key={attempt.attemptNumber}
                    className='d-flex mb-1 text-muted'
                    style={{fontSize: '11px', paddingLeft: '20px'}}
                  >
                    Bot {attempt.attemptNumber}: joined {fmt(attempt.botJoinedAtUtc)}
                    {attempt.interpreterMeetingSeconds != null &&
                      ` · interpreter ${fmtDuration(attempt.interpreterMeetingSeconds)}`}
                    {attempt.rejoinReason && ` · ${rejoinReasonLabel(attempt.rejoinReason)}`}
                  </span>
                ))}
              </div>
            )}
            <span className='d-flex mb-2'>
              <i className='fa-solid fa-clock me-2 text-muted align-self-center' style={{fontSize: '12px'}} />
              <span className='me-2 fw-bold'>Total meeting time:</span> {fmtDuration(totalMeetingSeconds)}
              {meetingEndSourceLabel && (
                <span className='text-muted ms-2 align-self-center' style={{fontSize: '11px'}}>
                  (end time from {meetingEndSourceLabel})
                </span>
              )}
            </span>
            {botLeftOnInterpreterAbsence && (
              <span className='d-flex mb-2 text-muted' style={{fontSize: '12px'}}>
                <i className='fa-solid fa-circle-info me-2 align-self-center' style={{fontSize: '12px'}} />
                Bot left the call — the interpreter did not rejoin after leaving.
              </span>
            )}
            {recallSession.fallbackTriggered && (
              <span className='d-flex mb-2 text-danger'>
                <i className='fa-solid fa-triangle-exclamation me-2 align-self-center' style={{fontSize: '12px'}} />
                <span className='me-2 fw-bold'>Fallback:</span>
                {recallSession.fallbackReason ?? 'triggered'}
                {recallSession.errorCode ? ` (${recallSession.errorCode})` : ''}
              </span>
            )}
          </div>
        </div>
      </div>
    )
  }
  
  const renderAttendanceAuditLines = () => {
    const ad = appointmentDetails
    const manualCheckedInAt = ad?.checkedInAt ?? ad?.CheckedInAt
    const manualCheckOutAt = ad?.checkOutAt ?? ad?.CheckOutAt
    const isTppAudit = ad?.communicationTypeIdentification === 'THIRD_PART_PLATFORM'
    const botTimesUsable =
      isTppAudit &&
      recallSession &&
      recallSession.checkInSource !== RecallCheckInSource.BotAdmission
    const checkedInAt =
      manualCheckedInAt || (botTimesUsable ? recallSession?.interpreterCheckInAtUtc : null)
    const checkOutAt =
      manualCheckOutAt || (botTimesUsable ? recallSession?.interpreterCheckOutAtUtc : null)
    const checkInFromBot = !manualCheckedInAt && !!checkedInAt
    const checkOutFromBot = !manualCheckOutAt && !!checkOutAt
    const fmtDt = (v: any) => {
      if (!v) return '-'
      // Both manual and bot times are already in the appointment's timezone.
      const format = isTppAudit ? 'h:mm A' : 'MM/DD/YYYY h:mm A'
      return moment(v).format(format)
    }
    return (
      <>
        <span className='d-flex mb-2'>
          <i
            className='fa-solid fa-right-to-bracket me-2 text-muted align-self-center'
            style={{fontSize: '12px'}}
          />
          <span className='me-2 fw-bold'>Checked in:</span>
          {fmtDt(checkedInAt)}
          {checkInFromBot && (
            <span className='ms-2 text-muted' style={{fontSize: '11px'}}>
              (bot-verified)
            </span>
          )}
        </span>
        <span className='d-flex mb-2'>
          <i
            className='fa-solid fa-right-from-bracket me-2 text-muted align-self-center'
            style={{fontSize: '12px'}}
          />
          <span className='me-2 fw-bold'>Checked out:</span>
          {fmtDt(checkOutAt)}
          {checkOutFromBot && (
            <span className='ms-2 text-muted' style={{fontSize: '11px'}}>
              (bot-verified)
            </span>
          )}
        </span>
      </>
    )
  }

  const renderBotAvatar = () => (
    <div className='symbol symbol-50px symbol-circle overflow-hidden'>
      <div className='symbol-label bg-light-primary'>
        <i className='fa-solid fa-robot fs-2 text-primary' />
      </div>
    </div>
  )
  const [isResubmit, setIsResubmit] = useState(false)
  const [initialValuesOSI, setInitialValuesOSI] = useState({
    code: '',
    startTime: '',
    startDateTime: '',
    endDateTime: '',
    endTime: '',
    travelHours: 0,
    travelMinutes: 0,
    isRoundTrip: false,
    milageOfDrive: '',
    isTimeChargeableForInterpreter: true,
    isTimeChargeableForClient: true,
    isMileagePayableForInterpreter: true,
    isMileageChargeableForClient: true,
    isTravelTimePayableForInterpreter: true,
    isTravelTimeChargeableForClient: true,
    addStaffMember: false,
    staffMemberName: '',
    staffMemberEmail: '',
    breakTimeMinutes: '' as number | '',
    vosSubmissionMode: undefined as number | undefined,
    interpreterRateHour: '' as number | '',
    clientRateHour: '' as number | '',
    // Removed isExpensesPayableForInterpreter and isExpensesChargeableForClient from OSI
  })
  let [expenseList, setExpenseList] = useState<any>([])
  const [billingDetails, setBillingDetails] = useState<any>(null)
  const [
    forcefullyAssignInterpretersConfirmDetails,
    setForcefullyAssignInterpretersConfirmDetails,
  ] = useState<any>(null)

  // pagination
  const [currentPage, setCurrentPage] = useState(1)
  const [totalPages, setTotalPages] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState<number>(itemsPerPage)
  const [totalItems, setTotalItems] = useState(0)
  const [isLoadingAccept, setIsLoadingAccept] = useState<boolean>(false)
  const [initialValueUnassignConfirmedInterperter, setInitialValueUnassignConfirmedInterperter] =
    useState<any>({
      appointmentId: '',
      interpreterId: '',
      reason: '',
      additionalInfo: '',
    })
  const [unassignFormKey, setUnassignFormKey] = useState(0)
  const [unassignmentReasons, setUnassignmentReasons] = useState<UnassignmentReasonShort[] | null>([])
  const [unassignmentReasonsLoading, setUnassignmentReasonsLoading] = useState(false)

  const loadUnassignmentReasons = async () => {
    setUnassignmentReasonsLoading(true)
    try {
      setUnassignmentReasons((await getActiveUnassignmentReasons()) ?? [])
    } catch (error) {
      console.error(error)
      setUnassignmentReasons(null)
    } finally {
      setUnassignmentReasonsLoading(false)
    }
  }

  const [showClientNotesModal, setShowClientNotesModal] = useState(false)
  const [notesInterpreter, setNotesInterpreter] = useState<any>(null)
  const [showMissingDocsModal, setShowMissingDocsModal] = useState(false)
  const [missingDocsInterpreter, setMissingDocsInterpreter] = useState<any>(null)
  const [missingDocuments, setMissingDocuments] = useState<any[]>([])
  const [isLoadingMissingDocs, setIsLoadingMissingDocs] = useState(false)
  const [isRevertingApproval, setIsRevertingApproval] = useState(false)
  const [isVosDisputeActionLoading, setIsVosDisputeActionLoading] = useState(false)

  const [regenerateTarget, setRegenerateTarget] = useState<'client' | 'interpreter' | null>(null)
  const [showRegenerateConfirm, setShowRegenerateConfirm] = useState(false)
  const [isRegenerating, setIsRegenerating] = useState(false)
  const [documentExistsMessage, setDocumentExistsMessage] = useState<string | null>(null)
  const [showActivityParticipantModal, setShowActivityParticipantModal] = useState(false)
  const [activityParticipant, setActivityParticipant] = useState<any>(null)
  const [activityParticipantDetails, setActivityParticipantDetails] = useState<any>(null)
  const [isLoadingActivityParticipant, setIsLoadingActivityParticipant] = useState(false)

  // Lazy loading flags for tabs
  const [isActivitiesLoaded, setIsActivitiesLoaded] = useState(false)
  const [isDocumentsLoaded, setIsDocumentsLoaded] = useState(false)
  const [isMeetingSummaryLoaded, setIsMeetingSummaryLoaded] = useState(false)
  const [isMeetingSummaryPageLoading, setIsMeetingSummaryPageLoading] = useState(false)
  const [extensionRequests, setExtensionRequests] = useState<ExtensionRequestListItem[]>([])
  const [extensionsLoading, setExtensionsLoading] = useState(false)
  const meetingSummaryFetchRef = useRef({loaded: false, inFlight: false})
  const extensionRequestsFetchRef = useRef<{
    appointmentId: string | null
    inFlight: Promise<void> | null
  }>({appointmentId: null, inFlight: null})

  const [sortColumn, setSortColumn] = useState<string>('')
  const [sortDirection, setSortDirection] = useState<'asc' | 'desc'>('asc')
  const hasRequesterVOSSubmission = Boolean(
    meetingSummary?.hasRequesterVOSSubmission ?? meetingSummary?.HasRequesterVOSSubmission
  )
  const requesterVosDisputed = Boolean(
    meetingSummary?.requesterVosDisputed ?? meetingSummary?.RequesterVosDisputed
  )
  const interpreterAcceptedDispute =
    meetingSummary?.interpreterAcceptedDispute ?? meetingSummary?.InterpreterAcceptedDispute
  const interpreterAcceptedRequesterDispute =
    requesterVosDisputed && interpreterAcceptedDispute === true
  const interpreterRejectedRequesterDispute =
    requesterVosDisputed && interpreterAcceptedDispute === false
  const isManualVos = Number(meetingSummary?.vosSubmissionMode) === 0
  const isDigitalVos = Number(meetingSummary?.vosSubmissionMode) === 1
  const awaitingInterpreterDisputeDecision =
    requesterVosDisputed &&
    interpreterAcceptedDispute !== true &&
    interpreterAcceptedDispute !== false
  const showInterpreterVosDisputeActions =
    currentUser?.result?.userType === 'INTERPRETER' &&
    isDigitalVos &&
    awaitingInterpreterDisputeDecision &&
    Boolean(meetingSummary?.code)
  const isVosDisputeHighlight = isVosDisputeStatus(meetingSummary, {
    isDigitalVos,
    requesterVosDisputed,
    hasRequesterVOSSubmission,
  })
  const vosFieldDiffs = useMemo(
    () => getVosDisputeFieldDiffs(meetingSummary),
    [meetingSummary]
  )
  const vosRowClass = (field: VosDisputeFieldKey) =>
    vosDisputeRowClassName(isVosDisputeHighlight, vosFieldDiffs[field])
  /** Digital VOS only: hide Approve while interpreter has not decided, or after interpreter rejected (status 4). */
  const hideOsiApproveForRequesterDispute =
    isDigitalVos &&
    ((interpreterRejectedRequesterDispute && meetingSummary?.status === 4) ||
      awaitingInterpreterDisputeDecision)
  const isOsiAdminApproved = meetingSummary?.status === 2
  const vosFormDocument =
    meetingSummary?.vosForm ??
    meetingSummary?.vOSForm ??
    meetingSummary?.osiExpensesList?.find((e: any) =>
      String(e?.fileName ?? '').toLowerCase().includes('vos_form')
    )
  const vosFormDocumentPath =
    vosFormDocument?.document ?? vosFormDocument?.fileName ?? ''
  const vosFormOsiCode =
    vosFormDocument?.fK_OSICode ?? vosFormDocument?.fk_OSICode ?? meetingSummary?.code ?? ''
  const vosFormFileUrl = vosFormDocumentPath.startsWith('s3://')
    ? vosFormDocumentPath
    : vosFormDocumentPath
      ? `${Uploads_URL}/files/${vosFormOsiCode}/${vosFormDocumentPath}`
      : ''
  const showDigitalVosFormViewer =
    isDigitalVos && isOsiAdminApproved && Boolean(meetingSummary?.code)
  const showOsiSubmissionDetailsCard = isDigitalVos && isOsiAdminApproved
  const osiSubmissionDetailsCardTitle = isManualVos
    ? isOsiAdminApproved
      ? 'Approved Details'
      : 'Submitted Details'
    : 'Approved Details'
  // Sorting function
  const handleSort = (column: string) => {
    if (sortColumn === column) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc')
    } else {
      setSortColumn(column)
      setSortDirection('asc')
    }
  }

  const getSortedData = (data: any[]) => {
  if (!sortColumn) {
    if (!ipiRecommendationEnabled) return data;
    return [...data].sort((a, b) => {
      const aNew = a?.isNewInterpreter ? 1 : 0;
      const bNew = b?.isNewInterpreter ? 1 : 0;
      if (aNew !== bNew) return aNew - bNew;
      const av = a?.recommendationScore;
      const bv = b?.recommendationScore;
      if (av == null && bv == null) return 0;
      if (av == null) return 1;
      if (bv == null) return -1;
      return bv - av;
    });
  }

  return [...data].sort((a, b) => {
    if (sortColumn === "recommendationScore") {
      const aNew = a?.isNewInterpreter ? 1 : 0;
      const bNew = b?.isNewInterpreter ? 1 : 0;
      if (aNew !== bNew) return aNew - bNew;
      const av = a?.recommendationScore;
      const bv = b?.recommendationScore;
      if (av == null && bv == null) return 0;
      if (av == null) return 1;
      if (bv == null) return -1;
      return sortDirection === "asc" ? av - bv : bv - av;
    }

    let aValue = a[sortColumn];
    let bValue = b[sortColumn];

    // Handle profitMargin specially
    if (sortColumn === "profitMargin") {
      const getMargin = (rate: any, customerRate: any) => {
        const r = Number(rate);
        const cr = Number(customerRate);
        return !isNaN(r) && !isNaN(cr) && cr !== 0
          ? ((cr - r) / cr) * 100
          : null;
      };
      aValue = getMargin(a.rate, a.customerRate);
      bValue = getMargin(b.rate, b.customerRate);
    }

    // Handle distance (e.g. "3.03 miles" or "N/A")
    if (sortColumn === "distance") {
      const parseDistance = (val: any) => {
        if (typeof val !== "string") return val;
        const num = parseFloat(val);
        return isNaN(num) ? Infinity : num; // put "N/A" at bottom
      };
      aValue = parseDistance(aValue);
      bValue = parseDistance(bValue);
    }

    // Handle travelTime (e.g. "13.1 min" or "N/A")
    if (sortColumn === "travelTime") {
      const parseTime = (val: any) => {
        if (typeof val !== "string") return val;
        const num = parseFloat(val);
        return isNaN(num) ? Infinity : num; // put "N/A" at bottom
      };
      aValue = parseTime(aValue);
      bValue = parseTime(bValue);
    }

    // Handle rate as numeric
    if (sortColumn === "rate") {
      const parseRate = (val: any) => {
        if (typeof val === "string") {
          const num = parseFloat(val.replace(/[^\d.]/g, ""));
          return isNaN(num) ? 0 : num;
        }
        return val;
      };
      aValue = parseRate(aValue);
      bValue = parseRate(bValue);
    }

    // Fallback for undefined/null
    if (aValue === undefined || aValue === null) return 1;
    if (bValue === undefined || bValue === null) return -1;

    // Compare
    if (typeof aValue === "string" && typeof bValue === "string") {
      return sortDirection === "asc"
        ? aValue.localeCompare(bValue)
        : bValue.localeCompare(aValue);
    }

    return sortDirection === "asc" ? aValue - bValue : bValue - aValue;
  });
};


 

  const fillVOSForm = async () => {
    try {
      const statusCode = appointmentDetails?.status
      const watermarkText =
        statusCode === 4 ? 'ABANDONED' : statusCode === 6 ? 'CANCELED' : ''

      await exportManualVosPdf({
        appointment: appointmentDetails as Record<string, unknown>,
        fileName: `VOS Form ${appointmentDetails.code}-${moment().format('MM/DD/YYYY')}.pdf`,
        watermarkText,
        customerDocuments,
        appBaseUrl: process.env.REACT_APP_APP_URL,
      })
    } catch (error) {
      console.error('Error generating VOS form:', error)
      toaster('error', 'Error generating VOS form. Please try again.')
    }
  }

  const fetchBillingSummary = async () => {
    if (!billingDetails && (appointmentDetails?.status == 5 || appointmentDetails?.status == 7 || (appointmentDetails?.status === 6 && (appointmentDetails?.payable || appointmentDetails?.billable)))) {
      setIsLoading(true)

      let billingRes = await axios.get(`${API_URL}/invoice/appointment-billing-summary/${id}`)
      setBillingDetails(billingRes?.data?.data)

      if (!activities || !activities?.histories || activities?.histories?.length === 0) {
        try {
          let activitiesRes = await axios.get(`${API_URL}/Appoinment/${id}/activities`)
          setActivities(activitiesRes.data)
          setIsActivitiesLoaded(true)
        } catch (err) {
          console.error('Error fetching activities in billing summary:', err)
        }
      }

      setIsLoading(false)
    }
  }

  const reloadBillingAndActivities = async () => {
    try {
      const billing = await axios.get(`${API_URL}/invoice/appointment-billing-summary/${id}`)
      setBillingDetails(billing?.data?.data)
      const activitiesRes = await axios.get(`${API_URL}/Appoinment/${id}/activities`)
      setActivities(activitiesRes.data)
    } catch (error) {
      console.error('Error reloading billing summary:', error)
    }
  }

  const openActivityParticipantModal = async (item: any) => {
    if (!item?.insertedBy) return

    setActivityParticipant(item)
    setShowActivityParticipantModal(true)
    setIsLoadingActivityParticipant(true)
    try {
      const response = await axios.get(`${API_URL}/accounts/GetAccountDetailByID/${item.insertedBy}`)
      setActivityParticipantDetails(response?.data?.data ?? response?.data ?? null)
    } catch (error) {
      console.error('Error fetching participant details:', error)
      setActivityParticipantDetails(null)
    } finally {
      setIsLoadingActivityParticipant(false)
    }
  }

  const closeActivityParticipantModal = () => {
    setShowActivityParticipantModal(false)
    setActivityParticipant(null)
    setActivityParticipantDetails(null)
  }

  const openRegenerateConfirm = (target: 'client' | 'interpreter') => {
    if (billingDetails?.isInvoiceCreated) {
      setDocumentExistsMessage(
        `The invoice has already been generated for this appointment. Please detach it from Invoice #: ${billingDetails?.invoiceNo ?? ''} to proceed.`
      )
      return
    }
    setRegenerateTarget(target)
    setShowRegenerateConfirm(true)
  }

  const handleRegenerateRates = async () => {
    if (!regenerateTarget) return
    const endpoint =
      regenerateTarget === 'client'
        ? `${API_URL}/invoice/appointment/${id}/regenerate-client-charges`
        : `${API_URL}/invoice/appointment/${id}/regenerate-interpreter-pay`
    try {
      setIsRegenerating(true)
      const res = await axios.put(endpoint)
      const data = res?.data

      if (data?.status === 'DOCUMENT_EXISTS') {
        setDocumentExistsMessage(data?.text)
        return
      }
      if (data?.status === 'NO_RATE') {
        toaster('error', data?.text ?? 'No matching rate was found in the profile.')
        return
      }

      toaster('success', data?.text ?? 'Rates regenerated successfully.')
      await reloadBillingAndActivities()
    } catch (error: any) {
      toaster('error', error?.response?.data?.text ?? 'Failed to regenerate rates.')
    } finally {
      setIsRegenerating(false)
      setShowRegenerateConfirm(false)
      setRegenerateTarget(null)
    }
  }

  // Lazy load activities and notes data (Tab 2)
  const fetchActivitiesData = async () => {
    if (isActivitiesLoaded && activities?.histories?.length) return
    try {
      setIsLoading(true)
      const [activitiesRes, notesRes] = await Promise.all([
        axios.get(`${API_URL}/Appoinment/${id}/activities`),
        axios.get(`${API_URL}/Appoinment/${id}/notes`)
      ])
      setActivities(activitiesRes.data)
      setNotes(notesRes.data)
      setIsActivitiesLoaded(true)
    } catch (error) {
      console.error(error)
    } finally {
      setIsLoading(false)
    }
  }

  // Lazy load documents data (Tab 4)
  const fetchDocumentsData = async () => {
    if (isDocumentsLoaded) return
    try {
      setIsLoading(true)
      await getDocuments()
      setIsDocumentsLoaded(true)
    } catch (error) {
      console.error(error)
    } finally {
      setIsLoading(false)
    }
  }

  /** Refetch check-in staff + audit fields from GET /Appoinment/{id} (includes CheckInStaff* from TblAppoinment). */
  const refreshAppointmentAuditFields = async () => {
    if (!id) return
    try {
      const res = await axios.get(`${API_URL}/Appoinment/${id}`)
      const data = res.data
      setAppointmentDetails((prev: any) => ({
        ...prev,
        checkedInAt: data.checkedInAt ?? data.CheckedInAt ?? prev?.checkedInAt,
        checkOutAt: data.checkOutAt ?? data.CheckOutAt ?? prev?.checkOutAt,
        checkInLat: data.checkInLat ?? data.CheckInLat ?? prev?.checkInLat,
        checkInLng: data.checkInLng ?? data.CheckInLng ?? prev?.checkInLng,
        checkOutLat: data.checkOutLat ?? data.CheckOutLat ?? prev?.checkOutLat,
        checkOutLng: data.checkOutLng ?? data.CheckOutLng ?? prev?.checkOutLng,
        checkInStaffName: data.checkInStaffName ?? data.CheckInStaffName,
        checkInStaffEmail: data.checkInStaffEmail ?? data.CheckInStaffEmail,
        checkInStaffNumber: data.checkInStaffNumber ?? data.CheckInStaffNumber,
        checkInStaffSignUrl: data.checkInStaffSignUrl ?? data.CheckInStaffSignUrl,
        timeZoneZone: data.timeZoneZone ?? data.TimeZoneZone ?? prev?.timeZoneZone,
        timeZoneName: data.timeZoneName ?? data.TimeZoneName ?? prev?.timeZoneName,
        fK_TimeZone: data.fK_TimeZone ?? data.FK_TimeZone ?? prev?.fK_TimeZone,
        status: data.status ?? prev?.status,
        statusName: data.statusName ?? prev?.statusName,
      }))
    } catch (e) {
      console.error(e)
    }
  }

  const loadExtensionRequests = async (appointmentId?: string | number) => {
    const key = appointmentId != null ? String(appointmentId) : ''
    if (!key) {
      setExtensionRequests([])
      extensionRequestsFetchRef.current = {appointmentId: null, inFlight: null}
      return
    }

    const existing = extensionRequestsFetchRef.current
    if (existing.inFlight && existing.appointmentId === key) {
      return existing.inFlight
    }

    const run = (async () => {
      try {
        setExtensionsLoading(true)
        const response = await axios.get(
          `${API_URL}/Appoinment/extension-requests/${appointmentId}`
        )
        setExtensionRequests(normalizeExtensionRequestsList(response.data))
      } catch (error) {
        console.error(error)
        setExtensionRequests([])
      } finally {
        setExtensionsLoading(false)
        if (extensionRequestsFetchRef.current.appointmentId === key) {
          extensionRequestsFetchRef.current.inFlight = null
        }
      }
    })()

    extensionRequestsFetchRef.current = {appointmentId: key, inFlight: run}
    return run
  }

  // Lazy load meeting summary data (Tab 5)
  const fetchMeetingSummaryData = async (appointmentDetailsData?: any) => {
    if (meetingSummaryFetchRef.current.loaded || meetingSummaryFetchRef.current.inFlight) {
      setIsMeetingSummaryPageLoading(meetingSummaryFetchRef.current.inFlight)
      return
    }
    const details = appointmentDetailsData || appointmentDetails
    if (
      details?.communicationTypeIdentification !== 'ON_SITE' &&
      details?.communicationTypeIdentification !== 'THIRD_PART_PLATFORM'
    ) {
      setIsMeetingSummaryPageLoading(false)
      return
    }

    setIsMeetingSummaryPageLoading(true)
    meetingSummaryFetchRef.current.inFlight = true
    try {
      setIsLoading(true)
      let response6 = await axios.get(`${API_URL}/Appoinment/osi-submission-appointment/${id}`)
      // Check if OSI data actually exists (has a code property)
      if (response6?.data && response6?.data?.code) {
        setMeetingSummary(response6.data)

        // Compute startDateTime and endDateTime for vos submission
        let startDateTime = response6?.data?.startDate
          ? moment(response6.data.startDate).format('YYYY-MM-DD HH:mm')
          : (details?.startTime ? moment(details.startTime).format('YYYY-MM-DD HH:mm') : '');
        let endDateTime = response6?.data?.endDate
          ? moment(response6.data.endDate).format('YYYY-MM-DD HH:mm')
          : (details?.endTime ? moment(details.endTime).format('YYYY-MM-DD HH:mm') : '');
        setInitialValuesOSI({
          code: response6.data.code ?? '',
          startDateTime,
          endDateTime,
          startTime: response6?.data?.startDate
            ? moment(response6.data.startDate).format('HH:mm')
            : details?.startTime
            ? moment(details.startTime).format('HH:mm')
            : '',
          endTime: response6?.data?.endDate
            ? moment(response6.data.endDate).format('HH:mm')
            : details?.endTime
            ? moment(details.endTime).format('HH:mm')
            : '',
          travelHours: response6.data.travalTimeH ?? 0,
          travelMinutes: response6.data.travalTimeM ?? 0,
          isRoundTrip: response6.data.isRoundTrip ?? false,
          milageOfDrive: response6.data.milage ?? '',
          ...resolveOsiBillingFlags(response6.data),
          addStaffMember: !!(response6.data.staffMemberEmail || response6.data.staffMemberName),
          staffMemberName: response6.data.staffMemberName ?? '',
          staffMemberEmail: response6.data.staffMemberEmail ?? '',
          breakTimeMinutes: (() => {
            const value = readOsiBreakTimeMinutes(response6.data as Record<string, unknown>)
            return value != null ? value : ''
          })(),
          vosSubmissionMode:
            response6.data?.vosSubmissionMode !== undefined && response6.data?.vosSubmissionMode !== null
              ? Number(response6.data.vosSubmissionMode)
              : undefined,
          ...resolveAppointmentChargeRateHours(interpreters),
        })
        setExpenseList(mapOsiExpensesFromApi(response6.data.osiExpensesList))
        // osi notes
        let osiNoteResponse = await axios.get(
          `${API_URL}/Appoinment/osi-submission-activities/${response6?.data?.code}`
        )
        setOSINotes(osiNoteResponse?.data?.notes)
      } else {
        // No OSI data exists - set initial values from appointment times for "Add" flow
        const shouldClearThirdPartyEndTime =
          details?.communicationTypeIdentification === 'THIRD_PART_PLATFORM'
        setInitialValuesOSI({
          code: '',
          startDateTime: details?.startTime ? moment(details.startTime).format('YYYY-MM-DD HH:mm') : '',
          endDateTime: details?.endTime ? moment(details.endTime).format('YYYY-MM-DD HH:mm') : '',
          startTime: details?.startTime ? moment(details.startTime).format('HH:mm') : '',
          endTime: shouldClearThirdPartyEndTime
            ? ''
            : details?.endTime
              ? moment(details.endTime).format('HH:mm')
              : '',
          travelHours: 0,
          travelMinutes: 0,
          isRoundTrip: false,
          milageOfDrive: '',
          isTimeChargeableForInterpreter: true,
          isTimeChargeableForClient: true,
          isMileagePayableForInterpreter: true,
          isMileageChargeableForClient: true,
          isTravelTimePayableForInterpreter: true,
          isTravelTimeChargeableForClient: true,
          addStaffMember: false,
          staffMemberName: '',
          staffMemberEmail: '',
          breakTimeMinutes: '',
          vosSubmissionMode: undefined,
          ...resolveAppointmentChargeRateHours(interpreters),
        })
      }
      meetingSummaryFetchRef.current.loaded = true
      setIsMeetingSummaryLoaded(true)
      await loadExtensionRequests(id)
      await refreshAppointmentAuditFields()
    } catch (error) {
      console.error(error)
    } finally {
      meetingSummaryFetchRef.current.inFlight = false
      setIsLoading(false)
      setIsMeetingSummaryPageLoading(false)
    }
  }
  // Set the active tab based on the current location
  useEffect(() => {
    const isTpp = appointmentDetails?.communicationTypeIdentification === 'THIRD_PART_PLATFORM'
    if (!id || !isTpp) {
      setRecallSession(null)
      return
    }
    let cancelled = false
    ;(async () => {
      const session = await fetchRecallSession(id)
      if (!cancelled) setRecallSession(session)
    })()
    return () => {
      cancelled = true
    }
  }, [id, appointmentDetails?.communicationTypeIdentification])

  useEffect(() => {
    if (
      !id ||
      currentUser?.result?.userType !== 'SYSTEM' ||
      !isAiAssignmentInScope(appointmentDetails?.fK_CommunicationType)
    )
      return

    let cancelled = false

    const fetchAiAssignmentSummary = async () => {
      try {
        const response = await axios.get<{result: AiAssignmentSummary | null}>(
          `${API_URL}/Appoinment/${id}/ai-assignment/summary`
        )
        if (!cancelled) setAiAssignmentSummary(response.data?.result ?? null)
      } catch (error) {
        console.error('Error fetching AI assignment summary:', error)
      }
    }

    fetchAiAssignmentSummary()

    return () => {
      cancelled = true
    }
  }, [
    id,
    currentUser?.result?.userType,
    appointmentDetails?.fK_CommunicationType,
    aiAssignmentSummaryRefreshKey,
  ])

  useEffect(() => {
    const params = new URLSearchParams(location.search)
    let tabNumber = params.get('tab') // Get the value of 'tab' from the query string

    if (currentUser?.result?.userType === 'SYSTEM') {
      switch (tabNumber) {
        case '1':
          tabNumber = '1'
          break
        case '2':
          tabNumber = '2'
          fetchActivitiesData()
          break
        case '3':
          if (appointmentDetails?.status !== 6 || (appointmentDetails?.payable || appointmentDetails?.billable)) {
            tabNumber = '3'
            fetchBillingSummary()
            fetchActivitiesData()
          } else {
            tabNumber = '1'
          }
          break
        case '4':
          tabNumber = '4'
          fetchDocumentsData()
          break
        case '5':
          if (isMeetingSummaryTabVisible(appointmentDetails)) {
            tabNumber = '5'
            fetchMeetingSummaryData()
          } else {
            tabNumber = '1'
          }
          break
        default:
          tabNumber = '1'
      }
    }

    if (currentUser?.result?.userType === 'CONSUMER') {
      switch (tabNumber) {
        case '2':
          tabNumber = '2'
          fetchActivitiesData()
          break
        case '3':
          if (currentUser?.result?.role === 'User') {
            tabNumber = '2'
            fetchActivitiesData()
          } else {
            tabNumber = '3'
            fetchBillingSummary()
            fetchActivitiesData()
          }
          break
        case '4':
          tabNumber = '4'
          fetchDocumentsData()
          break
        case '5':
          if (isMeetingSummaryTabVisible(appointmentDetails)) {
            tabNumber = '5'
            fetchMeetingSummaryData()
          } else {
            tabNumber = '2'
            fetchActivitiesData()
          }
          break
        default:
          tabNumber = '2'
          fetchActivitiesData()
      }
    }

    if (currentUser?.result?.userType === 'INTERPRETER') {
      switch (tabNumber) {
        case '2':
          tabNumber = '2'
          fetchActivitiesData()
          break
        case '3':
          tabNumber = '3'
          fetchBillingSummary()
          fetchActivitiesData()
          break
        case '4':
          tabNumber = '4'
          fetchDocumentsData()
          break
        case '5':
          if (isMeetingSummaryTabVisible(appointmentDetails)) {
            tabNumber = '5'
            fetchMeetingSummaryData()
          } else {
            tabNumber = '2'
            fetchActivitiesData()
          }
          break
        default:
          tabNumber = '2'
          fetchActivitiesData()
      }
    }

    if (tabNumber && currentUser?.result?.userType) {
      setActiveTab(parseInt(tabNumber))
    }
  }, [
    location.search,
    appointmentDetails?.status,
    appointmentDetails?.communicationTypeIdentification,
    appointmentDetails?.payable,
    appointmentDetails?.billable,
    currentUser?.result?.userType,
  ])

  const fetchAppoinmentDetails = async () => {
    try {
      setIsLoading(true)
      setBillingDetails(null);
      
      // Reset lazy loading flags when fetching new appointment
      setIsActivitiesLoaded(false)
      setIsDocumentsLoaded(false)
      setIsMeetingSummaryLoaded(false)
      setIsMeetingSummaryPageLoading(false)
      setExtensionRequests([])
      meetingSummaryFetchRef.current = {loaded: false, inFlight: false}
      extensionRequestsFetchRef.current = {appointmentId: null, inFlight: null}

      // Use optimized merged endpoint for SYSTEM users, fallback to original for others
      let appointmentDetailsRes: any
      if (currentUser?.result?.userType === 'SYSTEM') {
        // Single optimized call that returns both appointment details and interpreters
        const response = await axios.get(`${API_URL}/Appoinment/details-with-interpreters/${id}`)
        appointmentDetailsRes = response.data;
        fetchMeetingSummaryData(appointmentDetailsRes);
        setAppointmentDetails(appointmentDetailsRes)
        await refreshAppointmentAuditFields()
        
        setIpiRecommendationEnabled(appointmentDetailsRes?.ipiRecommendationEnabled ?? false)

        if (appointmentDetailsRes?.lattestFeature === "optimization_v2") {
          setInterpreters(appointmentDetailsRes.availableInterpreters || [])
          setNotMatchInterpreters(appointmentDetailsRes.notIncludedInterpreters || [])
          setUnavailableInterpreters(appointmentDetailsRes.unavailableInterpreters || [])
        } else {
          setInterpreters(appointmentDetailsRes.interpreters || [])
          // For non-optimization_v2, we still need to fetch not-match interpreters if status is not completed
          if (appointmentDetailsRes?.status !== 5) {
            const response4 = await axios.get(`${API_URL}/Appoinment/interpreters-not-match/${id}`)
            setNotMatchInterpreters(response4.data?.notIncludedInterpreters || [])
            setUnavailableInterpreters(response4.data?.unavailableInterpreters || [])
          }
        }
      } else {
        // Non-SYSTEM users use the original endpoint
        const response = await axios.get(`${API_URL}/Appoinment/${id}`)
        appointmentDetailsRes = response.data
        setAppointmentDetails(appointmentDetailsRes)
      }

      // Fetch customer documents (needed for VOS form download)
      const customerDocumentsResponse = await axios.get(
        `${API_URL}/documents/customer-document/${appointmentDetailsRes?.fK_Customer}`
      )
      if (customerDocumentsResponse.data?.data) {
        setCustomerDocuments(customerDocumentsResponse.data.data)
      }

      // Note: Activities, Notes, Documents, and Meeting Summary are now lazy-loaded on tab click
    } catch (error) {
      console.error(error)
    } finally {
      setIsLoading(false)
    }
  }
  useEffect(() => {
    if (id) {
      fetchAppoinmentDetails()
    }
  }, [id])

  // Separate useEffect for document pagination - only refetch documents when pagination changes
  useEffect(() => {
    if (id && isDocumentsLoaded) {
      getDocuments()
    }
  }, [currentPage, rowsPerPage])

  const fetchMissingDocuments = async (interpreter: any) => {
    try {
      setIsLoadingMissingDocs(true)
      setMissingDocsInterpreter(interpreter)
      setShowMissingDocsModal(true)
      const response = await axios.get(
        `${API_URL}/compliance/missing-documents/${interpreter.fK_Interpreter}/${appointmentDetails?.fK_Customer}?communicationType=${appointmentDetails?.fK_CommunicationType || ''}`
      )
      const docs = response.data?.data || []
      const sortedDocs = [...docs].sort((a: any, b: any) => {
        if (a.isMissing && !b.isMissing) return -1
        if (!a.isMissing && b.isMissing) return 1
        return 0
      })
      setMissingDocuments(sortedDocs)
    } catch (error) {
      console.error(error)
      toaster('error', 'Failed to fetch missing documents')
    } finally {
      setIsLoadingMissingDocs(false)
    }
  }

  const fetchAfterSubmitOSISubmmission = async (editPayload?: any) => {
    if (editPayload?.isEdit && editPayload?.values) {
      const v = editPayload.values
      const startDt = editPayload.startDateTime
        ? moment(editPayload.startDateTime).toISOString()
        : (v.startDateTime ? moment(v.startDateTime).toISOString() : meetingSummary?.startDate)
      const endDt = editPayload.endDateTime
        ? moment(editPayload.endDateTime).toISOString()
        : (v.endDateTime ? moment(v.endDateTime).toISOString() : meetingSummary?.endDate)
      const startDtFormatted = editPayload.startDateTime
        ? moment(editPayload.startDateTime).format('YYYY-MM-DD HH:mm')
        : (v.startDateTime || initialValuesOSI?.startDateTime)
      const endDtFormatted = editPayload.endDateTime
        ? moment(editPayload.endDateTime).format('YYYY-MM-DD HH:mm')
        : (v.endDateTime || initialValuesOSI?.endDateTime)

      const travelH = v.travelHours != null && v.travelHours !== '' ? Number(v.travelHours) : 0
      const travelM = v.travelMinutes != null && v.travelMinutes !== '' ? Number(v.travelMinutes) : 0
      const mileage = v.milageOfDrive != null && v.milageOfDrive !== '' ? Number(v.milageOfDrive) : 0
      const breakTime = v.breakTimeMinutes != null && v.breakTimeMinutes !== '' ? Number(v.breakTimeMinutes) : ''

      setMeetingSummary((prev: any) => ({
        ...prev,
        startDate: startDt,
        endDate: endDt,
        travalTimeH: travelH,
        travalTimeM: travelM,
        milage: mileage,
        isRoundTrip: !!v.isRoundTrip,
        breakTimeMinutes: breakTime,
        staffMemberName: v.staffMemberName ?? '',
        staffMemberEmail: v.staffMemberEmail ?? '',
        isTimeChargeableForInterpreter: v.isTimeChargeableForInterpreter,
        isTimeChargeableForClient: v.isTimeChargeableForClient,
        isMileagePayableForInterpreter: v.isMileagePayableForInterpreter,
        isMileageChargeableForClient: v.isMileageChargeableForClient,
        isTravelTimePayableForInterpreter: v.isTravelTimePayableForInterpreter,
        isTravelTimeChargeableForClient: v.isTravelTimeChargeableForClient,
        osiExpensesList: editPayload.expenses?.map((e: any) => ({
          code: e.code,
          description: e.description,
          amount: Number(e.amount) || 0,
          fileName: e.fileName || e.file || e.dataUrl,
          isExpensesPayableForInterpreter: e.isExpensesPayableForInterpreter ?? true,
          isExpensesChargeableForClient: e.isExpensesChargeableForClient ?? true,
        })) ?? prev?.osiExpensesList,
      }))

      setInitialValuesOSI((prev: any) => ({
        ...prev,
        startDateTime: startDtFormatted,
        endDateTime: endDtFormatted,
        startTime: v.startTime || prev.startTime,
        endTime: v.endTime || prev.endTime,
        travelHours: travelH,
        travelMinutes: travelM,
        milageOfDrive: v.milageOfDrive !== '' && v.milageOfDrive != null ? v.milageOfDrive : '',
        isRoundTrip: !!v.isRoundTrip,
        breakTimeMinutes: breakTime,
        staffMemberName: v.staffMemberName ?? '',
        staffMemberEmail: v.staffMemberEmail ?? '',
        addStaffMember: !!(v.staffMemberName || v.staffMemberEmail),
        isTimeChargeableForInterpreter: v.isTimeChargeableForInterpreter,
        isTimeChargeableForClient: v.isTimeChargeableForClient,
        isMileagePayableForInterpreter: v.isMileagePayableForInterpreter,
        isMileageChargeableForClient: v.isMileageChargeableForClient,
        isTravelTimePayableForInterpreter: v.isTravelTimePayableForInterpreter,
        isTravelTimeChargeableForClient: v.isTravelTimeChargeableForClient,
        interpreterRateHour: v.interpreterRateHour !== '' && v.interpreterRateHour != null ? v.interpreterRateHour : prev.interpreterRateHour,
        clientRateHour: v.clientRateHour !== '' && v.clientRateHour != null ? v.clientRateHour : prev.clientRateHour,
      }))

      if (editPayload.expenses) {
        setExpenseList(mapOsiExpensesFromApi(editPayload.expenses))
      }

      // Reset billing data and activities so they reload fresh data when navigating to billing
      setBillingDetails(null)
      setActivities([])
      setIsActivitiesLoaded(false)
      return
    }

    try {
      setIsLoading(true)
      let response = await axios.get(`${API_URL}/Appoinment/${id}`)
      const appointmentDetailsRes = response.data

      setAppointmentDetails(appointmentDetailsRes)
      
      // Refresh activities data
      let response3 = await axios.get(`${API_URL}/Appoinment/${id}/activities`)
      setActivities(response3.data)
      setIsActivitiesLoaded(true)
      
      let response6 = await axios.get(`${API_URL}/Appoinment/osi-submission-appointment/${id}`)
      setMeetingSummary(response6.data)
      let osiNoteResponse = await axios.get(
        `${API_URL}/Appoinment/osi-submission-activities/${response6?.data?.code}`
      )

      // Always use OSI data times when available, fall back to appointment times
      let startDateTime = response6?.data?.startDate
        ? moment(response6.data.startDate).format('YYYY-MM-DD HH:mm')
        : (appointmentDetailsRes?.startTime ? moment(appointmentDetailsRes.startTime).format('YYYY-MM-DD HH:mm') : '');
      let endDateTime = response6?.data?.endDate
        ? moment(response6.data.endDate).format('YYYY-MM-DD HH:mm')
        : (appointmentDetailsRes?.endTime ? moment(appointmentDetailsRes.endTime).format('YYYY-MM-DD HH:mm') : '');

      setInitialValuesOSI({
        code: response6.data.code ?? '',
        startDateTime,
        endDateTime,
        startTime: response6?.data?.startDate
          ? moment(response6.data.startDate).format('HH:mm')
          : appointmentDetailsRes?.startTime
          ? moment(appointmentDetailsRes.startTime).format('HH:mm')
          : '',
        endTime: response6?.data?.endDate
          ? moment(response6.data.endDate).format('HH:mm')
          : appointmentDetailsRes?.endTime
          ? moment(appointmentDetailsRes.endTime).format('HH:mm')
          : '',
        travelHours: response6.data.travalTimeH ?? 0,
        travelMinutes: response6.data.travalTimeM ?? 0,
        isRoundTrip: response6.data.isRoundTrip ?? false,
        milageOfDrive: response6.data.milage ?? '',
        ...resolveOsiBillingFlags(response6.data),
        addStaffMember: !!(response6.data.staffMemberEmail || response6.data.staffMemberName),
        staffMemberName: response6.data.staffMemberName ?? '',
        staffMemberEmail: response6.data.staffMemberEmail ?? '',
        breakTimeMinutes: (() => {
          const value = readOsiBreakTimeMinutes(response6.data as Record<string, unknown>)
          return value != null ? value : ''
        })(),
        vosSubmissionMode:
          response6.data?.vosSubmissionMode !== undefined && response6.data?.vosSubmissionMode !== null
            ? Number(response6.data.vosSubmissionMode)
            : undefined,
        ...resolveAppointmentChargeRateHours(interpreters),
      })
      setOSINotes(osiNoteResponse?.data?.notes)
      setExpenseList(mapOsiExpensesFromApi(response6.data?.osiExpensesList))
      setIsMeetingSummaryLoaded(true)
      void loadExtensionRequests(id)
      
      // Reset billing data to force refetch
      setBillingDetails(null)
    } catch (error) {
      console.error(error)
    } finally {
      setIsLoading(false)
    }
  }
  const fetchNotes = async () => {
    try {
      setIsLoading(true)

      let response5 = await axios.get(`${API_URL}/Appoinment/${id}/notes`)
      setNotes(response5.data)
    } catch (error) {
      console.error(error)
    } finally {
      setIsLoading(false)
    }
  }
  
  function countInterpretersByStatus(assignStatus: number): number {
  if (!interpreters || !Array.isArray(interpreters)) {
    return 0
  }
  return interpreters.filter(
    (interpreter: any) => interpreter?.assignStatus === assignStatus
  ).length
}

function countNoMatchInterpretersByStatus(assignStatus: number): number {
  if (!notMatchInterpreters || !Array.isArray(notMatchInterpreters)) {
    return 0
  }
  return notMatchInterpreters.filter(
    (interpreter: any) => interpreter?.assignStatus === assignStatus
  ).length
}

  const buildRecommendationSnapshotPayload = (interpreterId: string) => {
    if (!ipiRecommendationEnabled) return {}
    const recommended = (interpreters || [])
      .filter((i: any) => i?.isTopMatch && !i?.isNewInterpreter && i?.assignStatus !== 3)
      .slice()
      .sort(
        (a: any, b: any) =>
          Number(b?.recommendationScore ?? 0) - Number(a?.recommendationScore ?? 0)
      )
      .slice(0, 3)
    if (recommended.length === 0) return {}
    const assignedItem = (interpreters || []).find((i: any) => i?.fK_Interpreter === interpreterId)
    return {
      recommendedUser1Id: recommended[0]?.fK_Interpreter,
      recommendedUser1Email: recommended[0]?.email,
      recommendedUser1Score: recommended[0]?.recommendationScore ?? undefined,
      recommendedUser2Id: recommended[1]?.fK_Interpreter,
      recommendedUser2Email: recommended[1]?.email,
      recommendedUser2Score: recommended[1]?.recommendationScore ?? undefined,
      recommendedUser3Id: recommended[2]?.fK_Interpreter,
      recommendedUser3Email: recommended[2]?.email,
      recommendedUser3Score: recommended[2]?.recommendationScore ?? undefined,
      assignedInterpreterScore: assignedItem?.recommendationScore ?? undefined,
      assignedInterpreterEmail: assignedItem?.email,
    }
  }

  const handleAssign = async (
    status: number,
    id: number,
    userID: any,
    interperterRate: any,
    assignAll: boolean = false,
    customerRate?: number,
    customerRateId?: number,
    interpreterRateId?: number,
    nonRecommendedReasonId?: number,
    nonRecommendedReason?: string,
    nonRecommendedReasonDetail?: string,
    selectedAppointmentIds?: number[]
  ) => {
    try {
      setIsAssignUnassignInProgress(true)
      const payload: any = {
        status: status,
        appointmentId: id,
        userId: userID,
        interpreterUpdatedRate: updatedRate,
        interpreterRate: interperterRate,
        isAssignAll: assignAll,
      }

      if (selectedAppointmentIds && selectedAppointmentIds.length > 0) {
        payload.selectedAppointmentIds = selectedAppointmentIds
        payload.isAssignAll = false
      }

      if (customerRate !== undefined && customerRate !== null) {
        payload.CLientRate = customerRate
      }

      if (customerRateId !== undefined && customerRateId !== null) {
        payload.FK_CustomerRateId = customerRateId
      }
      if (interpreterRateId !== undefined && interpreterRateId !== null) {
        payload.FK_InterpreterRateId = interpreterRateId
      }
      if (nonRecommendedReasonId !== undefined && nonRecommendedReasonId !== null) {
        payload.FK_NonRecommendedAssignmentReason = nonRecommendedReasonId
      }
      if (nonRecommendedReason) {
        payload.nonRecommendedAssignmentReason = nonRecommendedReason
      }
      if (nonRecommendedReasonDetail) {
        payload.nonRecommendedAssignmentReasonDetail = nonRecommendedReasonDetail
      }
      Object.assign(payload, buildRecommendationSnapshotPayload(userID))

      const response = await axios.put(`${API_URL}/Appoinment/interpreter-status`, payload)

      if (response.data.status === 'S') {
        toaster('success', 'Successfuly updated')
        setNonRecommendedAssignReason(null)
        setShowRecurringAssignModal(false)
        setShowRecurringSeriesSelectionModal(false)
        setPendingAssignDetails(null)
        setForcefullyAssignInterpretersConfirmDetails(null)
        await fetchAppoinmentDetails()
      }
      if (response.data.status === 'E') {
        toaster('error', response.data.text)
      }
    } catch (error) {
      console.error(error)
      toaster('error', 'Assignment failed. Please try again.')
    } finally {
      setIsAssignUnassignInProgress(false)
      setRecurringModalLoadingAction(null)
    }
  }

  const patchInterpreterAvailability = (
    interpreterId: string,
    assignStatus: number,
    assignStatusName?: string
  ) => {
    const nextStatusName = assignStatusName ?? getAssignStatusName(assignStatus)

    const patchList = (items: any[]) =>
      items?.map((item) =>
        item?.fK_Interpreter === interpreterId
          ? {...item, assignStatus, assignStatusName: nextStatusName}
          : item
      ) ?? []

    setInterpreters((prev: any[]) => patchList(prev))
  }

  const handleConfirmMarkUnavailable = async () => {
    if (!markUnavailableTarget?.fK_Interpreter || !id) {
      return
    }

    const interpreterId = markUnavailableTarget.fK_Interpreter

    try {
      const response = await axios.post(
        `${API_URL}/Appoinment/${id}/interpreters/${interpreterId}/mark-unavailable`
      )

      if (isApiSuccess(response)) {
        patchInterpreterAvailability(interpreterId, 11, 'ManuallyUnavailable')
        toaster('success', response.data?.text ?? 'Interpreter marked unavailable.')
        setMarkUnavailableTarget(null)
        await fetchAppoinmentDetails()
        return
      }

      toaster('error', response.data?.text ?? 'Failed to mark interpreter unavailable.')
    } catch (error) {
      console.error(error)
      toaster('error', 'Failed to mark interpreter unavailable.')
    }
  }

  const handleRevertUnavailable = async (item: any) => {
    if (!item?.fK_Interpreter || !id) {
      return
    }

    try {
      setIsRevertUnavailableInProgress(true)
      const response = await axios.post(
        `${API_URL}/Appoinment/${id}/interpreters/${item.fK_Interpreter}/revert-unavailable`
      )

      if (isApiSuccess(response)) {
        patchInterpreterAvailability(item.fK_Interpreter, 0, 'Invited')
        toaster('success', response.data?.text ?? 'Interpreter reverted to invited.')
        await fetchAppoinmentDetails()
        return
      }

      toaster('error', response.data?.text ?? 'Failed to revert interpreter status.')
    } catch (error) {
      console.error(error)
      toaster('error', 'Failed to revert interpreter status.')
    } finally {
      setIsRevertUnavailableInProgress(false)
    }
  }

  const handleInviteInterpreter = async (id: number) => {
    try {
      let response = await axios.post(`${API_URL}/Appoinment/interpreters-invite/${id}`)
      if (response.data.status === 'S') {
        toaster('success', 'Successfuly updated')
        fetchAppoinmentDetails()
      }
    } catch (error) {
      console.error(error)
    }
  }

  const createInvoiceCancellationNote = async (payload: any) => {
    try {
      // First, fetch the OSI submission for this appointment
      let osiSubmissionResponse = await axios.get(`${API_URL}/Appoinment/osi-submission-appointment/${id}`)
      
      if (!osiSubmissionResponse?.data?.code) {
        console.error('OSI submission not found for appointment, cannot create note')
        return
      }

      const osiSubmissionCode = osiSubmissionResponse.data.code

      // Build the note content in the requested format
      let noteContent = `Appointment Cancellation as "Invoice Applicable", Pay to terp: "${payload.payable ? 'Yes' : 'No'}"`
      if (payload.payable && payload.payableHours) {
        noteContent += `, Payable hours: "${payload.payableHours}"`
      }
      noteContent += `, Bill to client: "${payload.billable ? 'Yes' : 'No'}", Description: "${payload.cancellationDetails || 'No description provided'}"`

      // Create the note in OSI submission notes
      const result: any = await axios.post(`${API_URL}/Appoinment/osi-submission-notes`, {
        code: osiSubmissionCode, // Use the fetched OSI submission code
        note: noteContent,
      })

      if (result?.data?.status === 'S') {
        console.log('Invoice cancellation note created successfully in OSI submission')
        // Update the meetingSummary state with the fetched data
        setMeetingSummary(osiSubmissionResponse.data)
        // Refresh OSI notes to show the new note
        let osiNoteResponse = await axios.get(
          `${API_URL}/Appoinment/osi-submission-activities/${osiSubmissionCode}`
        )
        setOSINotes(osiNoteResponse?.data?.notes)
      } else {
        console.error('Failed to create invoice cancellation note:', result?.data?.text)
      }
    } catch (error) {
      console.error('Error creating invoice cancellation note:', error)
    }
  }

  const handleAppoinmentCancelation = async (payload?: any): Promise<boolean> => {
    try {
      let response
      const cancelPayload: Record<string, unknown> = {
        isBulk: isBulkCancalation,
        appointment: id,
        cancelationDiscription: payload?.cancellationDetails || '',
        fK_CancellationReason: payload?.fK_CancellationReason,
      }

      if (isBulkCancalation && selectedAppointmentIdsForCancel.length > 0) {
        cancelPayload.selectedAppointmentIds = selectedAppointmentIdsForCancel
      }

      if (payload?.noLinguist) {
        response = await axios.delete(`${API_URL}/Appoinment`, {
          data: {
            ...cancelPayload,
            noLinguist: true,
          },
        })
      } else if (payload?.payable !== undefined || payload?.billable !== undefined) {
        if (isBulkCancalation && selectedAppointmentIdsForCancel.length > 1) {
          toaster('error', 'Invoice applicable cancellation can only be applied to one appointment at a time.')
          return false
        }
        response = await axios.post(`${API_URL}/Appoinment/cancel-invoice-applicable`, {
          isBulk: isBulkCancalation,
          appointment: isBulkCancalation ? selectedAppointmentIdsForCancel[0] : id,
          payable: payload.payable,
          billable: payload.billable,
          payableHours: payload.payableHours,
          payableFull: payload.payableFull,
          cancelationDiscription: payload.cancellationDetails,
          fK_CancellationReason: payload.fK_CancellationReason,
        })
      } else {
        response = await axios.delete(`${API_URL}/Appoinment`, {
          data: cancelPayload,
        })
      }

      if (response.data.status === 'S') {
        setIsOpenCancelConfirmationModal(false)
        setSelectedAppointmentIdsForCancel([])

        if (payload?.payable !== undefined || payload?.billable !== undefined) {
          setTimeout(async () => {
            await createInvoiceCancellationNote(payload)
          }, 1000)
        }

        if (currentUser?.result?.userType === 'CONSUMER') {
          setCancelledAppointmentSnapshot({...appointmentDetails})
          setShowConsumerCancelSuccessModal(true)
        } else {
          toaster('success', 'Successfully cancelled')
        }

        fetchAppoinmentDetails()
        return true
      }

      toaster('error', response.data?.text || 'Fail Cancellation')
      return false
    } catch (error: any) {
      console.error(error)
      toaster('error', error?.response?.data?.text || 'Fail Cancellation')
      return false
    }
  }

  const handleCheckInterpreterForSelectedAppointments = async (appointmentIds: number[]) => {
    try {
      const results = await Promise.all(
        appointmentIds.map((appointmentId) =>
          axios
            .get(`${API_URL}/Appoinment/check-interpreter-available/${appointmentId}/false`)
            .then((response) => response.data)
        )
      )
      return results.some(Boolean)
    } catch (error) {
      console.error(error)
      return false
    }
  }

  const handleCancelSeriesSelectionConfirm = async (selectedIds: number[]) => {
    setSelectedAppointmentIdsForCancel(selectedIds)
    setIsBulkCancalation(true)
    setIsOpenCancelSeriesSelectionModal(false)

    const isInterpreterAvailable = await handleCheckInterpreterForSelectedAppointments(selectedIds)
    setMessage(
      isInterpreterAvailable
        ? 'It looks like the interpreter you are about to remove is already assigned to one or more selected appointments. Are you sure you want to proceed? Removing the interpreter will require you to cancel the job assignment series?'
        : 'Are you sure you want to cancel the selected appointments in this series?'
    )
    setIsOpenCancelConfirmationModal(true)
  }

  const handleCheckInterpreterAvalability: any = async (id: number, isBulk: boolean) => {
    try {
      let {data} = await axios.get(
        `${API_URL}/Appoinment/check-interpreter-available/${id}/${isBulk}`
      )
      return data
    } catch (error) {
      console.error(error)
    }
  }

  const handleCancelOccurrenceClick = async () => {
    if (currentUser?.result?.userType === 'CONSUMER') {
      if (!isClientCancellationEligible(appointmentDetails)) {
        setShowConsumerCancelModal(true)
        return
      }
      setIsBulkCancalation(false)
      setIsOpenCancelConfirmationModal(true)
      return
    }
    const isInterpreterAvalability: any = await handleCheckInterpreterAvalability(
      appointmentDetails?.code,
      false
    )
    setMessage(
      isInterpreterAvalability
        ? 'It looks like the interpreter you are about to remove is already assigned to this appointment. Are you sure you want to proceed? Removing the interpreter will require you to cancel the job assignment?'
        : 'Are you sure want to cancel this appoinment?'
    )
    setIsBulkCancalation(false)
    setIsOpenCancelConfirmationModal(true)
  }

  const handleCancelSeriesClick = async () => {
    if (currentUser?.result?.userType === 'CONSUMER') {
      setShowConsumerCancelModal(true)
      return
    }
    setIsOpenCancelSeriesSelectionModal(true)
  }

  const handleOpenAddNoteModal = () => {
    const noteModal = document.getElementById('kt_modal_2')
    if (noteModal) {
      Modal.getOrCreateInstance(noteModal).show()
    }
  }

  const onSelectFile = (e: any, setFieldValue: any) => {
    if (!e.target.files || e.target.files.length === 0) {
      setFieldValue('file', '')
      return
    }
    const file = e.target.files[0]
    if (file.type != 'application/pdf' && file.type != 'image/png' && file.type != 'image/jpeg') {
      setFieldValue('file', '')
      toaster('error', 'Please upload pdf , jpeg or png file')
      return
    }
    setFieldValue('file', e.currentTarget.files[0])
  }

  const getDocuments = async () => {
    try {
      let response = await axios.get(`${API_URL}/Appoinment/${id}/documents`, {
        params: {
          page: currentPage,
          items_per_page: rowsPerPage,
        },
      })

      const {data, payload} = response.data
      setDocuments(data)
      setTotalPages(payload.pagination.last_page)
      setTotalItems(payload.pagination.total)
    } catch (error) {
      console.error(error)
    }
  }

  const AppointmentStatus = (status: string) => {
    let label, color

    switch (status) {
      case 'Open':
        label = 'Open'
        color = 'rgba(215, 56, 60, 1)'
        break
      case 'ReadyToAssign':
        if (currentUser?.result?.userType === 'INTERPRETER') {
          label = 'Accepted'
        } else {
          label = 'Ready To Assign'
        }
        color = 'rgba(163, 162, 66, 1)'

        break
      case 'Confirmed':
        label = 'Confirmed'
        color = 'rgba(96, 187, 26, 1)'
        break
      case 'NoInterpreter':
        label = 'No Interpreter'
        color = 'rgba(255, 199, 0, 1)'
        break
      case 'Abandoned':
        label = 'Abandoned'
        color = 'rgba(227, 117, 155, 1)'
        break
      case 'Completed':
        label = 'Completed'
        color = 'rgba(24, 28, 50, 1)'
        break
      case 'Submitted':
        label = 'Submitted'
        color = 'rgba(24, 28, 50, 1)'
        break
      case 'InProgress':
        label = 'In Progress'
        color = 'rgba(74, 198, 215, 1)'
        break
      case 'CheckedIn':
        label = 'Checked In'
        color = 'rgba(74, 198, 215, 1)'
        break
      case 'CheckedOut':
        label = 'Checked Out'
        color = 'rgba(74, 198, 215, 1)'
        break
      case 'Canceled':
        label = 'Canceled'
        color = 'rgba(228, 230, 239, 1)'
        break
      default:
        label = 'Unknown'
        color = 'rgba(128, 128, 128, 1)'
    }
    return {label, color}
  }

  const handleChangeStatus = async (status: number) => {
    try {
      let response = await axios.put(`${API_URL}/Appoinment/osi-submission-admin-response`, {
        code: meetingSummary?.code,
        status: status,
      })
      if (response.data.status === 'S') {
        toaster('success', response.data.text ?? 'Successfuly updated')
        fetchAfterSubmitOSISubmmission()
      } else {
        toaster('error', response.data.text ?? 'Fail Actions')
      }
    } catch (error) {
      console.error(error)
    }
  }

  const handleRevertApproval = async () => {
    setIsRevertingApproval(true)
    try {
      let response = await axios.put(`${API_URL}/Appoinment/osi-submission-revert-approval`, {
        code: meetingSummary?.code,
      })
      if (response.data.status === 'S') {
        toaster('success', response.data.text ?? 'Approval reverted successfully')
        fetchAfterSubmitOSISubmmission()
      } else {
        toaster('error', response.data.text ?? 'Failed to revert approval')
      }
    } catch (error) {
      console.error(error)
    } finally {
      setIsRevertingApproval(false)
    }
  }

  const handleVosAcceptDispute = async () => {
    if (!meetingSummary?.code) return
    setIsVosDisputeActionLoading(true)
    try {
      const response = await axios.put(
        `${API_URL}/Appoinment/vos-accept-change/${meetingSummary.code}`
      )
      if (response.data.status === 'S') {
        toaster('success', response.data.text ?? 'Requester VOS changes accepted.')
        await fetchAfterSubmitOSISubmmission()
      } else {
        toaster('error', response.data.text ?? 'Unable to accept requester changes.')
      }
    } catch (error) {
      console.error(error)
      toaster('error', 'Unable to accept requester changes.')
    } finally {
      setIsVosDisputeActionLoading(false)
    }
  }

  const handleVosRejectDispute = async () => {
    if (!meetingSummary?.code) return
    setIsVosDisputeActionLoading(true)
    try {
      const response = await axios.put(
        `${API_URL}/Appoinment/vos-reject-change/${meetingSummary.code}`
      )
      if (response.data.status === 'S') {
        toaster('success', response.data.text ?? 'Requester VOS changes rejected.')
        await fetchAfterSubmitOSISubmmission()
      } else {
        toaster('error', response.data.text ?? 'Unable to reject requester changes.')
      }
    } catch (error) {
      console.error(error)
      toaster('error', 'Unable to reject requester changes.')
    } finally {
      setIsVosDisputeActionLoading(false)
    }
  }

  const handleAcceptReject = async (status: number, id: number, userID: string) => {
    setIsLoadingAccept(true)
    try {
      const payload = {
            status: status,             // integer or enum
            appointmentId: id,          // appointment code
            userId: userID,             // interpreter's userId
            interpreterUpdatedRate: 0,  // replacing the 0 in URL
            interpreterRate: 0,         // replacing the 0 in URL
            isAssignAll: false          // default value
          };

      const response = await axios.put(
      `${API_URL}/Appoinment/interpreter-status`,
        payload
      );
      if (response.data.status === 'S') {
        toaster('success', 'Successfuly updated')
        if (status === 1) {
          fetchAppoinmentDetails()
        } else {
          navigate(-1)
        }
      }
    } catch (error) {
      console.error(error)
    } finally {
      setIsLoadingAccept(false)
    }
  }

  const downloadFile = async (url: string, filename: string) => {
    try {
      const response = await fetch(url)
      const blob = await response.blob()
      const downloadUrl = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = downloadUrl
      link.download = filename
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(downloadUrl)
    } catch (error) {
      console.error('Error downloading file:', error)
      toaster('error', 'Error downloading file')
    }
  }

  const handleConfirmUnassign = async (
    UnAssignAllOccurence: boolean,
    selectedAppointmentIds?: number[]
  ) => {
    try {
      if (!pendingUnassignValues) return
      if (!selectedAppointmentIds?.length) {
        setRecurringModalLoadingAction(UnAssignAllOccurence ? 'all' : 'only')
      }
      setIsAssignUnassignInProgress(true)
      const payload: any = {...pendingUnassignValues, UnAssignAllOccurence: false}
      if (selectedAppointmentIds && selectedAppointmentIds.length > 0) {
        payload.selectedAppointmentIds = selectedAppointmentIds
      } else {
        payload.UnAssignAllOccurence = UnAssignAllOccurence
      }
      const result: any = await axios.post(
        `${API_URL}/Appoinment/interpreters-unassign`,
        payload
      )
      if (result?.data?.status == 'S') {
        toaster('success', result?.data?.text ?? 'Successfully unassigned')
        setShowRecurringUnassignModal(false)
        setShowRecurringSeriesSelectionModal(false)
        setPendingUnassignValues(null)
        await fetchAppoinmentDetails()
      } else {
        toaster('error', result?.data?.text ?? 'Interperter unassign failed')
      }
    } catch (ex) {
      console.error(ex)
      toaster('error', 'Unassignment failed. Please try again.')
    } finally {
      setIsAssignUnassignInProgress(false)
      setRecurringModalLoadingAction(null)
    }
  }

  // State for RecurringAppointmentAssignModal
  const [showRecurringAssignModal, setShowRecurringAssignModal] = useState(false);
  const [pendingAssignDetails, setPendingAssignDetails] = useState<any>(null);
  const [showSuboptimalAssignmentModal, setShowSuboptimalAssignmentModal] = useState(false)
  const [suboptimalSelectedInterpreter, setSuboptimalSelectedInterpreter] = useState<any>(null)
  const [nonRecommendedAssignReason, setNonRecommendedAssignReason] = useState<{
    reasonId: number
    reason: string
    reasonDetail?: string
  } | null>(null)

  // State for RecurringAppointmentUnassignModal
  const [showRecurringUnassignModal, setShowRecurringUnassignModal] = useState(false)
  const [pendingUnassignValues, setPendingUnassignValues] = useState<any>(null)

  const [showRecurringSeriesSelectionModal, setShowRecurringSeriesSelectionModal] = useState(false)
  const [recurringSeriesSelectionMode, setRecurringSeriesSelectionMode] =
    useState<RecurringSeriesSelectionMode>('assign')

  // Handler for assignment (called on Assign button click)
  const handleAssignClick = (
    statusId: any,
    appointmentId: any,
    interpreterId: any,
    rate: any,
    customerRate?: number,
    customerRateId?: number,
    interpreterRateId?: number,
    nonRecommendedReasonId?: number,
    nonRecommendedReason?: string,
    nonRecommendedReasonDetail?: string
  ) => {
    if (appointmentDetails?.isRecurring) {
      setPendingAssignDetails({
        statusId,
        appointmentId,
        interpreterId,
        rate,
        customerRate,
        customerRateId,
        interpreterRateId,
        nonRecommendedReasonId,
        nonRecommendedReason,
        nonRecommendedReasonDetail,
      })
      setShowRecurringAssignModal(true)
    } else {
      handleAssign(
        statusId,
        appointmentId,
        interpreterId,
        rate,
        false,
        customerRate,
        customerRateId,
        interpreterRateId,
        nonRecommendedReasonId,
        nonRecommendedReason,
        nonRecommendedReasonDetail
      )
    }
  }

  const getRecommendedInterpreters = () =>
    (interpreters || []).filter(
      (i: any) => i?.isTopMatch && !i?.isNewInterpreter && i?.assignStatus !== 3
    )

  const getBestMatchInterpreters = () =>
    getRecommendedInterpreters()
      .slice()
      .sort(
        (a: any, b: any) =>
          Number(b?.recommendationScore ?? 0) - Number(a?.recommendationScore ?? 0)
      )
      .slice(0, 3)

  const showForceAssignModal = () => {
    const modalEl = document.getElementById('forcefully_assign_interpreters_confirm')
    if (modalEl) {
      Modal.getOrCreateInstance(modalEl).show()
    }
  }

  const buildForceAssignDetails = (item: any) => ({
    statusId: 3,
    appointmentId: item.code,
    interpreterId: item?.fK_Interpreter,
    currentStatus: item?.assignStatus,
    rate: String(item?.rate ?? 0),
    name: item?.name,
    customer: item?.customer,
    customerRate: item?.customerRate ?? 0,
    appointmentCharges: item?.appointmentCharges,
    customerRateId: appointmentDetails?.customerRateId,
    interpreterRateId: item?.interpreterRateId,
  })

  const parseInterpreterRate = (rate: any) =>
    rate?.match(/\d+/)?.[0] ? parseFloat(rate.match(/\d+/)[0]) : 0

  const handleAssignButtonClick = (item: any) => {
    setForcefullyAssignInterpretersConfirmDetails(buildForceAssignDetails(item))
    setUpdatedRate(parseInterpreterRate(item?.rate))

    const recommended = getRecommendedInterpreters()
    const needsSuboptimalModal =
      ipiRecommendationEnabled &&
      recommended.length > 0 &&
      !item?.isTopMatch

    if (needsSuboptimalModal) {
      setSuboptimalSelectedInterpreter(item)
      setShowSuboptimalAssignmentModal(true)
    } else {
      showForceAssignModal()
    }
  }

  const handleRecommendedAssignFromSuboptimal = (item: any) => {
    setShowSuboptimalAssignmentModal(false)
    setSuboptimalSelectedInterpreter(null)
    setNonRecommendedAssignReason(null)
    handleAssignClick(
      3,
      item.code,
      item?.fK_Interpreter,
      parseInterpreterRate(item?.rate),
      item?.customerRate ?? undefined,
      appointmentDetails?.customerRateId,
      item?.interpreterRateId
    )
  }

  const handleConfirmOriginallySelected = (
    reasonCode: number,
    reason: string,
    reasonDetail?: string
  ) => {
    setShowSuboptimalAssignmentModal(false)
    setSuboptimalSelectedInterpreter(null)
    setNonRecommendedAssignReason({reasonId: reasonCode, reason, reasonDetail})
    showForceAssignModal()
  }

  const handleCloseSuboptimalModal = () => {
    setShowSuboptimalAssignmentModal(false)
    setSuboptimalSelectedInterpreter(null)
    setForcefullyAssignInterpretersConfirmDetails(null)
    setNonRecommendedAssignReason(null)
  }

  // Handler for Recurring modal action
  const handleRecurringAssign = async (assignAll: boolean) => {
    if (pendingAssignDetails) {
      setRecurringModalLoadingAction(assignAll ? 'all' : 'only')
      await handleAssign(
        pendingAssignDetails.statusId,
        pendingAssignDetails.appointmentId,
        pendingAssignDetails.interpreterId,
        pendingAssignDetails.rate,
        assignAll,
        pendingAssignDetails.customerRate,
        pendingAssignDetails.customerRateId,
        pendingAssignDetails.interpreterRateId,
        pendingAssignDetails.nonRecommendedReasonId,
        pendingAssignDetails.nonRecommendedReason,
        pendingAssignDetails.nonRecommendedReasonDetail
      )
    }
  }

  const openRecurringSeriesSelection = (mode: RecurringSeriesSelectionMode) => {
    setRecurringSeriesSelectionMode(mode)
    if (mode === 'assign') {
      setShowRecurringAssignModal(false)
    } else {
      setShowRecurringUnassignModal(false)
    }
    setShowRecurringSeriesSelectionModal(true)
  }

  const handleRecurringSeriesSelectionConfirm = async (selectedIds: number[]) => {
    if (recurringSeriesSelectionMode === 'assign' && pendingAssignDetails) {
      await handleAssign(
        pendingAssignDetails.statusId,
        pendingAssignDetails.appointmentId,
        pendingAssignDetails.interpreterId,
        pendingAssignDetails.rate,
        false,
        pendingAssignDetails.customerRate,
        pendingAssignDetails.customerRateId,
        pendingAssignDetails.interpreterRateId,
        pendingAssignDetails.nonRecommendedReasonId,
        pendingAssignDetails.nonRecommendedReason,
        pendingAssignDetails.nonRecommendedReasonDetail,
        selectedIds
      )
      return
    }

    if (recurringSeriesSelectionMode === 'unassign') {
      await handleConfirmUnassign(false, selectedIds)
    }
  }

  const showEditActions =
    ((currentUser?.result?.userType === 'CONSUMER' &&
      (appointmentDetails?.status === 0 ||
        appointmentDetails?.status === 4 ||
        appointmentDetails?.status === 8)) ||
      (currentUser?.result?.userType !== 'INTERPRETER' &&
        currentUser?.result?.userType !== 'CONSUMER')) &&
    appointmentDetails?.statusName !== 'Completed'

  const showCancelActions =
    currentUser?.result.userType !== 'INTERPRETER' &&
    appointmentDetails?.status !== 5 &&
    appointmentDetails?.status !== 4 &&
    appointmentDetails?.status !== 6

  const showAddNoteAction = currentUser?.result.userType !== 'INTERPRETER'

  const canViewProfileNotes =
    currentUser?.result?.userType === 'SYSTEM' &&
    !isAppointmentCancelled(appointmentDetails?.status)

  const showViewClientNotesAction = canViewProfileNotes
  const showViewInterpreterNotes = canViewProfileNotes

  const confirmedInterpreter = interpreters?.find((item: any) => item?.assignStatus === 3)

  const showRebroadcastAction =
    currentUser?.result?.userType === 'SYSTEM' &&
    appointmentDetails?.status !== 5 &&
    appointmentDetails?.status !== 6

  const showActionsMenu =
    showEditActions ||
    showCancelActions ||
    showAddNoteAction ||
    showViewClientNotesAction ||
    showRebroadcastAction

  const displayInterpreters =
    interpreters?.filter((item: any) => item?.assignStatus !== 3) ?? []

  return (
    <>
      <div className='modal fade' tabIndex={-1} id='kt_modal_2'>
        <div className='modal-dialog'>
          <Formik
            initialValues={initialValue}
            validationSchema={addnoteSchema}
            onSubmit={async (values, {setSubmitting, resetForm}) => {
              setSubmitting(true)
              try {
                const result: any = await axios.post(`${API_URL}/Appoinment/notes`, {
                  fK_Appoinment: id,
                  note: values?.note,
                  visibilityType: values?.chatwith,
                })
                if (result?.data?.status == 'S') {
                  setSubmitting(true)
                  toaster('success', result?.text ?? 'Successfully Inserted')
                  resetForm()
                  const modal = document.getElementById('kt_modal_2')
                  if (modal) {
                    const modalInstance = Modal.getInstance(modal)
                    if (modalInstance) modalInstance.hide()
                  }
                  const tab = new URLSearchParams(location.search).get('tab') || String(activeTab)
                  navigate(`/appointmentViewer/${id}?tab=${tab}`, {replace: true})
                  setActiveTab(parseInt(tab, 10))
                } else {
                  resetForm()
                }
              } catch (ex) {
                console.error(ex)
              } finally {
                fetchNotes()
                //setSubmitting(true)
                //cancel(true)
              }
            }}
          >
            {({
              handleChange,
              handleBlur,
              setFieldValue,
              errors,
              values,
              touched,
              isValid,
              dirty,
              isSubmitting,
              handleSubmit,
              resetForm,
              ...formik
            }) => (
              <Form>
                <div className='modal-content'>
                  <div className='modal-header py-2'>
                    <h4 className='modal-title'>Appointment Note</h4>
                    <div
                      className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                      data-bs-dismiss='modal'
                      aria-label='Close'
                      onClick={() => resetForm()}
                    >
                      <KTSVG
                        path='/media/icons/duotune/arrows/arr061.svg'
                        className='svg-icon svg-icon-2x'
                      />
                    </div>
                  </div>
                  <div className='modal-body'>
                    <div className='row g-4 g-xl-6'>
                      <div className='col-sm-12 col-md-12 col-lg-12'>
                        <div className='mb-3'>
                          <label
                            htmlFor='exampleFormControlInput1'
                            className='required form-label fs-7 mb-1  fs-7 mb-1'
                          >
                            Visible To
                          </label>
                          <Select
                            className='react-select-styled react-select-solid react-select-sm'
                            classNamePrefix='react-select'
                            options={chat}
                            // isMulti
                            placeholder='Select '
                            styles={{
                              control: (provided: any) => ({
                                ...provided,
                                width: '100%',
                                border: '1px solid #e4e6ef',
                              }),
                              placeholder: (provided: any) => ({
                                ...provided,
                                color: '#a4afc4',
                              }),
                            }}
                            onChange={(option: any) => setFieldValue('chatwith', option?.value)}
                            value={{
                              value: values.chatwith,
                              label:
                                chat?.find((c: any) => c.value === values.chatwith)?.label ||
                                'Select ',
                            }}
                            name='chatwith'
                            id='chatwith'
                          />
                          {errors.chatwith && (
                            <div className='fv-plugins-message-container'>
                              <div className='fv-help-block'>
                                <span role='alert'>{errors.chatwith}</span>
                              </div>
                            </div>
                          )}
                        </div>
                        <div className='mb-3'>
                          <label
                            htmlFor='exampleFormControlInput1'
                            className='required form-label fs-7 mb-1  fs-7 mb-1'
                          >
                            Write a Note
                          </label>
                          <textarea
                            placeholder='write Note..'
                            name='note'
                            id='note'
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.note}
                            className='form-control form-control-sm custom-input-height  custom-input-height  form-select-white mb-lg-0'
                          ></textarea>
                          {errors.note && (
                            <div className='fv-plugins-message-container'>
                              <div className='fv-help-block'>
                                <span role='alert'>{errors.note}</span>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='modal-footer py-3'>
                    <button
                      type='button'
                      className='btn btn-light btn-sm'
                      data-bs-dismiss='modal'
                      onClick={() => resetForm()}
                    >
                      Close
                    </button>
                    <button
                      type='submit'
                      className='btn btn-primary btn-sm'
                      disabled={isSubmitting || !isValid || !dirty}
                    >
                      Save Note
                    </button>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
      <div className='modal fade' tabIndex={-1} id='cancel-assign-interperter-modal'>
        <div className='modal-dialog modal-dialog-centered mw-650px'>
          <Formik
            key={unassignFormKey}
            enableReinitialize
            initialValues={initialValueUnassignConfirmedInterperter}
            validationSchema={unAssignConfirmedInterpreterSchema}
            onSubmit={async (values, {setSubmitting, resetForm}) => {
              setSubmitting(true)
              try {
                if (appointmentDetails?.isRecurring) {
                  setPendingUnassignValues(values)
                  setShowRecurringUnassignModal(true)
                  const modal = document.getElementById('cancel-assign-interperter-modal')
                  if (modal) {
                    const modalInstance = Modal.getInstance(modal)
                    if (modalInstance) modalInstance.hide()
                  }
                } else {
                  setIsAssignUnassignInProgress(true)
                  const result: any = await axios.post(
                    `${API_URL}/Appoinment/interpreters-unassign`,
                    values
                  )
                  if (result?.data?.status == 'S') {
                    toaster('success', result?.data?.text ?? 'Successfully unassigned')
                    resetForm()
                    const modal = document.getElementById('cancel-assign-interperter-modal')
                    if (modal) {
                      const modalInstance = Modal.getInstance(modal)
                      if (modalInstance) modalInstance.hide()
                    }
                    await fetchAppoinmentDetails()
                  } else {
                    toaster('error', result?.data?.text ?? 'Interperter unassign failed')
                  }
                }
              } catch (ex) {
                console.error(ex)
                toaster('error', 'Unassignment failed. Please try again.')
              } finally {
                setSubmitting(false)
                setIsAssignUnassignInProgress(false)
              }
            }}
          >
            {({
              handleChange,
              handleBlur,
              setFieldValue,
              errors,
              values,
              touched,
              isValid,
              dirty,
              isSubmitting,
              handleSubmit,
              resetForm,
              ...formik
            }) => (
              <Form>
                <div className='modal-content'>
                  <div className='modal-header py-4'>
                    <div>
                      <h2 className='fw-bold mb-1'>Unassignment Reason</h2>
                      <div className='text-gray-500 fs-6'>
                        Reason selection is mandatory and will be evaluated to improve interpreter
                        assignments
                      </div>
                    </div>
                    <div
                      className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                      data-bs-dismiss='modal'
                      aria-label='Close'
                      onClick={() => resetForm()}
                    >
                      <KTSVG
                        path='/media/icons/duotune/arrows/arr061.svg'
                        className='svg-icon svg-icon-2x'
                      />
                    </div>
                  </div>
                  <div className='modal-body py-6'>
                    <div className='row g-4 g-xl-6'>
                      <div className='col-sm-12 col-md-12 col-lg-12'>
                        <div className='mb-3'>
                          <label
                            htmlFor='reason'
                            className='form-label fs-6 fw-bold text-gray-900 mb-2'
                          >
                            Reason
                          </label>
                          <select
                            name='reason'
                            id='reason'
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.reason}
                            disabled={unassignmentReasonsLoading || !unassignmentReasons?.length}
                            className='form-select mb-lg-0'
                          >
                            <option value=''>
                              {unassignmentReasonsLoading ? 'Loading reasons...' : 'Select Reason'}
                            </option>
                            {unassignmentReasons?.map((unassignmentReason) => (
                              <option key={unassignmentReason.code} value={unassignmentReason.name}>
                                {unassignmentReason.name}
                              </option>
                            ))}
                          </select>
                          {!unassignmentReasonsLoading && unassignmentReasons === null && (
                            <div className='text-danger fs-7 mt-2'>
                              Unable to load unassignment reasons. Close and try again.
                            </div>
                          )}
                          {!unassignmentReasonsLoading && unassignmentReasons?.length === 0 && (
                            <div className='text-gray-600 fs-7 mt-2'>
                              No active unassignment reasons. Add one under Configuration → Reasons.
                            </div>
                          )}
                          {errors.reason && (
                            <div className='fv-plugins-message-container'>
                              <div className='fv-help-block'>
                                <span role='alert'>{errors.reason.toString()}</span>
                              </div>
                            </div>
                          )}
                        </div>
                        <div className='mb-3'>
                          <label
                            htmlFor='additionalInfo'
                            className='form-label fs-6 fw-bold text-gray-900 mb-2'
                          >
                            Additional Information
                          </label>
                          <span className='text-gray-500 ms-2' style={{fontSize: '11px'}}>
                            (Optional)
                          </span>
                          <textarea
                            name='additionalInfo'
                            id='additionalInfo'
                            className='form-control'
                            rows={3}
                            maxLength={ADDITIONAL_INFO_MAX_LENGTH}
                            placeholder='Add more details about this unassignment (optional)'
                            value={values.additionalInfo}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                          <div className='text-gray-500 text-end' style={{fontSize: '11px'}}>
                            {values.additionalInfo?.length ?? 0} / {ADDITIONAL_INFO_MAX_LENGTH}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='modal-footer py-4'>
                    <button
                      type='button'
                      className='btn btn-sm btn-outline btn-outline-danger btn-active-light-danger'
                      data-bs-dismiss='modal'
                      onClick={() => resetForm()}
                    >
                      Cancel
                    </button>
                    <Link to='#'>
                      <button
                        type='submit'
                        className='btn btn-primary btn-sm'
                        data-bs-dismiss='modal'
                        disabled={isSubmitting || isAssignUnassignInProgress || !isValid || !dirty}
                        onClick={() => handleSubmit()}
                      >
                        {isSubmitting || isAssignUnassignInProgress ? (
                          <>
                            <span className='spinner-border spinner-border-sm align-middle me-2'></span>
                            Unassigning...
                          </>
                        ) : (
                          'Unassign'
                        )}
                      </button>
                    </Link>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
      <div className='modal fade' tabIndex={-1} id='kt_modal_5'>
        <div className='modal-dialog'>
          <Formik
            initialValues={initialValue}
            validationSchema={addnoteSchema}
            onSubmit={async (values, {setSubmitting, resetForm}) => {
              setSubmitting(true)
              try {
                const result: any = await axios.post(`${API_URL}/Appoinment/osi-submission-notes`, {
                  code: meetingSummary.code,
                  note: values.note,
                })
                if (result?.data?.status == 'S') {
                  setSubmitting(true)
                  toaster('success', result?.data?.text ?? 'Successfully Inserted')
                  let osiNoteResponse = await axios.get(
                    `${API_URL}/Appoinment/osi-submission-activities/${meetingSummary.code}`
                  )
                  setOSINotes(osiNoteResponse?.data?.notes)
                  const modal = document.getElementById('kt_modal_5')
                  if (modal) {
                    const modalInstance = Modal.getInstance(modal)
                    if (modalInstance) modalInstance.hide()
                  }
                  navigate(`/appointmentViewer/${id}?tab=5`, {replace: true})
                  setActiveTab(5)
                } else {
                  toaster('error', result?.data?.text ?? 'Something went wrong')
                }
                resetForm()
              } catch (ex) {
                console.error(ex)
              }
            }}
          >
            {({
              handleChange,
              handleBlur,
              setFieldValue,
              errors,
              values,
              touched,
              isValid,
              dirty,
              isSubmitting,
              handleSubmit,
              resetForm,
              ...formik
            }) => (
              <Form>
                <div className='modal-content'>
                  <div className='modal-header py-2'>
                    <h4 className='modal-title'>Add OSI Note</h4>
                    <div
                      className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                      data-bs-dismiss='modal'
                      aria-label='Close'
                      onClick={() => resetForm()}
                    >
                      <KTSVG
                        path='/media/icons/duotune/arrows/arr061.svg'
                        className='svg-icon svg-icon-2x'
                      />
                    </div>
                  </div>
                  <div className='modal-body'>
                    <div className='row g-4 g-xl-6'>
                      <div className='col-sm-12 col-md-12 col-lg-12'>
                        <div className='mb-3'>
                          <label
                            htmlFor='exampleFormControlInput1'
                            className='required form-label fs-7 mb-1  fs-7 mb-1'
                          >
                            Write a Note
                          </label>
                          <textarea
                            placeholder='write Note..'
                            name='note'
                            id='note'
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.note}
                            className='form-control form-control-sm custom-input-height  custom-input-height  form-select-white mb-lg-0'
                          ></textarea>
                          {errors.note && (
                            <div className='fv-plugins-message-container'>
                              <div className='fv-help-block'>
                                <span role='alert'>{errors.note}</span>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='modal-footer py-3'>
                    <button
                      type='button'
                      className='btn btn-light btn-sm'
                      data-bs-dismiss='modal'
                      onClick={() => resetForm()}
                    >
                      Close
                    </button>
                    <button
                      type='submit'
                      className='btn btn-primary btn-sm'
                      disabled={isSubmitting || !isValid || !dirty}
                    >
                      Save Note
                    </button>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
      <div className='modal fade' tabIndex={-1} id='document'>
        <div className='modal-dialog'>
          <Formik
            initialValues={initialValues}
            validationSchema={documentUploadSchemaSchema}
            onSubmit={async (values, {setSubmitting, resetForm}) => {
              setSubmitting(true)
              try {
                const formData = new FormData()
                formData.append('name', values?.name ?? '')
                formData.append('description', values?.description ?? '')
                formData.append('file', values?.file ?? '')
                formData.append('appoinmentId', id ?? '')

                const result: any = await axios.post(
                  `${API_URL}/Appoinment/documents/insert`,
                  formData
                )
                if (result?.data?.status == 'S') {
                  toaster('success', result?.text ?? 'Successfully Inserted')
                  getDocuments()
                  resetForm()
                }
              } catch (ex) {
                console.error(ex)
              } finally {
                setSubmitting(false)
              }
            }}
          >
            {({
              handleChange,
              handleBlur,
              setFieldValue,
              errors,
              values,
              touched,
              isValid,
              dirty,
              isSubmitting,
              handleSubmit,
              resetForm,
              ...formik
            }) => (
              <Form>
                <div className='modal-content'>
                  <div className='modal-header py-2'>
                    <h4 className='modal-title'>Appointment File</h4>
                    <div
                      className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                      data-bs-dismiss='modal'
                      aria-label='Close'
                      onClick={() => resetForm()}
                    >
                      <KTSVG
                        path='/media/icons/duotune/arrows/arr061.svg'
                        className='svg-icon svg-icon-2x'
                      />
                    </div>
                  </div>
                  <div className='modal-body'>
                    <div className='row g-4 g-xl-6'>
                      <div className='col-sm-12 col-md-12 col-lg-12'>
                        <div className='mb-3'>
                          <label
                            htmlFor='exampleFormControlInput1'
                            className='required form-label fs-7 mb-1  fs-7 mb-1'
                          >
                            Name
                          </label>
                          <input
                            type='text'
                            className='form-control form-control-white form-select-sm custom-input-height   custom-input-height'
                            placeholder='Name'
                            name='name'
                            id='name'
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.name}
                          />
                          {errors.name && (
                            <div className='fv-plugins-message-container'>
                              <div className='fv-help-block'>
                                <span role='alert'>{errors.name}</span>
                              </div>
                            </div>
                          )}
                        </div>
                        <div className='mb-3'>
                          <label
                            htmlFor='exampleFormControlInput1'
                            className='form-label fs-7 mb-1  fs-7 mb-1'
                          >
                            Description
                          </label>
                          <textarea
                            placeholder='Write Description..'
                            className='form-control form-control-sm custom-input-height  custom-input-height  form-select-white mb-lg-0 '
                            id='description'
                            name='description'
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.description}
                            rows={3}
                          ></textarea>
                          {errors.description && (
                            <div className='fv-plugins-message-container'>
                              <div className='fv-help-block'>
                                <span role='alert'>{errors.description}</span>
                              </div>
                            </div>
                          )}
                        </div>
                        <div className='mb-3'>
                          <label
                            htmlFor='exampleFormControlInput1'
                            className='required form-label fs-7 mb-1  fs-7 mb-1'
                          >
                            File Upload
                          </label>
                          <input
                            type='file'
                            className='form-control form-control-white form-select-sm custom-input-height  '
                            placeholder='Select File'
                            onChange={(e) => onSelectFile(e, setFieldValue)}
                            name='file'
                            id='file'
                            onBlur={handleBlur}
                          />
                          {errors.file && (
                            <div className='fv-plugins-message-container'>
                              <div className='fv-help-block'>
                                <span role='alert'>{errors.file}</span>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='modal-footer py-3'>
                    <button
                      type='button'
                      className='btn btn-light btn-sm'
                      data-bs-dismiss='modal'
                      onClick={() => resetForm()}
                    >
                      Close
                    </button>
                    <button
                      type='submit'
                      className='btn btn-primary btn-sm'
                      data-bs-dismiss='modal'
                      disabled={isSubmitting || !isValid || !dirty}
                      onClick={() => handleSubmit()}
                    >
                      Add
                    </button>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
      <div className='modal fade' tabIndex={-1} id='kt_new_expense_1'>
        <div className='modal-dialog'>
          <div className='modal-content'>
            <div className='modal-header py-2'>
              <h4 className='modal-title'>Add Expense</h4>
              <div
                className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                data-bs-dismiss='modal'
                aria-label='Close'
              >
                <KTSVG
                  path='/media/icons/duotune/arrows/arr061.svg'
                  className='svg-icon svg-icon-2x'
                />
              </div>
            </div>
            <div className='modal-body'>
              <div className='row g-4 g-xl-6'>
                <div className='col-sm-12 col-md-12 col-lg-12'>
                  <div className='mb-3'>
                    <label
                      htmlFor='exampleFormControlInput1'
                      className='required form-label fs-7 mb-1 '
                    >
                      Category
                    </label>
                    <Select
                      className='react-select-styled react-select-solid react-select-sm'
                      classNamePrefix='react-select'
                      options={category}
                      placeholder='Select '
                      styles={{
                        control: (provided: any) => ({
                          ...provided,
                          width: '100%',
                          border: '1px solid #e4e6ef',
                        }),
                        placeholder: (provided: any) => ({
                          ...provided,
                          color: '#a4afc4',
                        }),
                      }}
                    />
                  </div>
                  <div className='mb-3'>
                    <label
                      htmlFor='exampleFormControlInput1'
                      className='required form-label fs-7 mb-1 '
                    >
                      Amount
                    </label>
                    <input
                      type='number'
                      className='form-control form-control-white form-select-sm custom-input-height'
                      placeholder='Amount'
                    />
                  </div>
                  <div className='mb-3'>
                    <label htmlFor='exampleFormControlInput1' className='form-label fs-7 mb-1 '>
                      Note
                    </label>
                    <textarea
                      placeholder='Write Note..'
                      name='Note'
                      className='form-control form-control-sm custom-input-height  custom-input-height  form-select-white mb-lg-0 custom-input-height'
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
            <div className='modal-footer py-3'>
              <button type='button' className='btn btn-light btn-sm' data-bs-dismiss='modal'>
                Close
              </button>

              <button type='button' className='btn btn-primary btn-sm'>
                Create Expense
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className='modal fade' tabIndex={-1} id='kt_interpreter_expense'>
        <div className='modal-dialog'>
          <div className='modal-content'>
            <div className='modal-header py-2'>
              <h4 className='modal-title'>Add Expense</h4>
              <div
                className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                data-bs-dismiss='modal'
                aria-label='Close'
              >
                <KTSVG
                  path='/media/icons/duotune/arrows/arr061.svg'
                  className='svg-icon svg-icon-2x'
                />
              </div>
            </div>
            <div className='modal-body'>
              <div className='row g-4 g-xl-6'>
                <div className='col-sm-12 col-md-12 col-lg-12'>
                  <div className='mb-3'>
                    <label
                      htmlFor='exampleFormControlInput1'
                      className='required form-label fs-7 mb-1 '
                    >
                      Category
                    </label>
                    <select
                      className='form-select form-select-sm custom-input-height   form-select-white'
                      data-kt-select2='true'
                      data-placeholder='Select option'
                      data-allow-clear='true'
                    >
                      <option> Select Category</option>
                      <option value='1'> Fuel/Mileage</option>
                      <option value='2'> Parking/Tolls</option>
                      <option value='3'> Public Transportation </option>
                      <option value='4'> Taxi/Uber/Back car</option>
                      <option value='5'> Internet/Phone </option>
                      <option value='6'> Meals/Foods</option>
                      <option value='7'> Hotel/Accommodation </option>
                      <option value='8'> Airfare</option>
                      <option value='9'> Travel Time</option>
                      <option value='10'> Other</option>
                    </select>
                  </div>
                  <div className='mb-3'>
                    <label
                      htmlFor='exampleFormControlInput1'
                      className='required form-label fs-7 mb-1 '
                    >
                      Amount
                    </label>
                    <input
                      type='number'
                      className='form-control form-control-white form-select-sm custom-input-height  '
                      placeholder='Amount'
                    />
                  </div>
                  <div className='mb-3'>
                    <label htmlFor='exampleFormControlInput1' className='form-label fs-7 mb-1 '>
                      Vendor
                    </label>
                    <input
                      type='text'
                      className='form-control form-control-white form-select-sm custom-input-height  '
                      placeholder='Enter Vendor'
                    />
                  </div>
                  <div className='mb-3'>
                    <label htmlFor='exampleFormControlInput1' className='form-label fs-7 mb-1 '>
                      Note
                    </label>
                    <textarea
                      placeholder='Write Note..'
                      name='Note'
                      className='form-control form-select-white mb-lg-0'
                    ></textarea>
                  </div>
                  <div className='mb-3'>
                    <label htmlFor='exampleFormControlInput1' className=' form-label fs-7 mb-1 '>
                      Receipt
                    </label>
                    <input
                      type='file'
                      className='form-control form-control-white form-select-sm custom-input-height  '
                      placeholder='Select Receipt'
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className='modal-footer py-3'>
              <button type='button' className='btn btn-light btn-sm' data-bs-dismiss='modal'>
                Close
              </button>

              <button type='button' className='btn btn-primary btn-sm'>
                Create Expense
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className='modal fade' tabIndex={-1} id='kt_edit_rate'>
        <div className='modal-dialog modal-lg'>
          <div className='modal-content '>
            <div className='modal-header py-2'>
              <h4 className='modal-title'>Edit Appointment Rate</h4>
              <div
                className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                data-bs-dismiss='modal'
                aria-label='Close'
              >
                <KTSVG
                  path='/media/icons/duotune/arrows/arr061.svg'
                  className='svg-icon svg-icon-2x'
                />
              </div>
            </div>
            <div className='modal-body' style={{maxHeight: '80vh', overflowY: 'scroll'}}>
              <div className='row g-4 g-xl-6'>
                <div className='col-sm-12 col-md-12 col-lg-12'>
                  <div className=''>
                    <div className='row g-4 g-xl-6'>
                      <div className='col-sm-12 col-md-12 col-lg-12 '>
                        <div className='row g-4 mb-0'>
                          <div className='col-sm-12 col-md-12'>
                            <label
                              htmlFor='exampleFormControlInput1'
                              className='form-label fs-7 mb-1 '
                            >
                              Rate
                            </label>
                            <input
                              type='number'
                              className='form-control form-control-white form-control-sm custom-input-height  custom-input-height  custom-input-height'
                              placeholder='Enter Rate'
                            />
                          </div>
                          <div className='row mt-3'>
                            <div className=''>
                              {rows.map((_, index) => (
                                <div className='' key={index}>
                                  <div className='row g-4 g-xl-4 mb-2'>
                                    <div className='col-sm-12 col-md-6'>
                                      <label
                                        htmlFor='exampleFormControlInput1'
                                        className='form-label fs-7 mb-1 '
                                      >
                                        For
                                      </label>
                                      <div className='input-group input-group-sm'>
                                        <input
                                          type='number'
                                          className='form-control form-control-white form-control-sm custom-input-height  custom-input-height  custom-input-height'
                                          placeholder='No Threshold '
                                        />
                                        <span className='input-group-text'>Min(s)</span>
                                      </div>
                                    </div>
                                    <div className='col-sm-12 col-md-5'>
                                      <label
                                        htmlFor='exampleFormControlInput1'
                                        className='form-label fs-7 mb-1 '
                                      >
                                        Then
                                      </label>
                                      <div className='input-group input-group-sm'>
                                        <span className='input-group-text'>Minute</span>
                                        <span className='input-group-text'>$</span>
                                        <input
                                          type='number'
                                          className='form-control form-control-white form-control-sm custom-input-height  custom-input-height  custom-input-height'
                                          placeholder='None '
                                        />
                                      </div>
                                    </div>
                                    <div className='col-sm-12 col-md-1 d-flex align-items-end flex-end'>
                                      <a className='' onClick={() => removeRow(index)}>
                                        <KTSVG
                                          path='/media/icons/duotune/general/gen040.svg'
                                          className='svg-icon-muted svg-icon-2hx'
                                        />
                                      </a>
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                            <div className='col-sm-12 col-md-12'>
                              <div>
                                <a
                                  type='button'
                                  className='btn btn-link btn-color-info btn-active-color-primary me-5 fs-6'
                                  onClick={addRow}
                                >
                                  <i className='bi bi-plus fs-2'></i>
                                  <span style={{fontSize: '12px'}}>
                                    Add Rate Threshold ({rows.length}/2)
                                  </span>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className='mb-3 mt-0'>
                          <label
                            htmlFor='exampleFormControlInput1'
                            className='form-label fs-7 mb-1 '
                          >
                            Per
                          </label>
                          <select
                            className='form-select form-select-sm custom-input-height   form-select-white'
                            data-kt-select2='true'
                            data-placeholder='Select option'
                            data-allow-clear='true'
                            onChange={handleRecurrenceChange}
                          >
                            <option value='1'>Min</option>
                            <option value='2'>Hr</option>
                            <option value='3'>Fixed</option>
                          </select>
                        </div>
                        {selectedRecurrence === '1' && (
                          <div className='row g-4 mb-3 '>
                            <div className='col-sm-12 col-md-6 '>
                              <label
                                htmlFor='exampleFormControlInput1'
                                className='form-label fs-7 mb-1 '
                              >
                                Rounding
                              </label>
                              <select
                                className='form-select form-select-sm custom-input-height   form-select-white'
                                data-kt-select2='true'
                                data-placeholder='Select option'
                                data-allow-clear='true'
                              >
                                <option value='1'>1 min</option>
                                <option value='2'>Pro-rata</option>
                                <option value='3'>5 min</option>
                                <option value='4'>15 min</option>
                                <option value='5'>30 min</option>
                                <option value='6'>1 Hr</option>
                              </select>
                            </div>
                            <div className='col-sm-12 col-md-6 '>
                              <label
                                htmlFor='exampleFormControlInput1'
                                className='form-label fs-7 mb-1 '
                              >
                                Direction
                              </label>
                              <select
                                className='form-select form-select-sm custom-input-height   form-select-white'
                                data-kt-select2='true'
                                data-placeholder='Select option'
                                data-allow-clear='true'
                              >
                                <option value='1'>Up</option>
                                <option value='2'>Down</option>
                                <option value='3'>Up/Down</option>
                              </select>
                            </div>
                            <div className='col-sm-12 col-md-6 '>
                              <label
                                htmlFor='exampleFormControlInput1'
                                className='form-label fs-7 mb-1 '
                              >
                                Minimum
                              </label>
                              <input
                                type='number'
                                className='form-control form-control-white form-control-sm custom-input-height  custom-input-height  custom-input-height'
                                placeholder='Enter Minimum'
                              />
                            </div>
                            <div className='col-sm-12 col-md-6 d-flex justify-content-start align-items-end'>
                              <a className='form-label fs-7 mb-1 '>Minute</a>
                            </div>
                          </div>
                        )}
                        {selectedRecurrence === '2' && (
                          <div className='row g-4 mb-3 '>
                            <div className='col-sm-12 col-md-6 '>
                              <label
                                htmlFor='exampleFormControlInput1'
                                className='form-label fs-7 mb-1 '
                              >
                                Rounding
                              </label>
                              <select
                                className='form-select form-select-sm custom-input-height   form-select-white'
                                data-kt-select2='true'
                                data-placeholder='Select option'
                                data-allow-clear='true'
                              >
                                <option value='1'>1 min</option>
                                <option value='2'>Pro-rata</option>
                                <option value='3'>5 min</option>
                                <option value='4'>15 min</option>
                                <option value='5'>30 min</option>
                                <option value='6'>1 Hr</option>
                              </select>
                            </div>
                            <div className='col-sm-12 col-md-6 '>
                              <label
                                htmlFor='exampleFormControlInput1'
                                className='form-label fs-7 mb-1 '
                              >
                                Direction
                              </label>
                              <select
                                className='form-select form-select-sm custom-input-height   form-select-white'
                                data-kt-select2='true'
                                data-placeholder='Select option'
                                data-allow-clear='true'
                              >
                                <option value='1'>Up</option>
                                <option value='2'>Down</option>
                                <option value='3'>Up/Down</option>
                              </select>
                            </div>
                            <div className='col-sm-12 col-md-6 '>
                              <label
                                htmlFor='exampleFormControlInput1'
                                className='form-label fs-7 mb-1 '
                              >
                                Minimum
                              </label>
                              <input
                                type='number'
                                className='form-control form-control-white form-control-sm custom-input-height  custom-input-height  custom-input-height'
                                placeholder='Enter Minimum'
                              />
                            </div>
                            <div className='col-sm-12 col-md-6 d-flex justify-content-start align-items-end'>
                              <a className='form-label fs-7 mb-1 '>Hour</a>
                            </div>
                          </div>
                        )}

                        <div className='mb-3'>
                          <label
                            htmlFor='exampleFormControlInput1'
                            className='form-label fs-7 mb-1 '
                          >
                            Priority (Fixed Amount){' '}
                            <i
                              className='bi bi-info-circle text-info'
                              data-bs-toggle='popover'
                              data-bs-custom-class='popover-inverse'
                              data-bs-placement='top'
                              title='Priority rate will be added in addition to base rate. For account charge it will also be multiplied by the number of participating interpreters.'
                            ></i>
                          </label>
                          <div className='input-group input-group-sm'>
                            <span className='input-group-text'>$</span>
                            <input
                              type='number'
                              className='form-control form-control-white form-control-sm custom-input-height  custom-input-height  custom-input-height'
                              placeholder='None'
                            />
                          </div>
                        </div>
                        <div className='mb-3'>
                          <label
                            htmlFor='exampleFormControlInput1'
                            className='form-label fs-7 mb-1 '
                          >
                            Priority (Add To Base Rate){' '}
                            <i
                              className='bi bi-info-circle text-info'
                              data-bs-toggle='popover'
                              data-bs-custom-class='popover-inverse'
                              data-bs-placement='top'
                              title='Priority rate will be added in addition to base rate. For account charge it will also be multiplied by the number of participating interpreters.'
                            ></i>
                          </label>
                          <div className='input-group input-group-sm'>
                            <span className='input-group-text p-0 '>
                              <select
                                className='form-select form-select-sm custom-input-height   form-select-white rounded-0'
                                data-kt-select2='true'
                                data-placeholder='Select option'
                                data-allow-clear='true'
                              >
                                <option value='1'>$</option>
                                <option value='2'>%</option>
                              </select>
                            </span>
                            <input
                              type='number'
                              className='form-control form-control-white form-control-sm custom-input-height  custom-input-height  custom-input-height'
                              placeholder='None'
                            />
                          </div>
                        </div>
                        <div className='row g-4 mb-3 '>
                          <div className='col-sm-12 col-md-6 '>
                            <label
                              htmlFor='exampleFormControlInput1'
                              className='form-label fs-7 mb-1 '
                            >
                              Conference Rate{' '}
                              <i
                                className='bi bi-info-circle text-info'
                                data-bs-toggle='popover'
                                data-bs-custom-class='popover-inverse'
                                data-bs-placement='top'
                                title='Additional rate for having 3+ participants during audio or video call.'
                              ></i>
                            </label>
                            <select
                              className='form-select form-select-sm custom-input-height   form-select-white'
                              data-kt-select2='true'
                              data-placeholder='Select option'
                              data-allow-clear='true'
                              value={selectedOption}
                              onChange={handleSelectChange}
                            >
                              <option value='1'>Add fixed amount</option>
                              <option value='2'>Add to a base rate</option>
                            </select>
                          </div>
                          <div className='col-sm-12 col-md-6 d-flex align-items-end'>
                            {selectedOption === '1' && (
                              <div className='input-group input-group-sm'>
                                <span className='input-group-text'>$</span>
                                <input
                                  type='number'
                                  className='form-control form-control-white form-control-sm custom-input-height  custom-input-height  custom-input-height'
                                  placeholder='None'
                                />
                              </div>
                            )}
                            {selectedOption === '2' && (
                              <div className='input-group input-group-sm'>
                                <span className='input-group-text'>Minute</span>
                                <span className='input-group-text'>$</span>
                                <input
                                  type='number'
                                  className='form-control form-control-white form-control-sm custom-input-height  custom-input-height  custom-input-height'
                                  placeholder='None'
                                />
                              </div>
                            )}
                          </div>
                        </div>
                        <div className='mb-3'>
                          <label
                            htmlFor='exampleFormControlInput1'
                            className='form-label fs-7 mb-1 '
                          >
                            Account charged based on
                          </label>
                          <div className='row g-4 g-xl-6'>
                            <div className='col-sm-12 col-md-12 col-lg-12'>
                              <label className='d-flex flex-start mb-0 cursor-pointer mb-2'>
                                <span className='form-check form-check-custom form-check-white me-3'>
                                  <input
                                    name='accountPlan'
                                    className='form-check-input'
                                    type='radio'
                                    value='1'
                                  />
                                </span>
                                <span className='d-flex align-items-center me-2'>
                                  <span
                                    className='text-gray-600 text-hover-primary '
                                    style={{fontSize: '12px'}}
                                  >
                                    Scheduled duration
                                  </span>
                                </span>
                              </label>
                              <label className='d-flex flex-start mb-0 cursor-pointer mb-2'>
                                <span className='form-check form-check-custom form-check-white me-3'>
                                  <input
                                    name='accountPlan'
                                    className='form-check-input'
                                    type='radio'
                                    value='2'
                                    checked
                                  />
                                </span>
                                <span className='d-flex align-items-center me-2'>
                                  <span
                                    className='text-gray-800 text-hover-primary'
                                    style={{fontSize: '12px'}}
                                  >
                                    Actual duration
                                  </span>
                                </span>
                              </label>
                              <label className='d-flex flex-start mb-0 cursor-pointer'>
                                <span className='form-check form-check-custom form-check-white me-3'>
                                  <input
                                    name='accountPlan'
                                    className='form-check-input'
                                    type='radio'
                                    value='3'
                                    checked
                                  />
                                </span>
                                <span className='d-flex align-items-center me-2'>
                                  <span
                                    className='text-gray-800 text-hover-primary '
                                    style={{fontSize: '12px'}}
                                  >
                                    Actual with minimum scheduled duration
                                  </span>
                                </span>
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='modal-footer py-3'>
              <button type='button' className='btn btn-light btn-sm' data-bs-dismiss='modal'>
                Cancel
              </button>
              <Link to='#'>
                <button type='button' className='btn btn-primary btn-sm' data-bs-dismiss='modal'>
                  Save
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div className='modal fade' tabIndex={-1} id='kt_edit_mileage_expense'>
        <div className='modal-dialog modal-md'>
          <div className='modal-content '>
            <div className='modal-header py-2'>
              <h4 className='modal-title'>Distance Rule</h4>
              <div
                className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                data-bs-dismiss='modal'
                aria-label='Close'
              >
                <KTSVG
                  path='/media/icons/duotune/arrows/arr061.svg'
                  className='svg-icon svg-icon-2x'
                />
              </div>
            </div>
            <div className='modal-body' style={{maxHeight: '80vh', overflowY: 'scroll'}}>
              <div className='row g-4 '>
                <div className='col-sm-12 col-md-12 col-lg-12'>
                  <label className='d-flex flex-start mb-0 cursor-pointer mb-2'>
                    <span className='form-check form-check-custom form-check-white me-3'>
                      <input
                        name='accountPlan1'
                        className='form-check-input'
                        type='radio'
                        value='1'
                        checked={isRatePerMile}
                        disabled={isRatePerMile}
                        onChange={() => setIsRatePerMile(true)}
                      />
                    </span>
                    <span className='d-flex align-items-center me-2'>
                      <span className='text-gray-800 text-hover-primary '>Rate per Mile</span>
                    </span>
                  </label>
                  <label className='d-flex flex-start mb-0 cursor-pointer mb-2'>
                    <span className='form-check form-check-custom form-check-white me-3'>
                      <input
                        name='accountPlan1'
                        className='form-check-input'
                        type='radio'
                        value='2'
                        checked={!isRatePerMile}
                        disabled={!isRatePerMile}
                        onChange={() => setIsRatePerMile(false)}
                      />
                    </span>
                    <span className='d-flex align-items-center me-2'>
                      <span className='text-gray-800 text-hover-primary'>Based on Rate</span>
                    </span>
                  </label>
                </div>
                {isRatePerMile ? (
                  <div className='col-sm-12 col-md-12 col-lg-12 '>
                    <label htmlFor='exampleFormControlInput1' className='form-label fs-7 mb-1 '>
                      Rate per Mile
                    </label>
                    <div className='input-group input-group-sm'>
                      {/* <span className='input-group-text'>Hr</span> */}
                      <span className='input-group-text'>$</span>
                      <input
                        type='number'
                        className='form-control form-control-white form-control-sm custom-input-height  custom-input-height  custom-input-height'
                        placeholder='None'
                      />
                    </div>
                  </div>
                ) : (
                  <div className='col-sm-12 col-md-12 col-lg-12 '>
                    <label htmlFor='exampleFormControlInput1' className='form-label fs-7 mb-1 '>
                      Base on Rate
                    </label>
                    <div className='input-group input-group-sm'>
                      {/* <span className='input-group-text'>Hr</span> */}

                      <input
                        type='number'
                        className='form-control form-control-white form-control-sm custom-input-height  custom-input-height  custom-input-height'
                        placeholder='None'
                      />
                      <span className='input-group-text'>miles equals to</span>
                      <input
                        type='number'
                        className='form-control form-control-white form-control-sm custom-input-height  custom-input-height  custom-input-height'
                        placeholder='None'
                      />
                      <span className='input-group-text'>hr of the rate</span>
                    </div>
                  </div>
                )}
                <div className='col-sm-12 col-md-6 col-lg-6 '>
                  <div className='form-check form-check-custom form-check-solid form-check-sm mb-2'>
                    <input
                      className='form-check-input'
                      type='checkbox'
                      value=''
                      id='flexRadioLg'
                      checked={isChecked}
                      onChange={handleCheckboxChange}
                    />
                    <label className='form-check-label' htmlFor='flexRadioLg'>
                      Min Miles
                    </label>
                  </div>

                  <input
                    type='number'
                    className='form-control form-control-white form-control-sm custom-input-height  custom-input-height  custom-input-height'
                    placeholder='None'
                    disabled={!isChecked}
                  />
                </div>

                <div className='col-sm-12 col-md-6 col-lg-6 '>
                  <div className='form-check form-check-custom form-check-solid form-check-sm mb-2'>
                    <input
                      className='form-check-input'
                      type='checkbox'
                      value=''
                      id='flexRadioLg'
                      checked={isChecked2}
                      onChange={handleCheckboxChange2}
                    />
                    <label className='form-check-label' htmlFor='flexRadioLg'>
                      Max Miles
                    </label>
                  </div>
                  <input
                    type='number'
                    className='form-control form-control-white form-control-sm custom-input-height  custom-input-height  custom-input-height'
                    placeholder='None'
                    disabled={!isChecked2}
                  />
                </div>
                <div className='col-sm-12 col-md-12 col-lg-12'>
                  <div className='form-check form-check-custom form-check-solid form-check-sm mb-2'>
                    <input
                      className='form-check-input'
                      type='checkbox'
                      value=''
                      id='flexRadioLg1'
                      checked
                    />
                    <label className='form-check-label' htmlFor='flexRadioLg1'>
                      Automatically add to appointments for Interpreters
                    </label>
                  </div>
                </div>
                <div className='col-sm-12 col-md-12 col-lg-12'>
                  <div className='form-check form-check-custom form-check-solid form-check-sm mb-2'>
                    <input
                      className='form-check-input'
                      type='checkbox'
                      value=''
                      id='flexRadioLg2'
                      checked
                    />
                    <label className='form-check-label' htmlFor='flexRadioLg2'>
                      Automatically add to appointments for Accounts
                    </label>
                  </div>
                </div>
                <div className='col-sm-12 col-md-12 col-lg-12'>
                  <div className='form-check form-check-custom form-check-solid form-check-sm mb-2'>
                    <input
                      className='form-check-input'
                      type='checkbox'
                      value=''
                      id='flexRadioLg3'
                    />
                    <label className='form-check-label' htmlFor='flexRadioLg'>
                      Round-trip{' '}
                      <i
                        className='bi bi-info-circle text-info'
                        data-bs-toggle='popover'
                        data-bs-custom-class='popover-inverse'
                        data-bs-placement='top'
                        title='When selected, distance from interpreter address to appointment location will be automatically doubled.'
                      ></i>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div className='modal-footer py-3'>
              <button type='button' className='btn btn-light btn-sm' data-bs-dismiss='modal'>
                Cancel
              </button>
              <Link to='#'>
                <button type='button' className='btn btn-primary btn-sm'>
                  Save Distance Rule
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div className='modal fade' tabIndex={-1} id='kt_edit_travel_expense'>
        <div className='modal-dialog modal-md'>
          <div className='modal-content '>
            <div className='modal-header py-2'>
              <h4 className='modal-title'>Travel Time Rule</h4>
              <div
                className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                data-bs-dismiss='modal'
                aria-label='Close'
              >
                <KTSVG
                  path='/media/icons/duotune/arrows/arr061.svg'
                  className='svg-icon svg-icon-2x'
                />
              </div>
            </div>
            <div className='modal-body' style={{maxHeight: '80vh', overflowY: 'scroll'}}>
              <div className='row g-4 '>
                <div className='col-sm-12 col-md-12 col-lg-12'>
                  <label className='d-flex flex-start mb-0 cursor-pointer mb-2'>
                    <span className='form-check form-check-custom form-check-white me-3'>
                      <input
                        name='accountPlan2'
                        className='form-check-input'
                        type='radio'
                        value='3'
                        checked={isTravelTime}
                        disabled={isTravelTime}
                        onChange={() => setIsTravelTime(true)}
                      />
                    </span>
                    <span className='d-flex align-items-center me-2'>
                      <span className='text-gray-800 text-hover-primary '>
                        Based on Interpreter/Account Rate{' '}
                        <i
                          className='bi bi-info-circle text-info'
                          data-bs-toggle='popover'
                          data-bs-custom-class='popover-inverse'
                          data-bs-placement='top'
                          title='1 hour/min of travel time equals to 1 hour/min of Account and Interpreter rate'
                        ></i>
                      </span>
                    </span>
                  </label>
                  <label className='d-flex flex-start mb-0 cursor-pointer mb-2'>
                    <span className='form-check form-check-custom form-check-white me-3'>
                      <input
                        name='accountPlan2'
                        className='form-check-input'
                        type='radio'
                        value='4'
                        checked={!isTravelTime}
                        disabled={!isTravelTime}
                        onChange={() => setIsTravelTime(false)}
                      />
                    </span>
                    <span className='d-flex align-items-center me-2'>
                      <span className='text-gray-800 text-hover-primary'>New Rate</span>
                    </span>
                  </label>
                </div>
                {isTravelTime ? (
                  <></>
                ) : (
                  <>
                    <div className='col-sm-12 col-md-12 col-lg-12 '>
                      <label htmlFor='exampleFormControlInput1' className='form-label fs-7 mb-1 '>
                        New Rate
                      </label>
                      <div className='input-group input-group-sm'>
                        <span className='input-group-text'>$</span>

                        <input
                          type='number'
                          className='form-control form-control-white form-control-sm custom-input-height  custom-input-height  custom-input-height'
                          placeholder='None'
                        />
                        <span className='input-group-text'>Per</span>
                        <select
                          className='form-select form-select-sm custom-input-height   form-select-white rounded-0'
                          data-kt-select2='true'
                          data-placeholder='Select option'
                          data-allow-clear='true'
                        >
                          <option value='1'>Hour</option>
                          <option value='2'>Minute</option>
                        </select>
                        <span className='input-group-text'>for interpreterse</span>
                      </div>
                    </div>
                    <div className='col-sm-12 col-md-12 col-lg-12 '>
                      <div className='input-group input-group-sm'>
                        <span className='input-group-text'>$</span>

                        <input
                          type='number'
                          className='form-control form-control-white form-control-sm custom-input-height  custom-input-height  custom-input-height'
                          placeholder='None'
                        />
                        <span className='input-group-text'>Per</span>
                        <select
                          className='form-select form-select-sm custom-input-height   form-select-white rounded-0'
                          data-kt-select2='true'
                          data-placeholder='Select option'
                          data-allow-clear='true'
                        >
                          <option value='1'>Hour</option>
                          <option value='2'>Minute</option>
                        </select>
                        <span className='input-group-text'>for accounts</span>
                      </div>
                    </div>
                  </>
                )}
                <div className='col-sm-12 col-md-6 col-lg-6 '>
                  <div className='form-check form-check-custom form-check-solid form-check-sm mb-2'>
                    <input
                      className='form-check-input'
                      type='checkbox'
                      value=''
                      id='flexRadioLg'
                      checked={isChecked}
                      onChange={handleCheckboxChange}
                    />
                    <label className='form-check-label' htmlFor='flexRadioLg'>
                      Min Time
                    </label>
                  </div>
                  <div className='d-flex justify-content-amount align-items-center flex-nowrap'>
                    <button type='button' className='btn btn-light btn-sm me-2'>
                      -
                    </button>
                    <div className='d-flex'>
                      <input
                        type='text'
                        className='form-control form-control-white form-select-sm custom-input-height '
                        pattern='[0-9]{2}:[0-9]{2}'
                        title='Enter Duration in HH:MM format'
                        placeholder='(HH:MM)'
                        disabled={!isChecked}
                      />
                    </div>
                    <button type='button' className='btn btn-light btn-sm ms-2'>
                      +
                    </button>
                  </div>
                </div>

                <div className='col-sm-12 col-md-6 col-lg-6 '>
                  <div className='form-check form-check-custom form-check-solid form-check-sm mb-2'>
                    <input
                      className='form-check-input'
                      type='checkbox'
                      value=''
                      id='flexRadioLg'
                      checked={isChecked2}
                      onChange={handleCheckboxChange2}
                    />
                    <label className='form-check-label' htmlFor='flexRadioLg'>
                      Max Time
                    </label>
                  </div>
                  <div className='d-flex justify-content-amount align-items-center flex-nowrap'>
                    <button type='button' className='btn btn-light btn-sm me-2'>
                      -
                    </button>
                    <div className='d-flex'>
                      <input
                        type='text'
                        className='form-control form-control-white form-select-sm custom-input-height '
                        pattern='[0-9]{2}:[0-9]{2}'
                        title='Enter Duration in HH:MM format'
                        placeholder='(HH:MM)'
                        disabled={!isChecked2}
                      />
                    </div>
                    <button type='button' className='btn btn-light btn-sm ms-2'>
                      +
                    </button>
                  </div>
                </div>
                <div className='col-sm-12 col-md-12 col-lg-12'>
                  <div className='form-check form-check-custom form-check-solid form-check-sm mb-2'>
                    <input
                      className='form-check-input'
                      type='checkbox'
                      value=''
                      id='flexRadioLg11'
                    />
                    <label className='form-check-label' htmlFor='flexRadioLg11'>
                      Automatically add to Account expenses
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div className='modal-footer py-3'>
              <button type='button' className='btn btn-light btn-sm' data-bs-dismiss='modal'>
                Cancel
              </button>
              <Link to='#'>
                <button type='button' className='btn btn-primary btn-sm'>
                  Save Travel Time Rule
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div className='modal fade' tabIndex={-1} id='kt_delete_confirm'>
        <div className='modal-dialog'>
          <div className='modal-content'>
            <div className='modal-header py-2'>
              <h4 className='modal-title'>Delete Confirmation</h4>
              <div
                className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                data-bs-dismiss='modal'
                aria-label='Close'
              >
                <KTSVG
                  path='/media/icons/duotune/arrows/arr061.svg'
                  className='svg-icon svg-icon-2x'
                />
              </div>
            </div>
            <div className='modal-body'>
              <div className='text-center'>
                <div className='symbol symbol-100px '>
                  <img src='/media/other/delete.gif' alt='' />
                </div>
              </div>
              <h4 style={{textAlign: 'center'}}>Are you sure you want to delete this?</h4>
            </div>
            <div className='modal-footer py-3'>
              <button type='button' className='btn btn-light btn-sm' data-bs-dismiss='modal'>
                Close
              </button>

              <button type='button' className='btn btn-danger btn-sm' data-bs-dismiss='modal'>
                Delete
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className='modal fade' tabIndex={-1} id='kt_canceled_status_confirm'>
        <div className='modal-dialog'>
          <div className='modal-content'>
            <div className='modal-header py-2'>
              <h4 className='modal-title'>Confirmation</h4>
              <div
                className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                data-bs-dismiss='modal'
                aria-label='Close'
              >
                <KTSVG
                  path='/media/icons/duotune/arrows/arr061.svg'
                  className='svg-icon svg-icon-2x'
                />
              </div>
            </div>
            <div className='modal-body'>
              <div className='text-center mb-5 me-3'>
                <div className='symbol symbol-90px '>
                  <img src='/media/other/warning.gif' alt='' />
                </div>
              </div>
              <>
                <p>Changing the status from Completed to Canceled might have rate implications:</p>
                <ul>
                  <li>Priority rate may be removed</li>
                  <li>Expenses may be excluded</li>
                  <li>
                    Previously applied standard / special rate may be substituted with cancellation
                    rate
                  </li>
                </ul>
                <p>
                  Please visit Billing tab after the change to make sure desirable rates are being
                  applied.
                </p>
              </>
            </div>
            <div className='modal-footer py-3'>
              <button type='button' className='btn btn-light btn-sm' data-bs-dismiss='modal'>
                Close
              </button>

              <button
                type='button'
                className='btn btn-success btn-sm'
                data-bs-toggle='modal'
                data-bs-target='#kt_canceled_reason'
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className='modal fade' tabIndex={-1} id='kt_canceled_reason'>
        <div className='modal-dialog'>
          <div className='modal-content'>
            <div className='modal-header py-2'>
              <h4 className='modal-title'>Cancel Appointment</h4>
              <div
                className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                data-bs-dismiss='modal'
                aria-label='Close'
              >
                <KTSVG
                  path='/media/icons/duotune/arrows/arr061.svg'
                  className='svg-icon svg-icon-2x'
                />
              </div>
            </div>
            <div className='modal-body'>
              <div className='row g-4 g-xl-6'>
                <div className='col-sm-12 col-md-12 col-lg-12'>
                  <div className='mb-3'>
                    <label
                      htmlFor='exampleFormControlInput1'
                      className='required form-label fs-7 mb-1 '
                    >
                      Reason
                    </label>
                    <select
                      className='form-select form-select-sm custom-input-height form-select-white'
                      data-kt-select2='true'
                      data-placeholder='Select option'
                      data-allow-clear='true'
                    >
                      <option>Select Reason</option>
                      <option value='1'>Did Not Show</option>
                      <option value='2'>Emergency</option>
                      <option value='3'>Other </option>
                      <option value='4'>Appointment made in error</option>
                      <option value='5'>Change of address</option>
                      <option value='6'>Declined, Unable to Cover</option>
                      <option value='7'>No-Show Consumer</option>
                      <option value='8'>No-Show Interpreter</option>
                      <option value='9'>Not necessary now</option>
                      <option value='10'>Same Day Cancellation</option>
                      <option value='11'>Time changed</option>
                    </select>
                  </div>
                  <div className='mb-3'>
                    <label htmlFor='exampleFormControlInput1' className='form-label fs-7 mb-1 '>
                      Other Reason
                    </label>
                    <textarea
                      placeholder='write Reason..'
                      name='reason'
                      className='form-control form-select-white mb-lg-0'
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
            <div className='modal-footer py-3'>
              <button type='button' className='btn btn-light btn-sm' data-bs-dismiss='modal'>
                Close
              </button>
              <Link to='#'>
                <button type='button' className='btn btn-primary btn-sm' data-bs-dismiss='modal'>
                  Submit
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div className='modal fade' tabIndex={-1} id='kt_archived_status_confirm'>
        <div className='modal-dialog'>
          <div className='modal-content'>
            <div className='modal-header py-2'>
              <h4 className='modal-title'>Confirmation</h4>
              <div
                className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                data-bs-dismiss='modal'
                aria-label='Close'
              >
                <KTSVG
                  path='/media/icons/duotune/arrows/arr061.svg'
                  className='svg-icon svg-icon-2x'
                />
              </div>
            </div>
            <div className='modal-body'>
              <div className='text-center mb-5 me-3'>
                <div className='symbol symbol-90px '>
                  <img src='/media/other/warning.gif' alt='' />
                </div>
              </div>
              <>
                <p>
                  Changing the status from Completed to Archived will have no rate implications
                  until you change any fields or perform interpreter actions.
                </p>

                <p>
                  Please visit Billing tab after the change to make sure desirable rates are being
                  applied.
                </p>
              </>
            </div>
            <div className='modal-footer py-3'>
              <button type='button' className='btn btn-light btn-sm' data-bs-dismiss='modal'>
                Close
              </button>

              <button type='button' className='btn btn-success btn-sm' data-bs-dismiss='modal'>
                Confirm
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className='modal fade' tabIndex={-1} id='kt_complete_status_confirm'>
        <div className='modal-dialog'>
          <div className='modal-content'>
            <div className='modal-header py-2'>
              <h4 className='modal-title'>Confirmation</h4>
              <div
                className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                data-bs-dismiss='modal'
                aria-label='Close'
              >
                <KTSVG
                  path='/media/icons/duotune/arrows/arr061.svg'
                  className='svg-icon svg-icon-2x'
                />
              </div>
            </div>
            <div className='modal-body'>
              <div className='text-center mb-5 me-3'>
                <div className='symbol symbol-90px '>
                  <img src='/media/other/warning.gif' alt='' />
                </div>
              </div>
              <>
                <p>
                  Changing the status from Archived to Completed will have no rate implications
                  until you change any fields or perform interpreter actions.
                </p>

                <p>
                  Please visit Billing tab after the change to make sure desirable rates are being
                  applied.
                </p>
              </>
            </div>
            <div className='modal-footer py-3'>
              <button type='button' className='btn btn-light btn-sm' data-bs-dismiss='modal'>
                Close
              </button>

              <button type='button' className='btn btn-success btn-sm' data-bs-dismiss='modal'>
                Confirm
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className='mb-3'>
        <div className='d-flex align-items-center '>
          <a
            className='btn btn-icon btn-bg-light btn-active-color-info btn-sm me-3'
            onClick={() => navigate(-1)}
          >
            <i className='bi bi-arrow-left-circle ' style={{fontSize: '28px'}}></i>
            {/* <i className='bi bi-arrow-left-circle-fill' s></i> */}
          </a>
          <div className=''>
            <h1 className='mb-0 fw-bold mb-2' style={{fontSize: '25px', lineHeight: '36px'}}>
              Appointment Viewer
            </h1>

            <p className='text-gray-500 fs-5'>Manage Appointment and Notes</p>
          </div>
        </div>
      </div>

      {/* {currentUser?.result?.userType === 'SYSTEM' && (
        <div className='d-flex justify-content-between align-items-center  px-3 py-2 mb-2 rounded shadow-sm bg-white'>
          <div>
            <span className='text-dark fs-7 fw-semibold'>
            </span>
          </div>
          <div>
            <span className='badge badge-info me-2'>{countInterpretersByStatus(0)} Invited</span>
            <span className='badge badge-primary me-2'>
              {countInterpretersByStatus(1)} Accepted
            </span>
            <span className='badge  badge-success me-2'>
              {countInterpretersByStatus(3)} Confirmed
            </span>
            <span className='badge  badge-secondary me-2'>
              {countInterpretersByStatus(2)} Declined
            </span>
            <span className='badge  badge-danger me-2'>{countInterpretersByStatus(4)} Reject</span>
          </div>
        </div>
      )} */}

      <div className='card mb-5 mb-xl-5 shadow-sm' style={{borderTop: '3px solid #a3a242'}}>
        <div className='card-body pt-9 pb-0'>
          <div className='d-flex flex-wrap flex-sm-nowrap mb-3'>
            <div className='me-7 mb-4'>
              <div className='symbol symbol-100px symbol-lg-125px symbol-fixed position-relative'>
                <img
                  src={toAbsoluteUrl('../media/avatars/appointment.gif')}
                  alt='appointment'
                  className='rounded-sm'
                />
                {/* <div className='position-absolute translate-middle bottom-0 start-100 mb-6 bg-success rounded-circle border border-4 border-white h-20px w-20px'></div> */}
              </div>
              {showActionsMenu && (
                <AppointmentActionsDropdown
                  showEditActions={showEditActions}
                  showCancelActions={showCancelActions}
                  showAddNoteAction={showAddNoteAction}
                  showViewClientNotesAction={showViewClientNotesAction}
                  showRebroadcastAction={showRebroadcastAction}
                  isRecurring={Boolean(appointmentDetails?.isRecurring)}
                  editSeriesDisabled={
                    !(
                      appointmentDetails?.statusName === 'NoInterpreter' ||
                      appointmentDetails?.statusName === 'Open'
                    )
                  }
                  onEditOccurrence={() => navigate(`/edit-appointment/${id}?isBulk=false`)}
                  onEditSeries={() => navigate(`/edit-appointment/${id}?isBulk=true`)}
                  onCancelOccurrence={handleCancelOccurrenceClick}
                  onCancelSeries={handleCancelSeriesClick}
                  onAddNote={handleOpenAddNoteModal}
                  onViewClientNotes={() => setShowClientNotesModal(true)}
                  onRebroadcast={() => setIsRebroadcastModalOpen(true)}
                />
              )}
            </div>

            <div className='flex-grow-1'>
              <div className='d-flex justify-content-between align-items-start flex-wrap mb-2'>
                <div className='d-flex flex-column'>
                  <div className='d-flex align-items-center mb-2'>
                    <a
                      href={
                        appointmentDetails?.fK_Customer &&
                        currentUser?.result?.userType !== 'INTERPRETER'
                          ? `/customers/${appointmentDetails.fK_Customer}`
                          : undefined
                      }
                      target='_blank'
                      rel='noopener noreferrer'
                      className='text-gray-800 text-hover-primary fs-2 fw-bolder me-1 text-uppercase'
                    >
                      {appointmentDetails?.customerName ?? 'N/A'}
                    </a>
                    {appointmentDetails?.communicationTypeIdentification !== 'ON_SITE' && (
                      <span className='badge badge-dark ms-3 py-3 px-4 fs-8'>
                        {' '}
                        Meeting code : {appointmentDetails?.meetingPinCode}
                      </span>
                    )}
                    <span
                      className='badge badge-success ms-3 py-3 px-4 fs-8'
                      style={{
                        backgroundColor: AppointmentStatus(appointmentDetails?.statusName).color,
                        color: appointmentDetails?.statusName === 'Canceled' ? 'black' : 'white',
                      }}
                    >
                      Status : {AppointmentStatus(appointmentDetails?.statusName).label}
                    </span>
                    {currentUser?.result.userType === 'SYSTEM' && appointmentDetails?.status == 6 && (() => {
                    const { noLinguist, billable, payable } = appointmentDetails || {};
                    let badgeText = '';
                    let badgeClass = 'badge-muted';
                    
                    if (noLinguist) {
                      badgeText = 'Linguist No Show';
                      badgeClass = 'badge-danger';
                    } else if (billable && payable) {
                      badgeText = 'Billable & Payable';
                      badgeClass = 'badge-warning';
                    } else if (billable) {
                      badgeText = 'Billable';
                      badgeClass = 'badge-info';
                    } else if (payable) {
                      badgeText = 'Payable';
                      badgeClass = 'badge-primary';
                    } else {
                      badgeText = 'Normal Cancellation';
                      badgeClass = 'badge-secondary';
                    }
                    
                    return (
                      <span className={`badge ${badgeClass} ms-3 py-3 px-4 fs-8`}>
                        {badgeText}
                      </span>
                    );
                  })()}
                  
                  </div>

                  <div className='d-flex flex-wrap fw-semibold fs-6 mb-2 pe-2 '>
                    <div className='d-flex flex-column'>
                      <a className='d-flex align-items-center text-gray-600 text-hover-primary me-5 mb-2'>
                        <i className='bi bi-calendar3 me-2'></i>
                        {moment(appointmentDetails?.startTime).format('MM/DD/YYYY, dddd')}{' '}
                        {moment(appointmentDetails.startTime).format('h:mm A')} -{' '}
                        {moment(appointmentDetails?.endTime).format('MM/DD/YYYY, dddd')}{' '}
                        {moment(appointmentDetails.endTime).format('h:mm A')}
                      </a>
                      <span className='text-gray-500 fs-8 ms-4'>
                        {appointmentDetails?.timeZoneName ?? 'N/A'}
                      </span>
                    </div>
                  </div>
                </div>

                <div className='d-flex flex-row'>
                  {currentUser?.result?.userType === 'INTERPRETER' && 
                    appointmentDetails?.status == 2 
                    && appointmentDetails?.communicationTypeIdentification != 'ON_SITE' 
                    && appointmentDetails?.communicationTypeIdentification != 'THIRD_PART_PLATFORM'  
                    && (
                    <CCPStatusButton 
                      text='Start Session' 
                      appointmentId={appointmentDetails?.code}
                      hasSessionStarted = {appointmentDetails.hasSessionStarted}
                      appointmentStartTime={appointmentDetails?.startTime}
                    />
                  )}

                  {currentUser?.result.userType === 'INTERPRETER' &&
                    appointmentDetails?.assignStatus == 0 && appointmentDetails?.status !== 6 && (
                      <div className='d-flex justify-content-end'>
                        <OverlayTrigger
                          placement='top'
                          overlay={<Tooltip id='tooltip-filter'>Mark Available</Tooltip>}
                        >
                          <div className='d-flex justify-content-start flex-shrink-0 me-2'>
                            <button
                              className='btn btn-success btn-sm h-35px'
                              disabled={isLoadingAccept}
                              onClick={() =>
                                handleAcceptReject(
                                  1,
                                  appointmentDetails?.code,
                                  currentUser?.result?.code
                                )
                              }
                            >
                              Available
                            </button>
                          </div>
                        </OverlayTrigger>
                        <OverlayTrigger
                          placement='top'
                          overlay={<Tooltip id='tooltip-filter'>Mark Unavailable</Tooltip>}
                        >
                          <div className='d-flex justify-content-end flex-shrink-0 me-2'>
                            <button
                              className='btn btn-danger btn-sm h-35px'
                              disabled={isLoadingAccept}
                              onClick={() =>
                                handleAcceptReject(
                                  2,
                                  appointmentDetails?.code,
                                  currentUser?.result?.code
                                )
                              }
                            >
                              Unavailable
                            </button>
                          </div>
                        </OverlayTrigger>
                      </div>
                    )}

                  {(appointmentDetails?.status === 2 ||
                    appointmentDetails?.status === 4 ||
                    appointmentDetails?.status === 5 ||
                    appointmentDetails?.status === 6 ||
                    appointmentDetails?.status === 7 ||
                    appointmentDetails?.status === 9) &&
                    (appointmentDetails?.communicationTypeIdentification === 'ON_SITE' || appointmentDetails?.communicationTypeIdentification === 'THIRD_PART_PLATFORM') && (
                      <OverlayTrigger
                        placement='bottom'
                        overlay={<Tooltip id='tooltip-filter'>Download VOS Form</Tooltip>}
                      >
                        <div className='d-flex align-items-center mb-2 me-2'>
                          <button
                            onClick={() => fillVOSForm()}
                            className='btn btn-sm btn-primary btn-icon px-4'
                          >
                            <KTSVG
                              path='/media/icons/duotune/files/fil017.svg'
                              className='svg-icon-muted'
                            />
                          </button>
                        </div>
                      </OverlayTrigger>
                    )}

                  {(appointmentDetails?.status === 2 ||
                    appointmentDetails?.status === 7 ||
                    appointmentDetails?.status === 9 ||
                    appointmentDetails?.status === 10) &&
                    (currentUser?.result.userType === 'INTERPRETER' ||
                      currentUser?.result.userType === 'SYSTEM') &&
                    (appointmentDetails?.communicationTypeIdentification === 'ON_SITE' || appointmentDetails?.communicationTypeIdentification === 'THIRD_PART_PLATFORM') && (
                      <OverlayTrigger
                        placement='bottom'
                        overlay={
                          <Tooltip id='tooltip-filter'>
                            {appointmentDetails?.status === 7 || appointmentDetails?.status === 10
                              ? 'Re-submit VOS Form'
                              : 'Add Complete Appointment'}
                          </Tooltip>
                        }
                      >
                        <div className='d-flex align-items-center mb-2 me-2'>
                          <button
                            type='button'
                            className='btn btn-sm btn-primary px-4'
                            data-bs-toggle='modal'
                            data-bs-target='#kt_add_osi_details'
                            data-bs-backdrop='static'
                            data-bs-keyboard='false'
                            onClick={() => {
                              setOsiEdit(false)
                              setShowOsiReadOnly(false)
                              setIsResubmit(
                                appointmentDetails?.status === 7 || appointmentDetails?.status === 10
                              )
                              const appointmentStartTime = appointmentDetails?.startTime
                                ? moment(appointmentDetails.startTime).format('YYYY-MM-DD HH:mm')
                                : ''
                              const appointmentEndTime = appointmentDetails?.endTime
                                ? moment(appointmentDetails.endTime).format('YYYY-MM-DD HH:mm')
                                : ''
                              const startTimeHm = appointmentDetails?.startTime
                                ? moment(appointmentDetails.startTime).format('HH:mm')
                                : ''
                              const endTimeHm = appointmentDetails?.endTime
                                ? moment(appointmentDetails.endTime).format('HH:mm')
                                : ''
                              const isThirdParty =
                                appointmentDetails?.communicationTypeIdentification ===
                                'THIRD_PART_PLATFORM'
                              // Bot times prefill only from a successful ('done') meeting with real
                              // interpreter join/leave events (BotAdmission = coarse meeting window).
                              const botTimesUsable =
                                isThirdParty &&
                                isBotMeetingSuccessful &&
                                recallSession?.checkInSource !== RecallCheckInSource.BotAdmission
                              const botCheckInHm =
                                botTimesUsable && recallSession?.interpreterCheckInAtUtc
                                  ? moment(recallSession.interpreterCheckInAtUtc).format('HH:mm')
                                  : ''
                              const botCheckOutHm =
                                botTimesUsable && recallSession?.interpreterCheckOutAtUtc
                                  ? moment(recallSession.interpreterCheckOutAtUtc).format('HH:mm')
                                  : ''
                              // A submitted VOS form overrides bot-recorded times.
                              const hasSubmittedVos = !!meetingSummary?.code
                              const shouldClearThirdPartyEndTime =
                                isThirdParty && !botCheckOutHm && !hasSubmittedVos
                              const prefillStartDateTime =
                                initialValuesOSI?.startDateTime || appointmentStartTime
                              const prefillEndDateTime =
                                initialValuesOSI?.endDateTime || appointmentEndTime
                              const prefillStartTimeHm =
                                hasSubmittedVos && initialValuesOSI?.startTime
                                  ? initialValuesOSI.startTime
                                  : botCheckInHm || initialValuesOSI?.startTime || startTimeHm
                              const prefillEndTimeHm =
                                hasSubmittedVos && initialValuesOSI?.endTime
                                  ? initialValuesOSI.endTime
                                  : botCheckOutHm ||
                                    (shouldClearThirdPartyEndTime
                                      ? ''
                                      : initialValuesOSI?.endTime || endTimeHm)
                              setInitialValuesOSI({
                                ...initialValuesOSI,
                                ...(appointmentDetails?.status === 7 || appointmentDetails?.status === 10
                                  ? {code: ''}
                                  : {}),
                                startDateTime: prefillStartDateTime,
                                endDateTime: prefillEndDateTime,
                                startTime: prefillStartTimeHm,
                                endTime: prefillEndTimeHm,
                              })
                            }}
                          >
                            <KTSVG
                              path='/media/icons/duotune/general/gen016.svg'
                              className='svg-icon-muted '
                            />
                            {appointmentDetails?.status === 7 || appointmentDetails?.status === 10
                              ? 'Re-submit'
                              : 'Submit'}
                          </button>
                        </div>
                      </OverlayTrigger>
                    )}
                </div>
              </div>
              {!isLoading && (
                <AddOSIDetails
                  initialValues={initialValuesOSI}
                  fetchAfterSubmitOSISubmmission={fetchAfterSubmitOSISubmmission}
                  expenseList={expenseList}
                  setExpenseList={setExpenseList}
                  isOsiEdit={isOsiEdit}
                  readOnly={showOsiReadOnly}
                  appointmentDetails={appointmentDetails}
                  payableHours={appointmentDetails?.payableHours}
                  hourlyRate={interpreters?.find((interpreter: any) => interpreter?.assignStatus === 3 || interpreter?.assignStatus === 6)?.rate || appointmentDetails?.rate}
                  meetingSummaryStatus={meetingSummary?.status}
                  onRevertApproval={handleRevertApproval}
                  isResubmit={isResubmit}
                  meetingSummary={meetingSummary}
                  showUpdateAndApprove={hideOsiApproveForRequesterDispute}
                  botRecordedTimes={
                    isBotMeetingSuccessful
                      ? {
                          start: recallSession?.interpreterCheckInAtUtc
                            ? moment(recallSession.interpreterCheckInAtUtc).format('hh:mm A')
                            : null,
                          end: recallSession?.interpreterCheckOutAtUtc
                            ? moment(recallSession.interpreterCheckOutAtUtc).format('hh:mm A')
                            : null,
                          timeZoneName: appointmentDetails?.timeZoneName ?? null,
                        }
                      : null
                  }
                  onEditWithoutUnlinking={() => setShowEditWithoutUnlinkingWarning(true)}
                  isEditWithoutUnlinking={isEditWithoutUnlinking}
                  setIsEditWithoutUnlinking={setIsEditWithoutUnlinking}
                  setShowOsiReadOnly={setShowOsiReadOnly}
                />
              )}

              <EditWithoutUnlinkingWarningModal
                show={showEditWithoutUnlinkingWarning}
                onClose={() => setShowEditWithoutUnlinkingWarning(false)}
                onProceed={() => {
                  setShowEditWithoutUnlinkingWarning(false)
                  setShowOsiReadOnly(false)
                  setOsiEdit(true)
                  setIsEditWithoutUnlinking(true)
                }}
              />

              <div className='separator mt-0 mb-2'></div>
              <div className='d-flex flex-wrap justify-content-start'>
                <div className='d-flex flex-column flex-grow-1 pe-4 '>
                  <div className='d-flex flex-wrap'>
                    <div className='card-body p-0'>
                      <div className='row mb-3'>
                        <label className='col-lg-4 fw-bold text-black fs-6'>ID </label>
                        <div className='col-lg-8'>
                          <span className='fs-6 text-gray-900'>: {appointmentDetails?.code}</span>
                        </div>
                      </div>
                      <div className='row mb-3'>
                        <label className='col-lg-4 fw-bold text-black fs-6'>
                          Record id
                        </label>
                        <div className='col-lg-8 fv-row'>
                          <span className='fs-6'>: {appointmentDetails?.recordId}</span>
                        </div>
                      </div>
                      <div className='row mb-3'>
                        <label className='col-lg-4 fw-bold text-black fs-6'>
                          Communication Type{' '}
                        </label>
                        <div className='col-lg-8 fv-row'>
                          <span className='fs-6'>: {appointmentDetails?.communicationType}</span>
                        </div>
                      </div>
                      <div className='row mb-3'>
                        <label className='col-lg-4 fw-bold text-black fs-6'>Requirements</label>
                        <div className='col-lg-8 d-flex align-items-center'>
                          <span className=' fs-6 me-2'>
                            : {appointmentDetails?.languageFrom ?? '-'} -{' '}
                            {appointmentDetails?.languageTo ?? '-'} Interpreter
                          </span>
                        </div>
                      </div>
                      <div className='row mb-3'>
                        <label className='col-lg-4 fw-bold text-black fs-6'>Recurrence</label>
                        <div className='col-lg-8'>
                          <span className='fs-6 text-gray-900'>
                            : {appointmentDetails?.recurrenceName ?? 'N/A'}
                          </span>
                        </div>
                      </div>
                      {/* <div className='row mb-3'>
                        <label className='col-lg-4 fw-bold text-black fs-6'>Subject</label>
                        <div className='col-lg-8'>
                          <span className='fs-6 text-gray-900'>
                            : {appointmentDetails?.subject ?? 'N/A'}
                          </span>
                        </div>
                      </div> */}
                      <div className='row mb-3'>
                        <label className='col-lg-4 fw-bold text-black fs-6'>Interpreter Gender Preference</label>
                        <div className='col-lg-8'>
                          <span className='fs-6 text-gray-900'>
                            : {appointmentDetails?.gender ?? 'N/A'}
                          </span>
                        </div>
                      </div>
                      <div className='row mb-3'>
                        <label className='col-lg-4 fw-bold text-black fs-6'>Consumer</label>
                        <div className='col-lg-8'>
                          <span className='fs-6 text-gray-900'>
                            :{' '}
                            {appointmentDetails?.consumer === '' ||
                            appointmentDetails?.consumer === null
                              ? 'N/A'
                              : appointmentDetails?.consumer}
                          </span>
                        </div>
                      </div>
                      <div className='row mb-3'>
                        <label className='col-lg-4 fw-bold text-black fs-6'>Description</label>
                        <div className='col-lg-8'>
                          <span className='fs-6 text-gray-900'>
                            :{' '}
                            {appointmentDetails?.description === '' ||
                            appointmentDetails?.description === null
                              ? 'N/A'
                              : appointmentDetails?.description}
                          </span>
                        </div>
                      </div>
                      {appointmentDetails?.communicationTypeIdentification === 'ON_SITE' && (
                        <div className='row mb-3'>
                          <label className='col-lg-4 fw-bold text-black fs-6'>Location</label>
                          <div className='col-lg-8 d-flex align-items-center'>
                            <span className=' fs-6 me-2'>
                              :{' '}
                              {appointmentDetails?.address === ''
                                ? 'N/A'
                                : appointmentDetails?.address}
                            </span>
                          </div>
                        </div>
                      )}
                      
                      {appointmentDetails?.communicationTypeIdentification ===
                        'THIRD_PART_PLATFORM' && (appointmentDetails?.status == 2 || appointmentDetails?.status == 5 || appointmentDetails?.status == 7) && (
                          <div>
                            <div className='row mb-3'>
                              <label className='col-lg-4 fw-bold text-black fs-6'>Meeting Link</label>
                              <div className='col-lg-8 d-flex align-items-center'>
                                <span
                                  className=' fs-6 me-2 text-nowrap'
                                  style={{
                                    textOverflow: 'ellipsis',
                                    width: '200px',
                                    overflow: 'hidden',
                                    flexGrow: '1',
                                  }}
                                >
                                  :{' '}
                                  {appointmentDetails?.virtualAddress === '' ? (
                                    'N/A'
                                  ) : (
                                    <a
                                      href={
                                        appointmentDetails.virtualAddress?.startsWith('http')
                                          ? appointmentDetails.virtualAddress
                                          : `https://${appointmentDetails.virtualAddress}`
                                      }
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      style={{ color: '#181C32', textDecoration: 'underline' }}
                                    >
                                      {appointmentDetails.virtualAddress}
                                    </a>


                                  )}
                                </span>
                              </div>
                            </div>

                            <InterpreterJoinNameHint />

                            <div className='row mb-3'>
                              <label className='col-lg-4 fw-bold text-black fs-6'>Pin</label>
                              <div className='col-lg-8 d-flex align-items-center'>
                                <span className=' fs-6 me-2'>
                                  :{' '}
                                  {appointmentDetails?.pin === '' || appointmentDetails?.pin === null
                                    ? 'N/A'
                                    : appointmentDetails?.pin}
                                </span>
                              </div>
                            </div>

                            <div className='row mb-3'>
                              <label className='col-lg-4 fw-bold text-black fs-6'>
                                Meeting ID / Caller Number
                              </label>
                              <div className='col-lg-8 d-flex align-items-center'>
                                <span className=' fs-6 me-2'>
                                  :{' '}
                                  {appointmentDetails?.callerNumber === '' ||
                                    appointmentDetails?.callerNumber === null
                                    ? 'N/A'
                                    : appointmentDetails?.callerNumber}
                                </span>
                              </div>
                            </div>

                            <div className='row mb-3'>
                              <label className='col-lg-4 fw-bold text-black fs-6'>Remarks</label>
                              <div className='col-lg-8 d-flex align-items-center'>
                                <span className=' fs-6 me-2'>
                                  :{' '}
                                  {appointmentDetails?.remarks === '' ||
                                    appointmentDetails?.remarks === null
                                    ? 'N/A'
                                    : appointmentDetails?.remarks}
                                </span>
                              </div>
                            </div>


                          </div>
                        )}
                    </div>
                  </div>
                </div>
                <div className='d-flex flex-column flex-grow-1 pe-4 '>
                  <div className='d-flex flex-wrap'>
                    <div className='card-body p-0'>
                      {currentUser?.result.userType === 'SYSTEM' && (
                        <>
                          <div className='row mb-3'>
                            <label className='col-lg-4 fw-bold text-black fs-6'>
                              Account Priority{' '}
                            </label>
                            <div className='col-lg-8'>
                              <span className='fs-6 text-gray-900'>
                                : {appointmentDetails?.accountPriorityName ?? 'N/A'}
                              </span>
                            </div>
                          </div>
                          <div className='row mb-3'>
                            <label className='col-lg-4 fw-bold text-black fs-6'>
                              Interpreter Priority{' '}
                            </label>
                            <div className='col-lg-8'>
                              <span className='fs-6 text-gray-900'>
                                : {appointmentDetails?.interpreterPriorityName ?? 'N/A'}
                              </span>
                            </div>
                          </div>
                        </>
                      )}

                      <div className='row mb-3'>
                        <label className='col-lg-4 fw-bold text-black fs-6'>
                          Service Delivery{' '}
                        </label>
                        <div className='col-lg-8 fv-row'>
                          <span className='fs-6'>: {appointmentDetails?.serviceType ?? 'N/A'}</span>
                        </div>
                      </div>
                      <div className='row mb-3'>
                        <label className='col-lg-4 fw-bold text-black fs-6'>Requester</label>
                        <div className='col-lg-8 d-flex align-items-center'>
                          <span className=' fs-6 me-2'>
                            : {appointmentDetails?.requesterName ?? 'N/A'}
                          </span>
                        </div>
                      </div>
                      {/*<div className='card-body p-0'>
                        <div className='row mb-3'>
                          <label className='col-lg-4 fw-bold text-black fs-6'>Notes for PM </label>
                          <div className='col-lg-8 fv-row'>
                            <span className='fs-6'>
                              :{' '}
                              {appointmentDetails?.notePM === '' ||
                              appointmentDetails?.notePM === null
                                ? 'N/A'
                                : appointmentDetails?.notePM}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className='card-body p-0'>
                        <div className='row mb-3'>
                          <label className='col-lg-4 fw-bold text-black fs-6'>
                            Notes for Interpreter{' '}
                          </label>
                          <div className='col-lg-8 fv-row'>
                            <span className='fs-6'>
                              :{' '}
                              {appointmentDetails?.noteInterpreter === '' ||
                              appointmentDetails?.noteInterpreter === null
                                ? 'N/A'
                                : appointmentDetails?.noteInterpreter}
                            </span>
                          </div>
                        </div>
                      </div>*/}

                      <div className='card-body p-0'>
                        <div className='row mb-3'>
                          <label className='col-lg-4 fw-bold text-black fs-6'>
                            Appointed Interpreter{' '}
                          </label>
                          <div className='col-lg-8 fv-row d-flex align-items-center gap-2'>
                            <span>
                              :{' '}
                              {appointmentDetails?.confirmedInterpreterName === 'Pending' ? (
                                <label className='badge badge-warning ms-3 py-3 px-4 fs-8'>
                                  Pending
                                </label>
                              ) : (
                                appointmentDetails?.confirmedInterpreterName
                              )}
                            </span>
                            {showViewInterpreterNotes && confirmedInterpreter?.fK_Interpreter && (
                              <InterpreterNotesButton
                                interpreterId={confirmedInterpreter?.fK_Interpreter}
                                onClick={() => setNotesInterpreter(confirmedInterpreter)}
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='card mb-5'>
        <div
          className='card-header py-0'
          style={{minWidth: '300px', overflowX: 'auto', minHeight: '40px'}}
        >
          <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-semibold flex-nowrap'>
            {currentUser?.result?.userType === 'SYSTEM' && (
              <li className='nav-item'>
                <a
                  className={`nav-link fs-7 text-gray-400   ${
                    activeTab === 1 ? 'text-active-dark fw-bold active show' : ''
                  }`}
                  data-bs-toggle='tab'
                  href='#kt_tab_pane_1'
                  onClick={() => handleTabClick(1)}
                >
                  Overview
                </a>
              </li>
            )}
            <li className='nav-item'>
              <a
                className={`nav-link fs-7 text-gray-400 ${
                  activeTab === 2 ? 'text-active-dark fw-bold active show' : ''
                }`}
                data-bs-toggle='tab'
                href='#kt_tab_pane_2'
                onClick={() => handleTabClick(2)}
              >
                Activities
              </a>
            </li>
            {(currentUser?.result?.userType === 'SYSTEM') &&
              (appointmentDetails?.status == 2 || appointmentDetails?.status == 5 || appointmentDetails?.status == 7 || (appointmentDetails?.status === 6 && (appointmentDetails?.payable || appointmentDetails?.billable))) && (
                 <li className='nav-item'>
                  <a
                    className={`nav-link fs-7 text-gray-400 ${
                      activeTab === 3 ? 'text-active-dark fw-bold active show' : ''
                    }`}
                    data-bs-toggle='tab'
                    href='#kt_tab_pane_3'
                    onClick={() => handleTabClick(3)}
                  >
                    Billing
                  </a>
                </li>
                  // <li className='nav-item'>
                  //   <a
                  //     className={`nav-link fs-7 text-gray-400 disabled-tab`}
                  //     style={{pointerEvents: 'none', opacity: 0.5, cursor: 'not-allowed'}}
                  //     tabIndex={-1}
                  //   >
                  //     Billing
                  //   </a>
                  // </li>
                
              )}

            <li className='nav-item'>
              <a
                className={`nav-link fs-7 text-gray-400 ${
                  activeTab === 4 ? 'text-active-dark fw-bold active show' : ''
                }`}
                data-bs-toggle='tab'
                href='#kt_tab_pane_4'
                onClick={() => handleTabClick(4)}
              >
                Documents
              </a>
            </li>

            {isMeetingSummaryTabVisible(appointmentDetails) && (
                <li className='nav-item'>
                  <a
                    className={`nav-link fs-7 text-gray-400 ${
                      activeTab === 5 ? 'text-active-dark fw-bold active show' : ''
                    }`}
                    data-bs-toggle='tab'
                    href='#kt_tab_pane_5'
                    onClick={() => handleTabClick(5)}
                  >
                    Meeting Summary
                  </a>
                </li>
              )}
          </ul>
        </div>
        <div className='card-body pt-0'>
          <div className=''>
            <div className='tab-content' id='myTabContent'>
              {activeTab === 1 &&
                currentUser?.result?.userType === 'SYSTEM' &&
                interpreters?.some((item: {assignStatus: number}) => item?.assignStatus === 3) && (
                  <div className='table-responsive'>
                    {/* begin::Table */}
                    <table className='table table-row-dashed table-row-gray-300 align-middle gs-2 gy-2'>
                      {/* begin::Table head */}
                      <thead>
                        <tr className='fw-semibold text-muted text-uppercase'>
                          <th className='min-w-150px text-uppercase' style={{width: '30%'}}>
                            Assigned Interpreter
                          </th>

                          <th className='min-w-100px '>Rate</th>
{/* 
                          <th className='min-w-100px'>Status</th>
                          <th className='min-w-100px'>Distance (mi)</th>
                          <th className='min-w-100px'>Travel Time (min)</th>
                          <th className='min-w-100px'>Profit Margin (%)</th> */}
                          {/* {appointmentDetails?.communicationTypeIdentification === 'ON_SITE' && (
                            <th className='min-w-100px '>Distance</th>
                          )} */}

                          <th className='min-w-100px'>Status</th>
                          <th className='min-w-100px'>Distance (mi)</th>
                          <th className='min-w-100px'>Travel Time (min)</th>
                          <th className='min-w-100px'>Profit Margin (%)</th>
                          {appointmentDetails?.status === 2 &&
                          currentUser?.result.userType === 'SYSTEM' ? (
                            <th className='min-w-100px text-end'>Action</th>
                          ) : (
                            <th className='min-w-100px text-end'>Conflicts</th>
                          )}
                        </tr>
                      </thead>
                      {/* end::Table head */}
                      {/* begin::Table body */}
                      <tbody>
                        {interpreters?.length > 0 ? (
                          interpreters
                            .filter((item: any) => item?.assignStatus === 3)
                            .map((item: any) => (
                              <tr>
                                <td>
                                  <Link
                                    to={`/profile/${item?.fK_Interpreter}`}
                                    target='_blank'
                                    rel='noopener noreferrer'
                                  >
                                    <a className='text-gray-800 text-hover-primary fs-6'>
                                      <div className='d-flex align-items-center'>
                                        {item.profileImage !== '' || item.profileImage !== null ? (
                                          <div className='symbol symbol-45px me-5 rounded-circle'>
                                            <ProfileImg
                                              imagePath={item.profileImage}
                                              alt=''
                                              className='rounded-circle'
                                            />
                                          </div>
                                        ) : (
                                          <div className='symbol symbol-circle symbol-45px overflow-hidden me-3'>
                                            <div
                                              className={clsx(
                                                'symbol-label fs-4',
                                                'badge-light-success',
                                                `bg-light-success`
                                              )}
                                            >
                                              <span style={{fontSize: '20x'}}>
                                                {(item?.name ?? '').charAt(0).toUpperCase() +
                                                  (item?.name ?? '').charAt(1).toUpperCase()}
                                              </span>
                                            </div>
                                          </div>
                                        )}
                                        <div className='d-flex justify-content-start '>
                                          <div className='text-gray-900 fw-bold text-hover-primary fs-6'>
                                            {item?.name ?? 'N/A'}
                                          </div>
                                        </div>
                                      </div>
                                    </a>
                                  </Link>
                                </td>

                                {currentUser?.result.userType === 'SYSTEM' && (
                                  <td>
                                    {item?.appointmentCharges ? (
                                      <a className='text-gray-800 text-hover-primary fs-6 fw-bold'>
                                        ${item?.appointmentCharges?.interpreterUpdatedRate ?? 'N/A'}
                                        <button
                                          style={{
                                            all: 'unset',
                                            fontWeight: 'bold',
                                            cursor: 'pointer',
                                          }}
                                          data-bs-toggle='modal'
                                          data-bs-target='#edited_rates_model'
                                          onClick={() =>
                                            setForcefullyAssignInterpretersConfirmDetails({
                                              statusId: 3,
                                              appointmentId: item?.code ?? '',
                                              interpreterId: item?.fK_Interpreter ?? '',
                                              currentStatus: item?.assignStatus ?? 0,
                                              rate: String(
                                                item?.appointmentCharges?.interpreterUpdatedRate ??
                                                  0
                                              ),
                                              name: item?.name ?? '',
                                              customer: item?.customer ?? 0,
                                              appointmentCharges: item?.appointmentCharges ?? {},
                                              isEdited: true,
                                              customerRateId: appointmentDetails?.customerRateId,
                                              interpreterRateId: item?.interpreterRateId,
                                            })
                                          }
                                        >
                                          {!(item?.appointmentCharges?.interpreterUpdatedRate == item?.appointmentCharges?.interpreterRate) ? "(Edited)" : ""}

                                        </button>
                                      </a>
                                    ) : (
                                      <a className='text-gray-800 text-hover-primary fs-6'>
                                        ${item?.rate ?? 'N/A'}
                                      </a>
                                    )}
                                  </td>
                                )}

                                <td>{statusMapping[item?.assignStatus]}</td>

                                <td>
                                  {item?.distance !== undefined && item?.distance !== null
                                    ? item.distance
                                    : 'N/A'}
                                </td>
                                <td>
                                  {item?.travelTime !== undefined && item?.travelTime !== null
                                    ? item.travelTime
                                    : 'N/A'}
                                </td>
                                <td>
                                  {item?.customerRate &&
                                  item?.appointmentCharges &&
                                  !isNaN(Number(item.customerRate)) &&
                                  !isNaN(
                                    Number(item?.appointmentCharges?.interpreterUpdatedRate)
                                  ) &&
                                  Number(item.customerRate) !== 0
                                    ? (
                                        ((Number(item.customerRate) -
                                          Number(
                                            item?.appointmentCharges?.interpreterUpdatedRate || 0
                                          )) /
                                          Number(item.customerRate)) *
                                        100
                                      ).toFixed(1) + '%'
                                    : 'N/A'}
                                </td>

                                {/* {appointmentDetails?.communicationTypeIdentification ===
                                  'ON_SITE' && (
                                  <td>
                                    <a className='text-gray-800 text-hover-primary fs-6'>
                                      {item?.distance ?? 'N/A'}
                                    </a>
                                  </td>
                                )} */}

                                {currentUser?.result.userType === 'SYSTEM' &&
                                appointmentDetails?.status === 2 ? (
                                  <td>
                                    <div className='d-flex justify-content-end align-items-center gap-2'>
                                      {showViewInterpreterNotes && (
                                        <InterpreterNotesButton
                                          interpreterId={item?.fK_Interpreter}
                                          onClick={() => setNotesInterpreter(item)}
                                        />
                                      )}
                                      <OverlayTrigger
                                        placement='bottom'
                                        overlay={<Tooltip id='tooltip-filter'>Unassign</Tooltip>}
                                      >
                                        <div className='d-flex'>
                                          <button
                                            type='button'
                                            className='btn btn-sm btn-danger btn-icon px-4'
                                            data-bs-toggle='modal'
                                            data-bs-target='#cancel-assign-interperter-modal'
                                            data-bs-backdrop='static'
                                            data-bs-keyboard='false'
                                            onClick={() => {
                                              setInitialValueUnassignConfirmedInterperter({
                                                appointmentId: item?.fK_appoinment,
                                                interpreterId: item?.fK_Interpreter,
                                                reason: '',
                                                additionalInfo: '',
                                              })
                                              setUnassignFormKey((key) => key + 1)
                                              loadUnassignmentReasons()
                                            }}
                                          >
                                            <i className='bi bi-x-circle'></i>
                                          </button>
                                        </div>
                                      </OverlayTrigger>
                                    </div>
                                  </td>
                                ) : (
                                  <td>
                                    <div className='d-flex justify-content-end align-items-center gap-2'>
                                      {showViewInterpreterNotes && (
                                        <InterpreterNotesButton
                                          interpreterId={item?.fK_Interpreter}
                                          onClick={() => setNotesInterpreter(item)}
                                        />
                                      )}
                                    </div>
                                  </td>
                                )}
                              </tr>
                            ))
                        ) : (
                          <tr>
                            <td colSpan={7}>
                              <div className='py-5 d-flex flex-column align-content-center justify-content-center'>
                                <div className='text-center'>
                                  <div className='symbol symbol-200px '>
                                    <img src='/media/other/nodata.png' alt='' />
                                  </div>
                                </div>
                                <div className='d-flex text-center w-100 align-content-center justify-content-center fw-semibold fs-3 text-gray-400'>
                                  No matching records found
                                </div>
                              </div>
                            </td>
                          </tr>
                        )}
                      </tbody>

                      {/* end::Table body */}
                    </table>
                    {/* end::Table */}
                  </div>
                )}
              {activeTab === 1 && currentUser?.result?.userType === 'SYSTEM' && (
                <>
                  <AiAgentBanner
                    summary={aiAssignmentSummary}
                    onOpenActivity={() => setIsSmsActivityOpen(true)}
                  />

                  {countInterpretersByStatus(3) > 0 ? (
                    <div className='accordion' id='kt_accordion_1'>
                      <div className='accordion-item'>
                        <h2 className='accordion-header' id='kt_accordion_1_header_1'>
                          <button
                            className='accordion-button fs-4 fw-bold collapsed'
                            type='button'
                            data-bs-toggle='collapse'
                            data-bs-target='#kt_accordion_1_body_1'
                            aria-expanded='false'
                            aria-controls='kt_accordion_1_body_1'
                          >
                            Invited & Rejected Interpreters (
                            {interpreters?.length - countInterpretersByStatus(3)})
                          </button>
                        </h2>
                        <div
                          id='kt_accordion_1_body_1'
                          className='accordion-collapse collapse'
                          aria-labelledby='kt_accordion_1_header_1'
                          data-bs-parent='#kt_accordion_1'
                        >
                          <div className='accordion-body'>
                            <div className='table-responsive'>
                              {/* Table Begin */}
                              <table className='table table-row-dashed table-row-gray-300 align-middle gs-2 gy-2'>
                                <thead>
                                  <tr className='fw-semibold text-muted text-uppercase'>
                                    <th
                                      className='min-w-150px text-uppercase'
                                      style={{width: '30%', cursor: 'pointer'}}
                                      onClick={() => handleSort('name')}
                                    >
                                      Name{' '}
                                      {sortColumn === 'name' &&
                                        (sortDirection === 'asc' ? '▲' : '▼')}
                                    </th>
                                    <th
                                      className='min-w-100px'
                                      style={{cursor: 'pointer'}}
                                      onClick={() => handleSort('rate')}
                                    >
                                      Rate{' '}
                                      {sortColumn === 'rate' &&
                                        (sortDirection === 'asc' ? '▲' : '▼')}
                                    </th>
                                    <th
                                      className='min-w-100px'
                                      style={{cursor: 'pointer'}}
                                      onClick={() => handleSort('assignStatus')}
                                    >
                                      Status{' '}
                                      {sortColumn === 'assignStatus' &&
                                        (sortDirection === 'asc' ? '▲' : '▼')}
                                    </th>
                                    <th
                                      className='min-w-100px'
                                      style={{cursor: 'pointer'}}
                                      onClick={() => handleSort('distance')}
                                    >
                                      Distance (mi){' '}
                                      {sortColumn === 'distance' &&
                                        (sortDirection === 'asc' ? '▲' : '▼')}
                                    </th>
                                    <th
                                      className='min-w-100px'
                                      style={{cursor: 'pointer'}}
                                      onClick={() => handleSort('travelTime')}
                                    >
                                      Travel Time (min){' '}
                                      {sortColumn === 'travelTime' &&
                                        (sortDirection === 'asc' ? '▲' : '▼')}
                                    </th>
                                    <th
                                      className='min-w-100px'
                                      style={{cursor: 'pointer'}}
                                      onClick={() => handleSort('profitMargin')}
                                    >
                                      Profit Margin (%){' '}
                                      {sortColumn === 'profitMargin' &&
                                        (sortDirection === 'asc' ? '▲' : '▼')}
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {interpreters?.length > 0 ? (
                                    getSortedData(
                                      interpreters.filter((item: any) => item?.assignStatus !== 3)
                                    ).map((item: any) => (
                                      <tr key={item?.fK_Interpreter}>
                                        <td>
                                          <Link
                                    to={`/profile/${item?.fK_Interpreter}`}
                                    target='_blank'
                                    rel='noopener noreferrer'
                                  >
                                            <a className='text-gray-800 text-hover-primary fs-6'>
                                              <div className='d-flex align-items-center'>
                                                {item.profileImage ? (
                                                  <div className='symbol symbol-45px me-5 rounded-circle'>
                                                    <ProfileImg
                                                      imagePath={item.profileImage}
                                                      alt=''
                                                      className='rounded-circle'
                                                    />
                                                  </div>
                                                ) : (
                                                  <div className='symbol symbol-circle symbol-45px overflow-hidden me-3'>
                                                    <div className='symbol-label fs-4 badge-light-success bg-light-success'>
                                                      <span style={{fontSize: '20px'}}>
                                                        {(item?.name ?? 'N/A')
                                                          .slice(0, 2)
                                                          .toUpperCase()}
                                                      </span>
                                                    </div>
                                                  </div>
                                                )}
                                                <div className='d-flex justify-content-start'>
                                                  <div className='text-gray-900 fw-bold text-hover-primary fs-6'>
                                                    {item?.name ?? 'N/A'}
                                                  </div>
                                                </div>
                                              </div>
                                            </a>
                                          </Link>
                                        </td>
                                        {currentUser?.result.userType === 'SYSTEM' && (
                                          <td>
                                            <a className='text-gray-800 text-hover-primary fs-6'>
                                              ${item?.rate ?? 'N/A'}
                                            </a>
                                          </td>
                                        )}
                                        <td>{statusMapping[item?.assignStatus]}</td>
                                        <td>
                                          {item?.distance !== undefined && item?.distance !== null
                                            ? item.distance
                                            : 'N/A'}
                                        </td>
                                        <td>
                                          {item?.travelTime !== undefined &&
                                          item?.travelTime !== null
                                            ? item.travelTime
                                            : 'N/A'}
                                        </td>
                                        <td>
                                          {item?.customerRate &&
                                          item?.rate &&
                                          !isNaN(Number(item.customerRate)) &&
                                          !isNaN(Number(item.rate)) &&
                                          Number(item.customerRate) !== 0
                                            ? (
                                                ((Number(item.customerRate) - Number(item.rate)) /
                                                  Number(item.customerRate)) *
                                                100
                                              ).toFixed(1) + '%'
                                            : 'N/A'}
                                        </td>

                                        {/* {appointmentDetails?.communicationTypeIdentification ===
                                            'ON_SITE' && (
                                            <td>
                                              <a className='text-gray-800 text-hover-primary fs-6'>
                                                {item?.distance ?? 'N/A'}
                                              </a>
                                            </td>
                                          )} */}
                                        {currentUser?.result.userType === 'SYSTEM' && (
                                          <td className=''>
                                            <div className='d-flex justify-content-end align-items-center gap-2'>
                                              {showViewInterpreterNotes && (
                                                <InterpreterNotesButton
                                                  interpreterId={item?.fK_Interpreter}
                                                  onClick={() => setNotesInterpreter(item)}
                                                />
                                              )}
                                            </div>
                                          </td>
                                        )}
                                      </tr>
                                    ))
                                  ) : (
                                    <tr>
                                      <td colSpan={7}>
                                        <div className='py-5 d-flex flex-column align-content-center justify-content-center'>
                                          <div className='text-center'>
                                            <div className='symbol symbol-200px'>
                                              <img src='/media/other/nodata.png' alt='' />
                                            </div>
                                          </div>
                                          <div className='d-flex text-center w-100 align-content-center justify-content-center fw-semibold fs-3 text-gray-400'>
                                            No matching records found
                                          </div>
                                        </div>
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                              {/* Table End */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <>
                      {ipiRecommendationEnabled && getBestMatchInterpreters().length > 0 && (
                        <BestMatchesSection
                          interpreters={getBestMatchInterpreters()}
                          availableCount={
                            interpreters?.filter(
                              (item: any) =>
                                resolveAssignStatus(item?.assignStatus) !== 3 &&
                                !isInterpreterManuallyUnavailable(item?.assignStatus)
                            )?.length ?? 0
                          }
                          onAssign={handleAssignButtonClick}
                          canAssign={!isAppointmentCancelled(appointmentDetails?.status)}
                          aiAssignment={aiAssignmentSummary}
                        />
                      )}
                      {ipiRecommendationEnabled && (
                        <div className='d-flex align-items-center justify-content-between mb-1 mt-2'>
                          <h3 className='mb-0 fs-4 fw-bold'>All Available Interpreters</h3>
                        </div>
                      )}
                    <div className='table-responsive'>
                      {/* Table Begin */}
                      <table className='table table-row-dashed table-row-gray-300 align-middle gs-2 gy-2'>
                        <thead>
                          <tr className='fw-semibold text-muted text-uppercase'>
                            <th
                              className='min-w-150px text-uppercase'
                              style={{width: '30%', cursor: 'pointer'}}
                              onClick={() => handleSort('name')}
                            >
                              Name {sortColumn === 'name' && (sortDirection === 'asc' ? '▲' : '▼')}
                            </th>
                               <th className='min-w-150px text-uppercase' style={{width: '30%', cursor: 'pointer'}}>
                                Contact
                              </th>
                            {ipiRecommendationEnabled && (
                            <th
                              className='min-w-100px'
                              style={{cursor: 'pointer'}}
                              onClick={() => handleSort('recommendationScore')}
                            >
                              <span className='d-inline-flex align-items-center'>
                                <ScoreColumnHeader />
                                {sortColumn === 'recommendationScore' &&
                                  (sortDirection === 'asc' ? ' ▲' : ' ▼')}
                              </span>
                            </th>
                            )}
                            <th
                              className='min-w-100px'
                              style={{cursor: 'pointer'}}
                              onClick={() => handleSort('rate')}
                            >
                              Rate {sortColumn === 'rate' && (sortDirection === 'asc' ? '▲' : '▼')}
                            </th>
                            <th
                              className='min-w-100px'
                              style={{cursor: 'pointer'}}
                              onClick={() => handleSort('assignStatus')}
                            >
                              Status{' '}
                              {sortColumn === 'assignStatus' &&
                                (sortDirection === 'asc' ? '▲' : '▼')}
                            </th>
                            <th
                              className='min-w-100px'
                              style={{cursor: 'pointer'}}
                              onClick={() => handleSort('distance')}
                            >
                              Distance (mi){' '}
                              {sortColumn === 'distance' && (sortDirection === 'asc' ? '▲' : '▼')}
                            </th>
                            <th
                              className='min-w-100px'
                              style={{cursor: 'pointer'}}
                              onClick={() => handleSort('travelTime')}
                            >
                              Travel Time (min){' '}
                              {sortColumn === 'travelTime' && (sortDirection === 'asc' ? '▲' : '▼')}
                            </th>
                            <th
                              className='min-w-100px'
                              style={{cursor: 'pointer'}}
                              onClick={() => handleSort('profitMargin')}
                            >
                              Profit Margin (%){' '}
                              {sortColumn === 'profitMargin' &&
                                (sortDirection === 'asc' ? '▲' : '▼')}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {displayInterpreters?.length > 0 ? (
                            getSortedData(displayInterpreters).map((item: any) => (
                              <tr key={item?.fK_Interpreter}>
                                <td>
                                  <Link
                                    to={`/profile/${item?.fK_Interpreter}`}
                                    target='_blank'
                                    rel='noopener noreferrer'
                                  >
                                    <a className='text-gray-800 text-hover-primary fs-6'>
                                      <div className='d-flex align-items-center'>
                                        {item.profileImage ? (
                                          <div className='symbol symbol-45px me-5 rounded-circle'>
                                            <ProfileImg
                                              imagePath={item.profileImage}
                                              alt=''
                                              className='rounded-circle'
                                            />
                                          </div>
                                        ) : (
                                          <div className='symbol symbol-circle symbol-45px overflow-hidden me-3'>
                                            <div className='symbol-label fs-4 badge-light-success bg-light-success'>
                                              <span style={{fontSize: '20px'}}>
                                                {(item?.name ?? 'N/A').slice(0, 2).toUpperCase()}
                                              </span>
                                            </div>
                                          </div>
                                        )}
                                        <div className='d-flex flex-column justify-content-start align-items-start'>
                                          <div className='text-gray-900 fw-bold text-hover-primary fs-6'>
                                            {ipiRecommendationEnabled ? (
                                              <InterpreterNameWithCaseCount
                                                name={item?.name ?? 'N/A'}
                                                accountCompletedCaseCount={item?.accountCompletedCaseCount}
                                              />
                                            ) : (
                                              <span>{item?.name ?? 'N/A'}</span>
                                            )}
                                          </div>
                                          {ipiRecommendationEnabled && (
                                            <InterpreterTag
                                              isNew={item?.isNewInterpreter}
                                              isTopMatch={item?.isTopMatch}
                                            />
                                          )}
                                          {(() => {
                                            const aiBadge = getAiBadge(
                                              aiAssignmentSummary,
                                              item?.fK_Interpreter
                                            )
                                            return aiBadge ? (
                                              <AiRecommendedTag label={aiBadge.tag} title={aiBadge.title} />
                                            ) : null
                                          })()}
                                          {item?.isComplianceMissing && (
                                            <span
                                              className='badge fw-semibold mt-1 d-inline-flex align-items-center gap-1 align-self-start'
                                              style={{
                                                backgroundColor: '#fff5f8',
                                                color: '#d7383c',
                                                fontSize: '0.7rem',
                                                borderRadius: '999px',
                                                padding: '4px 10px',
                                              }}
                                            >
                                              <i className='bi bi-exclamation-triangle-fill' style={{fontSize: '0.65rem'}}></i>
                                              Non-compliant
                                            </span>
                                          )}
                                        </div>
                                      </div>
                                    </a>
                                  </Link>
                                </td>
                                  <td>
                                    <div className="">
                                      <div className="small text-muted">{item?.email ? item.email : 'N/A'}</div>
                                      <div className="small text-muted">{item?.phone ? item.phone : 'N/A'}</div>
                                    </div>
                                  </td>
                                {ipiRecommendationEnabled && (
                                <td>
                                  <InterpreterScoreBadge
                                    score={item?.recommendationScore}
                                    maxScore={item?.recommendationMaxScore ?? 10}
                                    breakdown={item?.scoreBreakdown}
                                    isNew={item?.isNewInterpreter}
                                  />
                                </td>
                                )}

                                {currentUser?.result.userType === 'SYSTEM' && (
                                  <td>
                                    <a className='text-gray-800 text-hover-primary fs-6'>
                                      ${item?.rate ?? 'N/A'}
                                    </a>
                                  </td>
                                )}
                                 

                                <td>{getAssignStatusBadge(item?.assignStatus) ?? statusMapping[item?.assignStatus]}</td>
                                <td>
                                  {item?.distance !== undefined && item?.distance !== null
                                    ? item.distance
                                    : 'N/A'}
                                </td>
                                <td>
                                  {item?.travelTime !== undefined && item?.travelTime !== null
                                    ? item.travelTime
                                    : 'N/A'}
                                </td>
                                <td>
                                  {item?.customerRate &&
                                  item?.rate &&
                                  !isNaN(Number(item.customerRate)) &&
                                  !isNaN(Number(item.rate)) &&
                                  Number(item.customerRate) !== 0
                                    ? (
                                        ((Number(item.customerRate) - Number(item.rate)) /
                                          Number(item.customerRate)) *
                                        100
                                      ).toFixed(1) + '%'
                                    : 'N/A'}
                                </td>
                                {/* {appointmentDetails?.communicationTypeIdentification ===
                                    'ON_SITE' && (
                                    <td>
                                      <a className='text-gray-800 text-hover-primary fs-6'>
                                        {item?.distance ?? 'N/A'}
                                      </a>
                                    </td>
                                  )} */}
                                {/* {currentUser?.result.userType === 'SYSTEM' && (
                                  <td>
                                    <div className='d-flex'>
                                      <a
                                        href='#'
                                        className={`btn btn-icon btn-bg-light btn-color-${
                                          item?.isTimeConflict ? 'danger' : 'primary'
                                        } btn-sm`}
                                      >
                                        <i className='bi bi-calendar'></i>
                                      </a>
                                    </div>
                                  </td>
                                )} */}
                                <td
                                  className='d-flex justify-content-end align-items-center gap-2 border-bottom-0'
                                  style={{marginTop: '10px'}}
                                >
                                  {showViewInterpreterNotes && (
                                    <InterpreterNotesButton
                                      interpreterId={item?.fK_Interpreter}
                                      onClick={() => setNotesInterpreter(item)}
                                    />
                                  )}
                                  {currentUser?.result.userType === 'SYSTEM' &&
                                    (appointmentDetails?.status === 0 ||
                                      appointmentDetails?.status === 1) &&
                                    (isInterpreterAvailableForAssignment(item?.assignStatus) ||
                                      isInterpreterManuallyUnavailable(item?.assignStatus)) && (
                                      <>
                                        {isInterpreterAvailableForAssignment(item?.assignStatus) && (
                                          <>
                                            <OverlayTrigger
                                              placement='left'
                                              overlay={
                                                <Tooltip id={`tooltip-mark-unavailable-${item?.fK_Interpreter}`}>
                                                  Mark Unavailable
                                                </Tooltip>
                                              }
                                            >
                                              <button
                                                type='button'
                                                className='btn btn-danger btn-sm btn-icon'
                                                onClick={() => setMarkUnavailableTarget(item)}
                                              >
                                                <i className='bi bi-x-lg'></i>
                                              </button>
                                            </OverlayTrigger>
                                            <OverlayTrigger
                                              placement='left'
                                              overlay={
                                                <Tooltip id={`tooltip-assign-${item?.fK_Interpreter}`}>
                                                  Assign
                                                </Tooltip>
                                              }
                                            >
                                              <button
                                                type='button'
                                                className='btn btn-success btn-sm btn-icon'
                                                onClick={() => handleAssignButtonClick(item)}
                                              >
                                                <i className='bi bi-check-lg'></i>
                                              </button>
                                            </OverlayTrigger>
                                          </>
                                        )}
                                        {isInterpreterManuallyUnavailable(item?.assignStatus) && (
                                          <OverlayTrigger
                                            placement='left'
                                            overlay={
                                              <Tooltip id={`tooltip-revert-unavailable-${item?.fK_Interpreter}`}>
                                                Revert to Invited
                                              </Tooltip>
                                            }
                                          >
                                            <button
                                              type='button'
                                              className='btn btn-light btn-sm btn-icon'
                                              onClick={() => handleRevertUnavailable(item)}
                                              disabled={isRevertUnavailableInProgress}
                                            >
                                              <i className='bi bi-arrow-counterclockwise'></i>
                                            </button>
                                          </OverlayTrigger>
                                        )}
                                      </>
                                    )}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan={7}>
                                <div className='py-5 d-flex flex-column align-content-center justify-content-center'>
                                  <div className='text-center'>
                                    <div className='symbol symbol-200px'>
                                      <img src='/media/other/nodata.png' alt='' />
                                    </div>
                                  </div>
                                  <div className='d-flex text-center w-100 align-content-center justify-content-center fw-semibold fs-3 text-gray-400'>
                                    No matching records found
                                  </div>
                                </div>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                      {/* Table End */}
                    </div>
                    </>
                  )}
                </>
              )}

              {activeTab === 1 &&
                currentUser?.result?.userType !== 'INTERPRETER' &&
                appointmentDetails?.status !== 5 && (
                  <div className='tab-pane fade show active' id='kt_tab_pane_2' role='tabpanel'>
                    <div className='accordion' id='kt_accordion_1'>
                      <div className='accordion-item'>
                        <h2 className='accordion-header' id='kt_accordion_2_header_1'>
                          <button
                            className='accordion-button fs-4 fw-bold collapsed'
                            type='button'
                            data-bs-toggle='collapse'
                            data-bs-target='#kt_accordion_2_body_1'
                            aria-expanded='false'
                            aria-controls='kt_accordion_2_body_1'
                          >
                            Service type not matched Interpreters ( {notMatchInterpreters?.length} )
                          </button>
                        </h2>
                        <div
                          id='kt_accordion_2_body_1'
                          className='accordion-collapse collapse'
                          aria-labelledby='kt_accordion_2_header_1'
                          data-bs-parent='#kt_accordion_1'
                        >
                          <div className='accordion-body'>
                            <div className='table-responsive'>
                              <table className='table table-row-dashed table-row-gray-300 align-middle gs-2 gy-2'>
                                <thead>
                                  <tr className='fw-semibold text-muted text-uppercase'>
                                    <th
                                      className='min-w-150px text-uppercase'
                                      style={{width: '30%'}}
                                    >
                                      Service type not matched Interpreters(
                                      {countNoMatchInterpretersByStatus(3)}/
                                      {notMatchInterpreters?.length})
                                    </th>
                                    {currentUser?.result.userType !== 'CONSUMER' && (
                                      <th className='min-w-100px'>Rate</th>
                                    )}
                                    <th className='min-w-100px'>Status</th>
                                    {countInterpretersByStatus(3) <= 0 &&
                                      currentUser?.result.userType !== 'CONSUMER' && (
                                        <th className='min-w-50px text-end'>Invite</th>
                                      )}
                                  </tr>
                                </thead>
                                <tbody>
                                  {notMatchInterpreters?.length > 0 ? (
                                    notMatchInterpreters?.map((item: any) => (
                                      <tr key={item?.fK_Interpreter}>
                                        <td>
                                          <Link
                                    to={`/profile/${item?.fK_Interpreter}`}
                                    target='_blank'
                                    rel='noopener noreferrer'
                                  >
                                            <a className='text-gray-800 text-hover-primary fs-6'>
                                              <div className='d-flex align-items-center'>
                                                {item.profileImage ? (
                                                  <div className='symbol symbol-45px me-5 rounded-circle'>
                                                    <ProfileImg
                                                      imagePath={item.profileImage}
                                                      alt=''
                                                      className='rounded-circle'
                                                    />
                                                  </div>
                                                ) : (
                                                  <div className='symbol symbol-circle symbol-45px overflow-hidden me-3'>
                                                    <div className='symbol-label fs-4 badge-light-success bg-light-success'>
                                                      <span style={{fontSize: '20x'}}>
                                                        {(item?.name ?? '')
                                                          .charAt(0)
                                                          .toUpperCase() +
                                                          (item?.name ?? '')
                                                            .charAt(1)
                                                            .toUpperCase()}
                                                      </span>
                                                    </div>
                                                  </div>
                                                )}
                                                <div className='text-gray-900 fw-bold text-hover-primary fs-6'>
                                                  {item?.name ?? 'N/A'}
                                                </div>
                                              </div>
                                            </a>
                                          </Link>
                                        </td>
                                        {currentUser?.result.userType !== 'CONSUMER' && (
                                          <td>
                                            <a className='text-gray-800 text-hover-primary fs-6'>
                                              ${item?.rate ?? 'N/A'}
                                            </a>
                                          </td>
                                        )}
                                        <td>{statusMapping[item?.assignStatus]}</td>
                                        {countInterpretersByStatus(3) <= 0 &&
                                          currentUser?.result.userType !== 'CONSUMER' && (
                                            <td>
                                              <div className='d-flex justify-content-end flex-shrink-0'>
                                                <button
                                                  className='btn btn-success btn-sm btn-icon'
                                                  onClick={() => handleInviteInterpreter(item.code)}
                                                  disabled={
                                                    appointmentDetails?.status == 0 ||
                                                    appointmentDetails?.status == 1 ||
                                                    appointmentDetails?.status == 3
                                                      ? false
                                                      : true
                                                  }
                                                >
                                                  <KTSVG
                                                    path='/media/icons/duotune/general/gen016.svg'
                                                    className='svg-icon-muted svg-icon-1hx'
                                                  />
                                                </button>
                                              </div>
                                            </td>
                                          )}
                                      </tr>
                                    ))
                                  ) : (
                                    <tr>
                                      <td colSpan={7}>
                                        <div className='py-5 d-flex flex-column align-content-center justify-content-center'>
                                          <div className='text-center'>
                                            <div className='symbol symbol-200px'>
                                              <img src='/media/other/nodata.png' alt='' />
                                            </div>
                                          </div>
                                          <div className='d-flex text-center w-100 align-content-center justify-content-center fw-semibold fs-3 text-gray-400'>
                                            No matching records found
                                          </div>
                                        </div>
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className='accordion' id='kt_accordion_3'>
                      <div className='accordion-item'>
                        <h2 className='accordion-header' id='kt_accordion_3_header_1'>
                          <button
                            className='accordion-button fs-4 fw-bold collapsed'
                            type='button'
                            data-bs-toggle='collapse'
                            data-bs-target='#kt_accordion_3_body_1'
                            aria-expanded='false'
                            aria-controls='kt_accordion_3_body_1'
                          >
                            Other Potential Interpreters ({' '}
                            {unavailableInterpreters?.length} )
                          </button>
                        </h2>
                        <div
                          id='kt_accordion_3_body_1'
                          className='accordion-collapse collapse'
                          aria-labelledby='kt_accordion_3_header_1'
                          data-bs-parent='#kt_accordion_3'
                        >
                          <div className='accordion-body'>
                            <div className='table-responsive'>
                              <table className='table table-row-dashed table-row-gray-300 align-middle gs-2 gy-2'>
                                <thead>
                                  <tr className='fw-semibold text-muted text-uppercase'>
                                    <th
                                      className='min-w-150px text-uppercase'
                                      style={{width: '30%'}}
                                    >
                                      Other Potential Interpreters(
                                      {unavailableInterpreters?.length})
                                    </th>
                                    {currentUser?.result.userType !== 'CONSUMER' && (
                                      <th className='min-w-100px'>Rate</th>
                                    )}
                                    <th className='min-w-100px'>Status</th>
                                    {countInterpretersByStatus(3) > 0 && (
                                      <>
                                        {currentUser?.result.userType !== 'CONSUMER' && (
                                          <th className='min-w-100px text-end'>Conflicts</th>
                                        )}
                                      </>
                                    )}
                                    {countInterpretersByStatus(3) <= 0 && (
                                      <>
                                        {currentUser?.result.userType !== 'CONSUMER' && (
                                          <th className='min-w-100px'>Conflicts</th>
                                        )}
                                        {currentUser?.result.userType !== 'CONSUMER' && (
                                          <th className='min-w-50px text-end'>Invite</th>
                                        )}
                                      </>
                                    )}
                                  </tr>
                                </thead>
                                <tbody>
                                  {unavailableInterpreters?.length > 0 ? (
                                    unavailableInterpreters?.map((item: any) => (
                                      <tr key={item?.fK_Interpreter}>
                                        <td>
                                          <Link
                                    to={`/profile/${item?.fK_Interpreter}`}
                                    target='_blank'
                                    rel='noopener noreferrer'
                                  >
                                            <a className='text-gray-800 text-hover-primary fs-6'>
                                              <div className='d-flex align-items-center'>
                                                {item.profileImage ? (
                                                  <div className='symbol symbol-45px me-5 rounded-circle'>
                                                    <ProfileImg
                                                      imagePath={item.profileImage}
                                                      alt=''
                                                      className='rounded-circle'
                                                    />
                                                  </div>
                                                ) : (
                                                  <div className='symbol symbol-circle symbol-45px overflow-hidden me-3'>
                                                    <div className='symbol-label fs-4 badge-light-success bg-light-success'>
                                                      <span style={{fontSize: '20x'}}>
                                                        {(item?.name ?? '')
                                                          .charAt(0)
                                                          .toUpperCase() +
                                                          (item?.name ?? '')
                                                            .charAt(1)
                                                            .toUpperCase()}
                                                      </span>
                                                    </div>
                                                  </div>
                                                )}
                                                <div className='text-gray-900 fw-bold text-hover-primary fs-6'>
                                                  {item?.name ?? 'N/A'}
                                                </div>
                                              </div>
                                            </a>
                                          </Link>
                                        </td>
                                        {currentUser?.result.userType !== 'CONSUMER' && (
                                          <td>
                                            <a className='text-gray-800 text-hover-primary fs-6'>
                                              ${item?.rate ?? 'N/A'}
                                            </a>
                                          </td>
                                        )}
                                        <td>
                                          <div className='d-flex flex-wrap gap-1'>
                                            {item?.isBusyInterpreter && (
                                              <span className='badge badge-light-info fw-bolder px-4 py-3 text-info'>
                                                Busy
                                              </span>
                                            )}
                                            {item?.isComplianceMissing && (
                                              <span className='badge badge-light-warning fw-bolder px-4 py-3'>
                                                Not Compliant
                                              </span>
                                            )}
                                            {item?.assignStatusName === 'TimeOff' && (
                                              <span
                                                className='badge badge-light fw-bolder px-4 py-3 text-gray-700'
                                                title='Marked as Time Off'
                                              >
                                                Time Off
                                              </span>
                                            )}
                                            {!item?.isBusyInterpreter && !item?.isComplianceMissing && !item?.isTimeOffInterpreter && (
                                              statusMapping[item?.assignStatus]
                                            )}
                                          </div>
                                        </td>
                                        {countInterpretersByStatus(3) > 0 && (
                                          <>
                                            {currentUser?.result.userType !== 'CONSUMER' && (
                                              <td>
                                                <div className='d-flex justify-content-end gap-2'>
                                                  {item?.isComplianceMissing && (
                                                    <button
                                                      className='btn btn-icon btn-bg-light btn-color-warning btn-sm'
                                                      onClick={() => fetchMissingDocuments(item)}
                                                      title='Missing Documents'
                                                    >
                                                      <i className='bi bi-file-earmark-text'></i>
                                                    </button>
                                                  )}
                                                </div>
                                              </td>
                                            )}
                                          </>
                                        )}
                                        {countInterpretersByStatus(3) <= 0 && (
                                          <>
                                            {currentUser?.result.userType !== 'CONSUMER' && (
                                              <td>
                                                <div className='d-flex gap-2'>
                                                  {item?.isComplianceMissing && (
                                                    <button
                                                      className='btn btn-icon btn-bg-light btn-color-warning btn-sm'
                                                      onClick={() => fetchMissingDocuments(item)}
                                                      title='Missing Documents'
                                                    >
                                                      <i className='bi bi-file-earmark-text'></i>
                                                    </button>
                                                  )}
                                                </div>
                                              </td>
                                            )}
                                            {currentUser?.result.userType !== 'CONSUMER' && (
                                              <td>
                                                <div className='d-flex justify-content-end flex-shrink-0'>
                                                  <button
                                                    className='btn btn-success btn-sm btn-icon'
                                                    onClick={() =>
                                                      handleInviteInterpreter(
                                                        item.code
                                                      )
                                                    }
                                                    disabled={
                                                      appointmentDetails?.status == 0 ||
                                                      appointmentDetails?.status == 1 ||
                                                      appointmentDetails?.status == 3
                                                        ? false
                                                        : true
                                                    }
                                                  >
                                                    <KTSVG
                                                      path='/media/icons/duotune/general/gen016.svg'
                                                      className='svg-icon-muted svg-icon-1hx'
                                                    />
                                                  </button>
                                                </div>
                                              </td>
                                            )}
                                          </>
                                        )}
                                      </tr>
                                    ))
                                  ) : (
                                    <tr>
                                      <td colSpan={7}>
                                        <div className='py-5 d-flex flex-column align-content-center justify-content-center'>
                                          <div className='text-center'>
                                            <div className='symbol symbol-200px'>
                                              <img src='/media/other/nodata.png' alt='' />
                                            </div>
                                          </div>
                                          <div className='d-flex text-center w-100 align-content-center justify-content-center fw-semibold fs-3 text-gray-400'>
                                            No matching records found
                                          </div>
                                        </div>
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              {activeTab === 2 && (
                <div className='tab-pane fade show active' id='kt_tab_pane_2' role='tabpanel'>
                  <div className='row g-4'>
                    { currentUser?.result?.userType !== 'INTERPRETER' &&
                    (
                    <div className='col-md-6 col-sm-12 pt-5 '>
                      <div className='d-flex align-items-center justify-content-between mb-5'>
                        <h3 className='fs-6 fw-semibold text-gray-800 mb-0'>Appointment History</h3>
                        {aiAssignmentSummary && (
                          <button
                            type='button'
                            className='btn btn-sm btn-light-primary'
                            onClick={() => setIsSmsActivityOpen(true)}
                          >
                            <i className='bi bi-chat-left-text' style={{marginRight: 6}} />
                            SMS Activities
                          </button>
                        )}
                      </div>
                      <div className='separator my-3'></div>
                      <div
                        className='scrollable-notes'
                        style={{maxHeight: '50vh', overflowY: 'auto'}}
                      >
                        {activities?.histories?.length > 0 ? (
                          activities?.histories?.map((item: any) => (
                            <div className='card bg-white mb-2 border border-dotted border-gray-400 border-1 mx-2'>
                              <div className='card-body p-4'>
                                <div className='d-flex justify-content-between flex-nowrap w-100'>
                                  <div className='d-flex align-items-center w-100'>
                                    <div
                                      className={clsx('symbol-group symbol-hover me-3', item?.insertedBy && !item?.isRecallBot && 'cursor-pointer')}
                                      role={item?.insertedBy && !item?.isRecallBot ? 'button' : undefined}
                                      onClick={() => item?.insertedBy && !item?.isRecallBot && openActivityParticipantModal(item)}
                                    >
                                      {item?.isRecallBot ? (
                                        renderBotAvatar()
                                      ) : item.profileImages?.length > 0 ? (
                                        item.profileImages?.map((image: any) =>
                                          image ? (
                                            <div className='symbol symbol-50px symbol-circle d-flex align-items-start'>
                                              <ProfileImg
                                                imagePath={image}
                                                alt=''
                                                className=''
                                                style={{objectFit: 'cover'}}
                                              />
                                            </div>
                                          ) : (
                                            <div className='symbol symbol-50px symbol-circle overflow-hidden '>
                                              <div
                                                className={clsx(
                                                  'symbol-label fs-3',
                                                  'badge-light-success',
                                                  `bg-light-success`
                                                )}
                                              >
                                                <span style={{fontSize: '20x'}}>
                                                  {(item?.userName ?? '').charAt(0).toUpperCase() +
                                                    (item?.userName ?? '').charAt(1).toUpperCase()}
                                                </span>
                                              </div>
                                            </div>
                                          )
                                        )
                                      ) : (
                                        <div className='symbol symbol-50px symbol-circle overflow-hidden'>
                                          <div
                                            className={clsx(
                                              'symbol-label fs-3',
                                              'badge-light-success',
                                              `bg-light-success`
                                            )}
                                          >
                                            <span style={{fontSize: '20x'}}>
                                              {(item?.userName ?? '').charAt(0).toUpperCase() +
                                                (item?.userName ?? '').charAt(1).toUpperCase()}
                                            </span>
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                    <div className='d-flex flex-column w-100'>
                                      <div className='d-flex justify-content-between w-100 flex-wrap'>
                                        <div className='d-flex flex-wrap'>
                                          <span className='fw-bold d-flex align-items-center fs-6 me-1 me-3'>
                                            {item?.name}
                                          </span>
                                          <div className='d-flex'>
                                            <span
                                              className={clsx('badge badge-secondary px-3 fs-8', item?.insertedBy && !item?.isRecallBot && 'cursor-pointer')}
                                              role={item?.insertedBy && !item?.isRecallBot ? 'button' : undefined}
                                              onClick={() => item?.insertedBy && !item?.isRecallBot && openActivityParticipantModal(item)}
                                            >
                                              {item?.userName ?? 'N/A'}
                                            </span>
                                          </div>
                                        </div>

                                        <div className='d-flex text-gray-600'>
                                          <span className='fs-8'>
                                            <i className='bi bi-calendar-check me-2'></i>
                                            {moment(item.insertedDateTime).format(
                                              'MM/DD/YY hh:mm A'
                                            )}
                                          </span>
                                        </div>
                                      </div>

                                      <div className='d-flex flex-column flex-1 mt-1'>
                                        <span className='fs-7'>{item?.description ?? 'N/A'}</span>
                                      </div>
                                      {item?.name === 'Interpreter Unassigned' ? (
                                        item?.additionalInfo ? (
                                          <div className='d-flex flex-column flex-1 mt-1'>
                                            <span
                                              className='fs-7 text-break'
                                              style={{whiteSpace: 'pre-wrap'}}
                                            >
                                              <span className='fw-bold'>Additional Information:</span>{' '}
                                              {item.additionalInfo}
                                            </span>
                                          </div>
                                        ) : null
                                      ) : (() => {
                                        let additionalInfoArr: any[] = [];
                                        try {
                                          const parsed = JSON.parse(item?.additionalInfo);
                                          if (Array.isArray(parsed)) additionalInfoArr = parsed;
                                        } catch {}
                                        return additionalInfoArr.length > 0
                                          ? additionalInfoArr.map((x: any, idx: number) => (
                                              <div className='d-flex flex-column flex-1 mt-1' key={idx}>
                                                <span className='fs-7'>&#8226; {x ?? 'N/A'}</span>
                                              </div>
                                            ))
                                          : null;
                                      })()}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))
                        ) : (
                          <div className='card bg-white mb-2 border border-dotted border-gray-400 border-1 mx-2'>
                            <div className='py-5 d-flex flex-column align-content-center justify-content-center'>
                              <div className='text-center'>
                                <div className='symbol symbol-200px '>
                                  <img src='/media/other/nodata.png' alt='' />
                                </div>
                              </div>
                              <div className='d-flex text-center w-100 align-content-center justify-content-center fw-semibold fs-3 text-gray-400'>
                                No matching records found
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    )
                    }
                    <div className='col-md-6 col-sm-12 pt-5'>
                      <h3 className='fs-6 fw-semibold text-gray-800 mb-5'>Notes</h3>
                      <div className='separator my-3'></div>
                      <div
                        className='scrollable-notes'
                        style={{maxHeight: '50vh', overflowY: 'auto'}}
                      >
                        {notes?.length > 0 ? (
                          notes?.map((item: any) => (
                            <div className='card bg-white mb-2 border border-dotted border-gray-400 border-1 mx-2'>
                              <div className='card-body p-4'>
                                <div className='d-flex justify-content-between flex-nowrap w-100'>
                                  <div className='d-flex align-items-center w-100'>
                                    <div className='symbol-group symbol-hover me-3'>
                                      {item.avatar ? (
                                        <div className='symbol symbol-circle symbol-50px'>
                                          <ProfileImg
                                            imagePath={item.avatar}
                                            alt=''
                                            className='rounded-circle'
                                            style={{objectFit: 'cover'}}
                                          />
                                        </div>
                                      ) : (
                                        <div className='symbol symbol-circle symbol-50px overflow-hidden me-3'>
                                          <div
                                            className={clsx(
                                              'symbol-label fs-3',
                                              'badge-light-success',
                                              `bg-light-success`
                                            )}
                                          >
                                            <span style={{fontSize: '20px'}}>
                                              {(item?.insertedBy ?? '').charAt(0).toUpperCase() +
                                                (item?.insertedBy ?? '').charAt(1).toUpperCase()}
                                            </span>
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                    <div className='d-flex flex-column w-100'>
                                      <div className='d-flex justify-content-between w-100 flex-wrap'>
                                        <div className='d-flex flex-wrap'>
                                          <span className='fw-bold d-flex align-items-center fs-6 me-1 me-3'>
                                            {item?.noteHeader}
                                          </span>
                                          <div className='d-flex'>
                                            <span className='badge  badge-secondary px-3 fs-8'>
                                              {item?.insertedByName ?? 'N/A'}
                                            </span>
                                          </div>
                                        </div>

                                        <div className='d-flex text-gray-600'>
                                          <span className='fs-8'>
                                            <i className='bi bi-calendar-check me-2'></i>
                                            {moment(item.insertedDateTime)
                                              .local()
                                              .format('MM/DD/YY hh:mm A')}
                                          </span>
                                        </div>
                                      </div>

                                      <div className='d-flex flex-column flex-1 mt-1'>
                                        <span className='fs-7'>{item?.note ?? 'N/A'}</span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))
                        ) : (
                          <div className='card bg-white mb-2 border border-dotted border-gray-400 border-1 mx-2'>
                            <div className='py-5 d-flex flex-column align-content-center justify-content-center'>
                              <div className='text-center'>
                                <div className='symbol symbol-200px '>
                                  <img src='/media/other/nodata.png' alt='' />
                                </div>
                              </div>
                              <div className='d-flex text-center w-100 align-content-center justify-content-center fw-semibold fs-3 text-gray-400'>
                                No matching records found
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {activeTab === 3 && (
                <div className='tab-pane fade show active' id='kt_tab_pane_3' role='tabpanel'>
                  <div className='row g-4'>
                    <div className='col-md-12 col-sm-12 pt-5 flex-column'>
                      {appointmentDetails?.status === 5 || appointmentDetails?.status === 7 || (appointmentDetails?.status === 6 && (appointmentDetails?.billable || appointmentDetails?.payable)) ? (
                        <div className='row'>
                          {(currentUser?.result?.userType === 'SYSTEM' ||
                            currentUser?.result?.userType === 'CONSUMER') && (appointmentDetails?.status == 5 || appointmentDetails?.status == 7 || (appointmentDetails?.status === 6 && appointmentDetails?.billable)) && (
                            <div className='card mb-2 shadow-sm col-md-6'>
                              <div className='rounded-sm'>
                                {currentUser?.result?.userType === 'SYSTEM' && (
                                  <div className='card-header d-flex justify-content-between align-items-center pe-2' style={{minHeight: '50px'}}>
                                    <h3 className='card-title text-dark mb-0'>Client Estimated Charges</h3>
                                    <OverlayTrigger placement='top' overlay={<Tooltip>Regenerate rates from client profile</Tooltip>}>
                                      <button
                                        type='button'
                                        className='btn btn-sm btn-icon btn-light-success'
                                        onClick={() => openRegenerateConfirm('client')}
                                      >
                                        <i className='bi bi-arrow-repeat fs-2'></i>
                                      </button>
                                    </OverlayTrigger>
                                  </div>
                                )}
                                {billingDetails?.clientRateRevised && (
                                  <p className='text-danger fs-7 fw-semibold px-4 pt-3 mb-0'>
                                    Client rates have been revised. Please update the rates and click "Regenerate."
                                  </p>
                                )}
                                <div className='card-body py-2 bg-light'>
                                  <div className='w-50 '>
                                    <div className='d-flex justify-content-between flex-nowrap w-100'>
                                      <span className='fs-4 fw-bold text-gray-600'>Summary</span>
                                    </div>
                                    <div className='d-flex flex-column mt-3'>

                                      <div className='d-flex justify-content-between flex-wrap w-100 mb-2'>
                                        <div className='d-flex align-items-center '>
                                          <div className='d-flex flex-column w-auto'>
                                            <span className='fs-6'>Rate</span>
                                          </div>
                                        </div>
                                        <div className='text-dark fw-semibold d-flex'>
                                          ${billingDetails?.invoiceDetail?.rate?.toFixed(2) ?? '0'}
                                        </div>
                                      </div>

                                      <div className='d-flex justify-content-between flex-wrap w-100 mb-2'>
                                        <div className='d-flex align-items-center '>
                                          <div className='d-flex flex-column w-auto'>
                                            <span className='fs-6'>Amount</span>
                                          </div>
                                        </div>
                                        <div className='text-dark fw-semibold d-flex'>
                                          ${billingDetails?.invoiceDetail?.amount?.toFixed(2) ?? '0'}
                                        </div>
                                      </div>

                                      {billingDetails?.invoiceDetail?.totalDuration > 0 && (
                                        <div className='d-flex justify-content-between flex-wrap w-100 mb-2'>
                                          <div className='d-flex align-items-center '>
                                            <div className='d-flex flex-column w-auto'>
                                              <span className='fs-6'>Total Duration</span>
                                            </div>
                                          </div>
                                          <div className='text-dark fw-semibold d-flex'>
                                            {billingDetails?.invoiceDetail?.totalDuration ?? '0'} mins
                                          </div>
                                        </div>
                                      )}

                                      {billingDetails?.invoiceDetail?.breakTimeMinutes != null &&
                                        billingDetails?.invoiceDetail?.breakTimeMinutes > 0 && (
                                        <div className='d-flex justify-content-between flex-wrap w-100 mb-2'>
                                          <div className='d-flex align-items-center '>
                                            <div className='d-flex flex-column w-auto'>
                                              <span className='fs-6'>Break Time</span>
                                            </div>
                                          </div>
                                          <div className='text-dark fw-semibold d-flex'>
                                            {billingDetails?.invoiceDetail?.breakTimeMinutes} mins
                                          </div>
                                        </div>
                                      )}

                                      <div className='d-flex justify-content-between flex-wrap w-100 mb-2'>
                                        <div className='d-flex align-items-center '>
                                          <div className='d-flex flex-column w-auto'>
                                            <span className='fs-6'>Billable Duration</span>
                                          </div>
                                        </div>
                                        <div className='text-dark fw-semibold d-flex'>
                                          {`${billingDetails?.invoiceDetail?.duration ?? '0'} mins`}
                                        </div>
                                      </div>

                                      <div className='d-flex justify-content-between flex-wrap w-100 mb-2'>
                                        <div className='d-flex align-items-center '>
                                          <div className='d-flex flex-column w-auto'>
                                            <span className='fs-6'>Travel Time Expense</span>
                                          </div>
                                        </div>
                                        <div className='text-dark fw-semibold d-flex'>
                                          ${billingDetails?.invoiceDetail?.travelTimeExpense?.toFixed(2) ?? '0'}
                                        </div>
                                      </div>

                                      <div className='d-flex justify-content-between flex-wrap w-100 mb-2'>
                                        <div className='d-flex align-items-center '>
                                          <div className='d-flex flex-column w-auto'>
                                            <span className='fs-6'>Mileage Expense</span>
                                          </div>
                                        </div>
                                        <div className='text-dark fw-semibold d-flex'>
                                          ${billingDetails?.invoiceDetail?.mileageExpense?.toFixed(2) ?? '0'}
                                        </div>
                                      </div>

                                      <div className='d-flex justify-content-between flex-wrap w-100 mb-2'>
                                        <div className='d-flex align-items-center '>
                                          <div className='d-flex flex-column w-auto'>
                                            <span className='fs-6'>Other Expenses</span>
                                          </div>
                                        </div>
                                        <div className='text-dark fw-semibold d-flex'>
                                          ${billingDetails?.invoiceDetail?.otherExpenses?.toFixed(2) ?? '0'}
                                        </div>
                                      </div>

                                      <div className='separator separator-dashed border-dark my-3'></div>
                                      <div className='d-flex justify-content-between flex-wrap w-100 mb-2'>
                                        <div className='d-flex align-items-center'>
                                          <div className='d-flex flex-column w-auto'>
                                            <span className='fs-5 fw-bold'>Estimated Total</span>
                                          </div>
                                        </div>
                                        <div className='text-dark fw-bold d-flex fs-5'>
                                          ${billingDetails?.invoiceDetail?.total?.toFixed(2) ?? '0'}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                {billingDetails?.invoiceDetail?.expenses?.length > 0 && (
                                  <div className='py-2 card-footer'>
                                    <div className='row g-1'>
                                      <div className='d-flex justify-content-between flex-nowrap w-100'>
                                        <span className='fs-4 fw-bold text-gray-600'>
                                          Expense Details
                                        </span>
                                      </div>

                                      <div className='py-0 pt-3'>
                                        <div className='table-responsive'>
                                          <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-2'>
                                            <thead>
                                              <tr className='fw-semibold text-muted text-uppercase'>
                                                <th className='min-w-100px '>Created By</th>
                                                <th className='min-w-100px '>Created</th>
                                                <th className='min-w-100px '>Description</th>
                                                <th className='min-w-100px text-end'>Amount</th>
                                              </tr>
                                            </thead>

                                            <tbody>
                                              {billingDetails?.invoiceDetail?.expenses?.map(
                                                (x: any) => (
                                                  <tr>
                                                    <td>
                                                      <a className='text-gray-800 text-hover-primary fs-6'>
                                                        {x?.createdBy ?? 'N/A'}
                                                      </a>
                                                    </td>
                                                    <td>
                                                      <a className='text-gray-800 text-hover-primary fs-6'>
                                                        {moment(x?.date).format(
                                                          'DD/MM/YYYY h:mm A'
                                                        ) ?? 'N/A'}
                                                      </a>
                                                    </td>
                                                    <td>
                                                      <a className='text-gray-800 text-hover-primary fs-6'>
                                                        {x?.description ?? 'N/A'}
                                                      </a>
                                                    </td>
                                                    <td className='text-end'>
                                                      <a className='text-gray-800 text-hover-primary fs-6'>
                                                        ${x?.amount?.toFixed(2) ?? 'N/A'}
                                                      </a>
                                                    </td>
                                                  </tr>
                                                )
                                              )}
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          )}
                          {(currentUser?.result?.userType === 'SYSTEM' ||
                            currentUser?.result?.userType === 'INTERPRETER') && (appointmentDetails?.status == 5 || appointmentDetails?.status == 7 || (appointmentDetails?.status === 6 && appointmentDetails?.payable)) && (
                            <div className='card mb-2 shadow-sm col-md-6'>
                              <div className='rounded-sm '>
                                {currentUser?.result?.userType === 'SYSTEM' && (
                                  <div className='card-header d-flex justify-content-between align-items-center pe-2' style={{minHeight: '50px'}}>
                                    <h3 className='card-title text-dark mb-0'>
                                      Interpreter Estimated Pay
                                    </h3>
                                    <OverlayTrigger placement='top' overlay={<Tooltip>Regenerate rates from interpreter profile</Tooltip>}>
                                      <button
                                        type='button'
                                        className='btn btn-sm btn-icon btn-light-success'
                                        onClick={() => openRegenerateConfirm('interpreter')}
                                      >
                                        <i className='bi bi-arrow-repeat fs-2'></i>
                                      </button>
                                    </OverlayTrigger>
                                  </div>
                                )}
                                {billingDetails?.interpreterRateRevised && (
                                  <p className='text-danger fs-7 fw-semibold px-4 pt-3 mb-0'>
                                    Interpreter rates have been revised. Please update the rates and click "Regenerate."
                                  </p>
                                )}
                                <div className='card-body py-2 bg-light'>
                                  <div className='w-50 '>
                                    <div className='d-flex justify-content-between flex-nowrap w-100'>
                                      <span className='fs-4 fw-bold text-gray-600'>Summary</span>
                                    </div>
                                    <div className='d-flex flex-column mt-3'>
                                      <div className='d-flex justify-content-between flex-wrap w-100 mb-2'>
                                        <div className='d-flex align-items-center '>
                                          <div className='d-flex flex-column w-auto'>
                                            <span className='fs-6'>Rate</span>
                                          </div>
                                        </div>
                                        <div className='text-dark fw-semibold d-flex'>
                                          ${billingDetails?.voucherDetail?.rate?.toFixed(2) ?? '0'}
                                        </div>
                                      </div>

                                      <div className='d-flex justify-content-between flex-wrap w-100 mb-2'>
                                        <div className='d-flex align-items-center '>
                                          <div className='d-flex flex-column w-auto'>
                                            <span className='fs-6'>Amount</span>
                                          </div>
                                        </div>
                                        <div className='text-dark fw-semibold d-flex'>
                                          ${billingDetails?.voucherDetail?.amount?.toFixed(2) ?? '0'}
                                        </div>
                                      </div>

                                      {billingDetails?.voucherDetail?.totalDuration > 0 && (
                                        <div className='d-flex justify-content-between flex-wrap w-100 mb-2'>
                                          <div className='d-flex align-items-center '>
                                            <div className='d-flex flex-column w-auto'>
                                              <span className='fs-6'>Total Duration</span>
                                            </div>
                                          </div>
                                          <div className='text-dark fw-semibold d-flex'>
                                            {billingDetails?.voucherDetail?.totalDuration ?? '0'} mins
                                          </div>
                                        </div>
                                      )}

                                      {billingDetails?.voucherDetail?.breakTimeMinutes != null &&
                                        billingDetails?.voucherDetail?.breakTimeMinutes > 0 && (
                                        <div className='d-flex justify-content-between flex-wrap w-100 mb-2'>
                                          <div className='d-flex align-items-center '>
                                            <div className='d-flex flex-column w-auto'>
                                              <span className='fs-6'>Break Time</span>
                                            </div>
                                          </div>
                                          <div className='text-dark fw-semibold d-flex'>
                                            {billingDetails?.voucherDetail?.breakTimeMinutes} mins
                                          </div>
                                        </div>
                                      )}

                                      <div className='d-flex justify-content-between flex-wrap w-100 mb-2'>
                                        <div className='d-flex align-items-center '>
                                          <div className='d-flex flex-column w-auto'>
                                            <span className='fs-6'>Payable Duration</span>
                                          </div>
                                        </div>
                                        <div className='text-dark fw-semibold d-flex'>
                                          {`${billingDetails?.voucherDetail?.duration ?? '0'} mins`}
                                        </div>
                                      </div>

                                      <div className='d-flex justify-content-between flex-wrap w-100 mb-2'>
                                        <div className='d-flex align-items-center '>
                                          <div className='d-flex flex-column w-auto'>
                                            <span className='fs-6'>Travel Time Expense</span>
                                          </div>
                                        </div>
                                        <div className='text-dark fw-semibold d-flex'>
                                          ${billingDetails?.voucherDetail?.travelTimeExpense?.toFixed(2) ?? '0'}
                                        </div>
                                      </div>

                                      <div className='d-flex justify-content-between flex-wrap w-100 mb-2'>
                                        <div className='d-flex align-items-center '>
                                          <div className='d-flex flex-column w-auto'>
                                            <span className='fs-6'>Mileage Expense</span>
                                          </div>
                                        </div>
                                        <div className='text-dark fw-semibold d-flex'>
                                          ${billingDetails?.voucherDetail?.mileageExpense?.toFixed(2) ?? '0'}
                                        </div>
                                      </div>

                                      <div className='d-flex justify-content-between flex-wrap w-100 mb-2'>
                                        <div className='d-flex align-items-center '>
                                          <div className='d-flex flex-column w-auto'>
                                            <span className='fs-6'>Other Expenses</span>
                                          </div>
                                        </div>
                                        <div className='text-dark fw-semibold d-flex'>
                                          ${billingDetails?.voucherDetail?.otherExpenses?.toFixed(2) ?? '0'}
                                        </div>
                                      </div>

                                      <div className='separator separator-dashed border-dark my-3'></div>
                                      
                                      <div className='d-flex justify-content-between flex-wrap w-100 mb-2'>
                                        <div className='d-flex align-items-center '>
                                          <div className='d-flex flex-column w-auto'>
                                            <span className='fs-5 fw-bold'>Estimated Total</span>
                                          </div>
                                        </div>
                                        <div className='text-dark fw-bold d-flex fs-5'>
                                          $
                                          {(
                                            billingDetails?.voucherDetail?.total
                                          )?.toFixed(2) ?? '0'}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                {billingDetails?.voucherDetail?.expenses?.length > 0 && (
                                  <div className='py-2 card-footer'>
                                    <div className='row g-1'>
                                      <div className='d-flex justify-content-between flex-nowrap w-100'>
                                        <span className='fs-4 fw-bold text-gray-600'>
                                          Expense Details
                                        </span>
                                      </div>

                                      <div className='py-0 pt-3'>
                                        <div className='table-responsive'>
                                          <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-2'>
                                            <thead>
                                              <tr className='fw-semibold text-muted text-uppercase'>
                                                <th className='min-w-100px '>Created By</th>
                                                <th className='min-w-100px '>Created</th>
                                                <th className='min-w-100px '>Description</th>
                                                <th className='min-w-100px text-end'>Amount</th>
                                              </tr>
                                            </thead>

                                            <tbody>
                                              {billingDetails?.voucherDetail?.expenses?.map(
                                                (x: any) => (
                                                  <tr>
                                                    <td>
                                                      <a className='text-gray-800 text-hover-primary fs-6'>
                                                        {x?.createdBy ?? 'N/A'}
                                                      </a>
                                                    </td>
                                                    <td>
                                                      <a className='text-gray-800 text-hover-primary fs-6'>
                                                        {moment(x?.date).format(
                                                          'DD/MM/YYYY h:mm A'
                                                        ) ?? 'N/A'}
                                                      </a>
                                                    </td>
                                                    <td>
                                                      <a className='text-gray-800 text-hover-primary fs-6'>
                                                        {x?.description ?? 'N/A'}
                                                      </a>
                                                    </td>
                                                    <td className='text-end'>
                                                      <a className='text-gray-800 text-hover-primary fs-6'>
                                                        ${x?.amount?.toFixed(2) ?? 'N/A'}
                                                      </a>
                                                    </td>
                                                  </tr>
                                                )
                                              )}
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          )}
                        </div>
                      ) : (
                        <div className='py-5 d-flex flex-column align-content-center justify-content-center'>
                          <div className='text-center'>
                            <div className='symbol symbol-150px '>
                              <img src='/media/other/work-in-progress.gif' alt='' />
                            </div>
                          </div>
                          <div className='d-flex text-center w-100 align-content-center justify-content-center fw-semibold fs-3 text-gray-400'>
                            Your bill will be ready once the appointment is complete!
                          </div>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className='tab-pane fade show active' id='kt_tab_pane_2' role='tabpanel'>
                  <div className='row g-4'>
                    { currentUser?.result?.userType !== 'INTERPRETER' &&
                    (
                    <div className='col-md-6 col-sm-12 pt-5 '>
                      <h3 className='fs-6 fw-semibold text-gray-800 mb-5'>Activities Tracker</h3>
                      <div className='separator my-3'></div>
                      <div
                        className='scrollable-notes'
                        style={{maxHeight: '50vh', overflowY: 'auto'}}
                      >
                        {(() => {
                          const billingActivities =
                            activities?.histories?.filter(
                              (ac: {isOsi: boolean; isBilling: boolean}) => ac.isOsi || ac.isBilling
                            ) ?? []

                          return billingActivities.length > 0 ? (
                            billingActivities.map((item: any) => (
                            <div className='card bg-white mb-2 border border-dotted border-gray-400 border-1 mx-2' key={item.id ?? `${item.name}-${item.insertedDateTime}`}>
                              <div className='card-body p-4'>
                                <div className='d-flex justify-content-between flex-nowrap w-100'>
                                  <div className='d-flex align-items-center w-100'>
                                    <div
                                      className={clsx('symbol-group symbol-hover me-3', item?.insertedBy && !item?.isRecallBot && 'cursor-pointer')}
                                      role={item?.insertedBy && !item?.isRecallBot ? 'button' : undefined}
                                      onClick={() => item?.insertedBy && !item?.isRecallBot && openActivityParticipantModal(item)}
                                    >
                                      {item?.isRecallBot ? (
                                        renderBotAvatar()
                                      ) : item.profileImages?.length > 0 ? (
                                        item.profileImages?.map((image: any) =>
                                          image ? (
                                            <div className='symbol symbol-50px symbol-circle d-flex align-items-start'>
                                              <ProfileImg
                                                imagePath={image}
                                                alt=''
                                                className=''
                                                style={{objectFit: 'cover'}}
                                              />
                                            </div>
                                          ) : (
                                            <div className='symbol symbol-50px symbol-circle overflow-hidden '>
                                              <div
                                                className={clsx(
                                                  'symbol-label fs-3',
                                                  'badge-light-success',
                                                  `bg-light-success`
                                                )}
                                              >
                                                <span style={{fontSize: '20x'}}>
                                                  {(item?.userName ?? '').charAt(0).toUpperCase() +
                                                    (item?.userName ?? '').charAt(1).toUpperCase()}
                                                </span>
                                              </div>
                                            </div>
                                          )
                                        )
                                      ) : (
                                        <div className='symbol symbol-50px symbol-circle overflow-hidden'>
                                          <div
                                            className={clsx(
                                              'symbol-label fs-3',
                                              'badge-light-success',
                                              `bg-light-success`
                                            )}
                                          >
                                            <span style={{fontSize: '20x'}}>
                                              {(item?.userName ?? '').charAt(0).toUpperCase() +
                                                (item?.userName ?? '').charAt(1).toUpperCase()}
                                            </span>
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                    <div className='d-flex flex-column w-100'>
                                      <div className='d-flex justify-content-between w-100 flex-wrap'>
                                        <div className='d-flex flex-wrap'>
                                          <span className='fw-bold d-flex align-items-center fs-6 me-1 me-3'>
                                            {item?.name}
                                          </span>
                                          <div className='d-flex'>
                                            <span
                                              className={clsx('badge badge-secondary px-3 fs-8', item?.insertedBy && !item?.isRecallBot && 'cursor-pointer')}
                                              role={item?.insertedBy && !item?.isRecallBot ? 'button' : undefined}
                                              onClick={() => item?.insertedBy && !item?.isRecallBot && openActivityParticipantModal(item)}
                                            >
                                              {item?.userName ?? 'N/A'}
                                            </span>
                                          </div>
                                        </div>

                                        <div className='d-flex text-gray-600'>
                                          <span className='fs-8'>
                                            <i className='bi bi-calendar-check me-2'></i>
                                            {moment(item.insertedDateTime).format(
                                              'MM/DD/YY hh:mm A'
                                            )}
                                          </span>
                                        </div>
                                      </div>

                                      <div className='d-flex flex-column flex-1 mt-1'>
                                        <span className='fs-7'>{item?.description ?? 'N/A'}</span>
                                      </div>
                                        {(() => {
                                        let additionalInfoArr: any[] = [];
                                        try {
                                          const parsed = JSON.parse(item?.additionalInfo);
                                          if (Array.isArray(parsed)) additionalInfoArr = parsed;
                                        } catch {}
                                        return additionalInfoArr.length > 0
                                          ? additionalInfoArr.map((x: any, idx: number) => (
                                              <div className='d-flex flex-column flex-1 mt-1' key={idx}>
                                                <span className='fs-7'>&#8226; {x ?? 'N/A'}</span>
                                              </div>
                                            ))
                                          : null;
                                      })()}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))
                          ) : (
                          <div className='card bg-white mb-2 border border-dotted border-gray-400 border-1 mx-2'>
                            <div className='py-5 d-flex flex-column align-content-center justify-content-center'>
                              <div className='text-center'>
                                <div className='symbol symbol-100px '>
                                  <img src='/media/other/nodata.png' alt='' />
                                </div>
                              </div>
                              <div className='d-flex text-center w-100 align-content-center justify-content-center fw-semibold fs-3 text-gray-400'>
                                No matching records found
                              </div>
                            </div>
                          </div>
                          )
                        })()}
                      </div>
                    </div>
                    )
                    }
                  </div>
                </div>

                </div>
              )}

              {showRegenerateConfirm && (
                <>
                  <div
                    className='modal fade show d-block'
                    role='dialog'
                    tabIndex={-1}
                    aria-modal='true'
                  >
                    <div className='modal-dialog modal-dialog-centered mw-500px'>
                      <div className='modal-content'>
                        <div className='modal-header py-4'>
                          <h2 className='fw-bolder'>Confirmation</h2>
                          <div
                            className='btn btn-icon btn-sm btn-active-icon-primary'
                            style={{cursor: 'pointer'}}
                            onClick={() => {
                              if (isRegenerating) return
                              setShowRegenerateConfirm(false)
                              setRegenerateTarget(null)
                            }}
                          >
                            <KTSVG
                              path='/media/icons/duotune/arrows/arr061.svg'
                              className='svg-icon-1'
                            />
                          </div>
                        </div>
                        <div className='modal-body text-center py-10'>
                          <i className='bi bi-arrow-repeat text-info' style={{fontSize: '5rem'}}></i>
                          <p className='fs-5 mt-6 mb-0'>
                            Are you sure you would like to regenerate rates from the invoice?
                          </p>
                        </div>
                        <div className='modal-footer py-4'>
                          <button
                            type='button'
                            className='btn btn-light btn-sm'
                            disabled={isRegenerating}
                            onClick={() => {
                              setShowRegenerateConfirm(false)
                              setRegenerateTarget(null)
                            }}
                          >
                            Close
                          </button>
                          <button
                            type='button'
                            className='btn btn-success btn-sm'
                            disabled={isRegenerating}
                            onClick={handleRegenerateRates}
                          >
                            {isRegenerating ? 'Regenerating...' : 'Regenerate'}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='modal-backdrop fade show'></div>
                </>
              )}

              {documentExistsMessage && (
                <>
                  <div
                    className='modal fade show d-block'
                    role='dialog'
                    tabIndex={-1}
                    aria-modal='true'
                  >
                    <div className='modal-dialog modal-dialog-centered mw-450px'>
                      <div className='modal-content'>
                        <div className='modal-header'>
                          <h2 className='fw-bolder'>Invoice already generated</h2>
                          <div
                            className='btn btn-icon btn-sm btn-active-icon-primary'
                            style={{cursor: 'pointer'}}
                            onClick={() => setDocumentExistsMessage(null)}
                          >
                            <KTSVG
                              path='/media/icons/duotune/arrows/arr061.svg'
                              className='svg-icon-1'
                            />
                          </div>
                        </div>
                        <div className='modal-body text-center'>
                          <p>{documentExistsMessage}</p>
                          <div className='text-center pt-10'>
                            <button
                              className='btn btn-light btn-sm me-3'
                              onClick={() => setDocumentExistsMessage(null)}
                            >
                              Cancel
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='modal-backdrop fade show'></div>
                </>
              )}

              {showActivityParticipantModal && activityParticipant && (
                <>
                  <div
                    className='modal fade show d-block'
                    role='dialog'
                    tabIndex={-1}
                    aria-modal='true'
                  >
                    <div className='modal-dialog modal-dialog-centered mw-500px'>
                      <div className='modal-content'>
                        <div className='modal-header py-4'>
                          <h2 className='fw-bolder mb-0'>Participant Details</h2>
                          <div
                            className='btn btn-icon btn-sm btn-active-icon-primary'
                            style={{cursor: 'pointer'}}
                            onClick={closeActivityParticipantModal}
                          >
                            <KTSVG
                              path='/media/icons/duotune/arrows/arr061.svg'
                              className='svg-icon-1'
                            />
                          </div>
                        </div>
                        <div className='modal-body py-8'>
                          {isLoadingActivityParticipant ? (
                            <div className='text-center py-5'>
                              <CommonLoading />
                            </div>
                          ) : (
                            <div className='d-flex flex-column align-items-center text-center'>
                              {(activityParticipantDetails?.profileImage ??
                                activityParticipant?.profileImages?.[0]) ? (
                                <div className='symbol symbol-80px symbol-circle mb-4'>
                                  <ProfileImg
                                    imagePath={
                                      activityParticipantDetails?.profileImage ??
                                      activityParticipant?.profileImages?.[0]
                                    }
                                    alt=''
                                    className='rounded-circle'
                                    style={{objectFit: 'cover'}}
                                  />
                                </div>
                              ) : (
                                <div className='symbol symbol-80px symbol-circle overflow-hidden mb-4'>
                                  <div className='symbol-label fs-2 badge-light-success bg-light-success'>
                                    {(activityParticipant?.userName ?? '').charAt(0).toUpperCase()}
                                    {(activityParticipant?.userName ?? '').charAt(1).toUpperCase()}
                                  </div>
                                </div>
                              )}

                              <h3 className='fw-bold text-gray-900 mb-1'>
                                {[activityParticipantDetails?.firstName, activityParticipantDetails?.lastName]
                                  .filter(Boolean)
                                  .join(' ') || activityParticipant?.userName || 'N/A'}
                              </h3>
                              <span className='badge badge-light-primary mb-5'>
                                {activityParticipantDetails?.userType ??
                                  activityParticipant?.userType ??
                                  'N/A'}
                              </span>

                              <div className='w-100 text-start'>
                                <div className='d-flex justify-content-between py-2 border-bottom'>
                                  <span className='text-muted'>Email</span>
                                  <span className='fw-semibold text-gray-800'>
                                    {activityParticipantDetails?.email ?? 'N/A'}
                                  </span>
                                </div>
                                <div className='d-flex justify-content-between py-2'>
                                  <span className='text-muted'>Phone</span>
                                  <span className='fw-semibold text-gray-800'>
                                    {activityParticipantDetails?.phoneNumber ?? 'N/A'}
                                  </span>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                        <div className='modal-footer py-4'>
                          <button
                            type='button'
                            className='btn btn-light btn-sm'
                            onClick={closeActivityParticipantModal}
                          >
                            Close
                          </button>
                          {activityParticipant?.insertedBy && (
                            <Link
                              to={`/profile/${activityParticipant.insertedBy}`}
                              className='btn btn-primary btn-sm'
                              onClick={closeActivityParticipantModal}
                            >
                              View Profile
                            </Link>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='modal-backdrop fade show'></div>
                </>
              )}

              {activeTab === 4 && (
                <>
                  <div className='tab-pane fade show active' id='kt_tab_pane_4' role='tabpanel'>
                    <div className='card py-0 mb-xl-5 mt-3'>
                      <div className='d-flex align-items-center justify-content-end'>
                        {currentUser?.result.userType !== 'INTERPRETER' &&
                          appointmentDetails?.status !== 6 && (
                            <OverlayTrigger
                              placement='top'
                              overlay={<Tooltip id='tooltip-filter'>Add Document</Tooltip>}
                            >
                              <div>
                                <button
                                  type='button'
                                  className='btn btn-sm btn-primary btn-icon'
                                  data-bs-toggle='modal'
                                  data-bs-target='#document'
                                >
                                  <i className='bi bi-plus fs-2'></i>
                                </button>
                              </div>
                            </OverlayTrigger>
                          )}
                      </div>
                    </div>
                  </div>
                  <div className='py-0'>
                    {/* begin::Table container */}
                    <div className='table-responsive'>
                      {/* begin::Table */}
                      <table className='table table-row-dashed table-row-gray-300 align-middle gs-2 gy-2 table-hover'>
                        {/* begin::Table head */}
                        <thead>
                          <tr className='fw-semibold text-muted text-uppercase'>
                            {/* <th className='min-w-150px '>Appointment ID</th> */}
                            <th className='min-w-250px '>Name</th>
                            <th className='min-w-150px '>Description</th>
                            <th className='min-w-150px '>Date</th>
                            <th className='min-w-100px'>Type</th>
                            <th className='min-w-200px text-end'>Action</th>
                          </tr>
                        </thead>

                        <tbody>
                          {documents?.length > 0 ? (
                            documents.map((item: any, index: number) => (
                              <tr style={{cursor: 'pointer'}}>
                                <td>
                                  <span className='text-gray-800 text-hover-primary fs-6'>
                                    {item?.name}
                                  </span>
                                </td>
                                <td>
                                  <span className='text-gray-800 text-hover-primary fs-6'>
                                    {item?.description ?? 'N/A'}
                                  </span>
                                </td>
                                <td>
                                  <span className='text-gray-800 text-hover-primary fs-6'>
                                    {moment(item?.createdDateTime).format('MM/DD/YYYY hh:mm A')}
                                  </span>
                                </td>
                                <td>
                                  <span className='text-gray-800 text-hover-primary fs-6'>
                                    {getFileType(item?.fileName)}
                                  </span>
                                </td>
                                <td className='text-end'>
                                  <DocumentViewModal
                                    documentCode={item?.code}
                                    fileName={item?.fileName}
                                  />
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan={7}>
                                <div className='py-5 d-flex flex-column align-content-center justify-content-center'>
                                  <div className='text-center'>
                                    <div className='symbol symbol-200px '>
                                      <img src='/media/other/nodata.png' alt='' />
                                    </div>
                                  </div>
                                  <div className='d-flex text-center w-100 align-content-center justify-content-center fw-semibold fs-3 text-gray-400'>
                                    No matching records found
                                  </div>
                                </div>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                    <CommonPaginationModel
                      currentPage={currentPage}
                      totalPages={totalPages}
                      rowsPerPage={rowsPerPage}
                      total={totalItems}
                      onPageChange={(page: number) => {
                        setCurrentPage(page)
                      }}
                      onRowsPerPageChange={(newRowsPerPage: number) => {
                        setRowsPerPage(newRowsPerPage)
                        setCurrentPage(1)
                      }}
                    />
                  </div>
                </>
              )}
              {activeTab === 5 && (
                <div className='tab-pane fade show active' id='kt_tab_pane_5' role='tabpanel'>
                  {isMeetingSummaryPageLoading && (
                    <div className='d-flex flex-column align-items-center justify-content-center py-20'>
                      <span className='spinner-border text-primary mb-3' role='status' />
                      <span className='text-muted fw-semibold'>Loading meeting summary...</span>
                    </div>
                  )}
                  <div className={clsx('row gx-6', {'d-none': isMeetingSummaryPageLoading})}>
                    {appointmentDetails?.isOSIMeetingSummerySubmitted ? (
                      <>
                        <div className='col-md-6 col-sm-12 pt-2 mb-3 min-h-620px'>
                          <div className='border border-gray-500 border-dotted rounded p-5'>
                            {(meetingSummary.showBulkVosApprovalBanner ||
                              meetingSummary.ShowBulkVosApprovalBanner) && (
                              <div
                                className='alert alert-light-primary border border-primary border-dashed py-3 px-4 mb-4'
                                role='status'
                              >
                                <div className='fw-bold text-gray-800 mb-1'>Bulk approval</div>
                                <div className='text-gray-700 mb-0 fs-7'>
                                  This appointment will be part of bulk approval. Please verify
                                  details
                                </div>
                              </div>
                            )}
                            <div className='mb-3'>
                              <div className='d-flex justify-content-between align-items-center mb-2'>
                                <h3 className='d-flex fs-3 fw-semibold mb-0'>
                                  Verification of Services
                                </h3>
                                {currentUser?.result.userType === 'SYSTEM' &&
                                  (appointmentDetails?.statusName === 'Submitted' ||
                                    meetingSummary.status == 1 ||
                                    meetingSummary.status == 2 ||
                                    meetingSummary.status == 4 ||
                                    meetingSummary.status == 5 ||
                                    meetingSummary.status == 6 ||
                                    meetingSummary.status == 7) && (
                                    <button
                                      className='btn btn-icon btn-sm'
                                      data-bs-toggle='modal'
                                      data-bs-target='#kt_add_osi_details'
                                      style={{fontSize: '16px'}}
                                      title='Show OSI Settings'
                                      onClick={() => {
                                        setShowOsiReadOnly(true)
                                        setOsiEdit(false)
                                        setIsEditWithoutUnlinking(false)
                                        if (meetingSummary) {
                                          if (meetingSummary.osiExpensesList) {
                                            setExpenseList(mapOsiExpensesFromApi(meetingSummary.osiExpensesList))
                                          }
                                          setInitialValuesOSI((prev: any) => ({
                                            ...prev,
                                            ...resolveOsiBillingFlags(meetingSummary),
                                            code: meetingSummary.code ?? prev?.code,
                                            startDateTime: meetingSummary?.startDate ? moment(meetingSummary.startDate).format('YYYY-MM-DD HH:mm') : prev?.startDateTime,
                                            endDateTime: meetingSummary?.endDate ? moment(meetingSummary.endDate).format('YYYY-MM-DD HH:mm') : prev?.endDateTime,
                                            startTime: meetingSummary?.startDate ? moment(meetingSummary.startDate).format('HH:mm') : prev?.startTime,
                                            endTime: meetingSummary?.endDate ? moment(meetingSummary.endDate).format('HH:mm') : prev?.endTime,
                                            milageOfDrive: meetingSummary?.milage ?? prev?.milageOfDrive,
                                            travelHours: meetingSummary?.travalTimeH ?? prev?.travelHours,
                                            travelMinutes: meetingSummary?.travalTimeM ?? prev?.travelMinutes,
                                            isRoundTrip: meetingSummary?.isRoundTrip ?? prev?.isRoundTrip,
                                            breakTimeMinutes: meetingSummary?.breakTimeMinutes ?? prev?.breakTimeMinutes,
                                            vosSubmissionMode: meetingSummary?.vosSubmissionMode,
                                            ...resolveAppointmentChargeRateHours(interpreters),
                                          }))
                                        }
                                      }}
                                    >
                                      <i className='fa-solid fa-gear'></i>
                                    </button>
                                  )}
                              </div>
                                {isManualVos && (
                                  <div className='d-flex gap-2 flex-wrap mb-1'>
                                    {meetingSummary.status == 2 ? (
                                      <label className='badge badge-light-success fs-8'>Approved</label>
                                    ) : meetingSummary.status == 3 ? (
                                      <label className='badge badge-light-danger fs-8'>Rejected</label>
                                    ) : meetingSummary.status == 4 ? (
                                      <label className='badge badge-light-danger fs-8'>Dispute</label>
                                    ) : (
                                      <label className='badge badge-light-warning fs-8'>Pending</label>
                                    )}
                                  </div>
                                )}
                                {isManualVos && (
                                  <ManualVosInvoiceVoucherLines meetingSummary={meetingSummary} />
                                )}
                              {(meetingSummary.isBreakTimeMissing ||
                                meetingSummary.IsBreakTimeMissing) && (
                                <div className='alert alert-warning py-2 px-3 mb-2 fs-7'>
                                  Break time is required for this client but was not captured on
                                  the VOS form. Duration is calculated with 0 break minutes until
                                  corrected.
                                </div>
                              )}
                            </div>
                            <div className='d-flex justify-content-between align-items-start gap-3 mb-3 flex-wrap'>
                              <div className='d-flex flex-column flex-grow-1 min-w-0'>
                                {!isManualVos && Number(meetingSummary.vosSubmissionMode) === 1 &&
                                (meetingSummary.status == 1 ||
                                  meetingSummary.status == 5 ||
                                  meetingSummary.status == 6 ||
                                  meetingSummary.status == 7) ? (
                                  <>
                                    {!hasRequesterVOSSubmission &&
                                    (meetingSummary.status == 7 ||
                                      meetingSummary.status == 1 ||
                                      meetingSummary.status == 6) ? (
                                      <div className='d-flex flex-column gap-1'>
                                        <div className='d-flex gap-2 flex-wrap'>
                                          <label className='badge badge-primary fs-8'>
                                            Pending Account
                                          </label>
                                        </div>
                                        <span className='text-muted small'>
                                          Client approval required
                                        </span>
                                      </div>
                                    ) : hasRequesterVOSSubmission && requesterVosDisputed ? (
                                      <>
                                        <div className='d-flex gap-2 flex-wrap'>
                                          <label className='badge badge-light-warning fs-8'>Pending</label>
                                          {interpreterAcceptedRequesterDispute ? (
                                            <label className='badge badge-light-info fs-8'>
                                              Disputed & Accepted by Interpreter
                                            </label>
                                          ) : interpreterRejectedRequesterDispute ? (
                                            <label className='badge badge-light-danger fs-8'>
                                              Disputed & Rejected by Interpreter
                                            </label>
                                          ) : (
                                            <label className='badge badge-light-info fs-8'>
                                              Disputed by Requester
                                            </label>
                                          )}
                                        </div>
                                        {(meetingSummary.disputeReason ||
                                          meetingSummary.DisputeReason) && (
                                          <span className='text-muted small ms-2'>
                                            {meetingSummary.disputeReason ||
                                              meetingSummary.DisputeReason}
                                          </span>
                                        )}
                                      </>
                                    ) : hasRequesterVOSSubmission ? (
                                      <div className='d-flex gap-2 flex-wrap'>
                                        <label className='badge badge-light-warning fs-8'>Pending</label>
                                        <label className='badge badge-light-success fs-8'>
                                          Approved by Requester/Staff Member
                                        </label>
                                      </div>
                                    ) : meetingSummary.status == 5 ? (
                                      <>
                                        <div className='d-flex gap-2 flex-wrap'>
                                          <label className='badge badge-light-info fs-8'>
                                            AI Verification: Dispute
                                          </label>
                                          <label className='badge badge-light-warning fs-8'>Pending</label>
                                        </div>
                                        <span className='text-muted small mt-1'>
                                          {meetingSummary.disputeReason ||
                                            meetingSummary.DisputeReason ||
                                            'Values differ from VOS form'}
                                        </span>
                                      </>
                                    ) : meetingSummary.status == 6 ? (
                                      <div className='d-flex gap-2 flex-wrap'>
                                        <label className='badge badge-light-success fs-8'>
                                          AI Verification: Approved
                                        </label>
                                        <label className='badge badge-light-warning fs-8'>Pending</label>
                                      </div>
                                    ) : (
                                      <label className='badge badge-light-warning fs-8'>Pending</label>
                                    )}
                                  </>
                                ) : (
                                  !isManualVos && (
                                    <>
                                      {meetingSummary.status == 1 &&
                                        (hasRequesterVOSSubmission ? (
                                          <div className='d-flex gap-2 flex-wrap'>
                                            <label className='badge badge-light-success fs-8'>
                                              Approved by Requester/Staff Member
                                            </label>
                                            <label className='badge badge-light-warning fs-8'>Pending</label>
                                          </div>
                                        ) : (
                                          <label className='badge badge-light-warning fs-8'>Pending</label>
                                        ))}
                                      {meetingSummary.status == 5 && (
                                        <>
                                          <div className='d-flex gap-2 flex-wrap'>
                                            <label className='badge badge-light-info fs-8'>
                                              AI Verification: Dispute
                                            </label>
                                            <label className='badge badge-light-warning fs-8'>Pending</label>
                                          </div>
                                          <span className='text-muted small ms-2'>
                                            {meetingSummary.disputeReason ||
                                              meetingSummary.DisputeReason ||
                                              'Values differ from VOS form'}
                                          </span>
                                        </>
                                      )}
                                      {meetingSummary.status == 6 && (
                                        <div className='d-flex gap-2 flex-wrap'>
                                          <label className='badge badge-light-success fs-8'>
                                            AI Verification: Approved
                                          </label>
                                          <label className='badge badge-light-warning fs-8'>Pending</label>
                                        </div>
                                      )}
                                    </>
                                  )
                                )
                                }
                                {!isManualVos && meetingSummary.status == 2 && (
                                  <label className='badge badge-light-success fs-8'>Approved</label>
                                )}
                                {!isManualVos && meetingSummary.status == 3 && (
                                  <label className='badge badge-light-danger fs-8'>Rejected</label>
                                )}
                                {!isManualVos && meetingSummary.status == 4 && (
                                  <div className='d-flex gap-2 flex-wrap'>
                                    <label
                                      className='badge badge-light-danger fs-8'
                                      style={{color: '#b72025'}}
                                    >
                                      Dispute
                                    </label>
                                    {Number(meetingSummary.vosSubmissionMode) === 1 &&
                                      interpreterRejectedRequesterDispute && (
                                        <label className='badge badge-light-danger fs-8'>
                                          Disputed & Rejected by Interpreter
                                        </label>
                                      )}
                                  </div>
                                )}
                                {!isManualVos &&
                                  (meetingSummary.status == 2 ||
                                    meetingSummary.status == 3 ||
                                    (meetingSummary.status == 1 && hasRequesterVOSSubmission) ||
                                    meetingSummary.status == 4) && (
                                    <div className='mt-3'>
                                      <div className='mt-1'>
                                        <span className='d-flex mb-2'>
                                          {meetingSummary.status == 2 && (
                                            <span className='me-2 fw-bold'>Approved by : </span>
                                          )}
                                          {meetingSummary.status == 3 && (
                                            <span className='me-2 fw-bold'> Rejected by : </span>
                                          )}
                                          {meetingSummary.status == 1 && hasRequesterVOSSubmission && (
                                            <span className='me-2 fw-bold'>
                                              {Number(meetingSummary.vosSubmissionMode) === 1 &&
                                              requesterVosDisputed
                                                ? interpreterAcceptedDispute === true
                                                  ? 'Accepted by Interpreter : '
                                                  : interpreterAcceptedDispute === false
                                                    ? 'Rejected by Interpreter : '
                                                    : 'Disputed by : '
                                                : 'Approved by : '}
                                            </span>
                                          )}
                                          {meetingSummary.status == 4 && (
                                            <span className='me-2 fw-bold'>
                                              {requesterVosDisputed && interpreterAcceptedDispute === false
                                                ? 'Rejected by Interpreter : '
                                                : 'Disputed by : '}
                                            </span>
                                          )}
                                          {meetingSummary.lastModifiedBy}
                                        </span>
                                      </div>
                                      <div className='mt-3'>
                                        <span className='d-flex mb-2'>
                                          {meetingSummary.status == 2 && (
                                            <span className='me-2 fw-bold'>Approved Date : </span>
                                          )}
                                          {meetingSummary.status == 3 && (
                                            <span className='me-2 fw-bold'> Rejected Date : </span>
                                          )}
                                          {meetingSummary.status == 1 && hasRequesterVOSSubmission && (
                                            <span className='me-2 fw-bold'>
                                              {Number(meetingSummary.vosSubmissionMode) === 1 &&
                                              requesterVosDisputed
                                                ? interpreterAcceptedDispute === true
                                                  ? 'Accepted Date : '
                                                  : interpreterAcceptedDispute === false
                                                    ? 'Rejected Date : '
                                                    : 'Disputed Date : '
                                                : 'Approved Date : '}
                                            </span>
                                          )}
                                          {meetingSummary.status == 4 && (
                                            <span className='me-2 fw-bold'>
                                              {requesterVosDisputed && interpreterAcceptedDispute === false
                                                ? 'Rejected Date : '
                                                : 'Disputed Date : '}
                                            </span>
                                          )}
                                          {moment(meetingSummary.lastModifiedDateTime).format('MM/DD/YYYY, dddd')}{' '}
                                          {moment(meetingSummary.lastModifiedDateTime).format('h:mm A')}
                                        </span>
                                      </div>
                                      {meetingSummary.status == 2 && (
                                        <div className='mt-3'>
                                          <span className='d-flex mb-2'>
                                            <span className='me-2 fw-bold'>Invoice ID : </span>
                                            {meetingSummary.invoiceNo ? (
                                              <a
                                                href={`/invoice/${meetingSummary.invoiceHeaderCode}`}
                                                target='_blank'
                                                rel='noopener noreferrer'
                                                className='text-primary text-decoration-underline'
                                              >
                                                {meetingSummary.invoiceNo}
                                              </a>
                                            ) : (
                                              <span className='text-muted'>-</span>
                                            )}
                                          </span>
                                        </div>
                                      )}
                                    </div>
                                  )}
                              </div>
                              <div className='d-flex align-items-start flex-shrink-0 gap-1 ms-auto'>
                                {currentUser?.result.userType === 'SYSTEM' &&
                                  (meetingSummary.status == 1 ||
                                    meetingSummary.status == 4 ||
                                    meetingSummary.status == 5 ||
                                    meetingSummary.status == 6) &&
                                  !(
                                    Number(meetingSummary.vosSubmissionMode) === 1 &&
                                    !hasRequesterVOSSubmission &&
                                    (meetingSummary.status == 7 ||
                                      meetingSummary.status == 1 ||
                                      meetingSummary.status == 6)
                                  ) && (
                                    <>
                                      <button
                                        className='btn text-white btn-primary btn-sm mx-1'
                                        data-bs-toggle='modal'
                                        data-bs-target='#kt_add_osi_details'
                                        style={{fontSize: '12px'}}
                                        onClick={() => {
                                          setShowOsiReadOnly(false)
                                          setOsiEdit(true)
                                          setIsResubmit(false)
                                          setExpenseList(mapOsiExpensesFromApi(meetingSummary.osiExpensesList))
                                          // For Edit, use the actual OSI times from meetingSummary
                                          setInitialValuesOSI({
                                            ...initialValuesOSI,
                                            ...resolveOsiBillingFlags(meetingSummary),
                                            code: meetingSummary.code,
                                            startDateTime: meetingSummary?.startDate ? moment(meetingSummary.startDate).format('YYYY-MM-DD HH:mm') : '',
                                            endDateTime: meetingSummary?.endDate ? moment(meetingSummary.endDate).format('YYYY-MM-DD HH:mm') : '',
                                            startTime: meetingSummary?.startDate ? moment(meetingSummary.startDate).format('HH:mm') : '',
                                            endTime: meetingSummary?.endDate ? moment(meetingSummary.endDate).format('HH:mm') : '',
                                            addStaffMember: !!(meetingSummary?.staffMemberEmail || meetingSummary?.staffMemberName),
                                            staffMemberName: meetingSummary?.staffMemberName ?? '',
                                            staffMemberEmail: meetingSummary?.staffMemberEmail ?? '',
                                            breakTimeMinutes: (() => {
                                              const value = readOsiBreakTimeMinutes(
                                                meetingSummary as Record<string, unknown>
                                              )
                                              return value != null ? value : ''
                                            })(),
                                            vosSubmissionMode: meetingSummary?.vosSubmissionMode,
                                            ...resolveAppointmentChargeRateHours(interpreters),
                                          })
                                        }}
                                      >
                                        <i
                                          className='fa-solid fa-pen me-1'
                                          style={{fontSize: '12px'}}
                                        ></i>
                                        Edit
                                      </button>

                                      {!hideOsiApproveForRequesterDispute && (
                                        <button
                                          className='btn text-white btn-success btn-sm mx-1'
                                          style={{fontSize: '12px'}}
                                          data-bs-toggle='modal'
                                          data-bs-target='#kt_approve_confirm'
                                        >
                                          Approve
                                        </button>
                                      )}
                                      <button
                                        className='btn text-white btn-danger btn-sm mx-1'
                                        style={{fontSize: '12px'}}
                                        data-bs-toggle='modal'
                                        data-bs-target='#kt_reject_confirm'
                                      >
                                        Reject
                                      </button>
                                    </>
                                  )}
                                {meetingSummary.status == 3 &&
                                  currentUser?.result.userType === 'INTERPRETER' && (
                                    <button
                                      className='btn text-white btn-primary btn-sm mx-1'
                                      data-bs-toggle='modal'
                                      data-bs-target='#kt_add_osi_details'
                                      style={{fontSize: '12px'}}
                                      onClick={() => {
                                        setShowOsiReadOnly(false)
                                        setOsiEdit(true)
                                        setIsResubmit(false)
                                        setExpenseList(mapOsiExpensesFromApi(meetingSummary.osiExpensesList))
                                        setInitialValuesOSI({
                                          ...initialValuesOSI,
                                          ...resolveOsiBillingFlags(meetingSummary),
                                          code: meetingSummary.code,
                                          startDateTime: meetingSummary?.startDate
                                            ? moment(meetingSummary.startDate).format('YYYY-MM-DD HH:mm')
                                            : '',
                                          endDateTime: meetingSummary?.endDate
                                            ? moment(meetingSummary.endDate).format('YYYY-MM-DD HH:mm')
                                            : '',
                                          startTime: meetingSummary?.startDate
                                            ? moment(meetingSummary.startDate).format('HH:mm')
                                            : '',
                                          endTime: meetingSummary?.endDate
                                            ? moment(meetingSummary.endDate).format('HH:mm')
                                            : '',
                                          breakTimeMinutes: (() => {
                                            const value = readOsiBreakTimeMinutes(
                                              meetingSummary as Record<string, unknown>
                                            )
                                            return value != null ? value : ''
                                          })(),
                                          vosSubmissionMode: meetingSummary?.vosSubmissionMode,
                                          ...resolveAppointmentChargeRateHours(interpreters),
                                        })
                                      }}
                                    >
                                      <i
                                        className='fa-solid fa-pen me-1'
                                        style={{fontSize: '12px'}}
                                      ></i>
                                      Edit
                                    </button>
                                  )}
                                {showInterpreterVosDisputeActions && (
                                  <>
                                    <button
                                      className='btn text-white btn-success btn-sm mx-1'
                                      style={{fontSize: '12px'}}
                                      data-bs-toggle='modal'
                                      data-bs-target='#kt_vos_accept_dispute_confirm'
                                      disabled={isVosDisputeActionLoading}
                                    >
                                      Accept
                                    </button>
                                    <button
                                      className='btn text-white btn-danger btn-sm mx-1'
                                      style={{fontSize: '12px'}}
                                      data-bs-toggle='modal'
                                      data-bs-target='#kt_vos_reject_dispute_confirm'
                                      disabled={isVosDisputeActionLoading}
                                    >
                                      Reject
                                    </button>
                                  </>
                                )}
                              </div>
                            </div>
                            <div className='separator my-3'></div>
                            {isManualVos ? (
                              <>
                                <ManualVosMeetingSummaryCard meetingSummary={meetingSummary} />
                                <div className='row g-3 my-3'>
                                  <div className='col-12'>
                                    <div className='card border rounded p-3'>
                                      <div className='d-flex flex-column'>
                                        <div className='fw-bold mb-3'>
                                          Appointment Audit Details
                                        </div>
                                        {renderAttendanceAuditLines()}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                {renderBotAttendanceCard()}
                              </>
                            ) : (
                            <>
                            {/* Appointment Audit Details + Submitted/Approved Details (Tbl_T_OSISubmission) */}
                            <div className='row g-3 mb-3'>
                              <div
                                className={
                                  showOsiSubmissionDetailsCard ? 'col-md-6' : 'col-12'
                                }
                              >
                                <div className='card border rounded p-3'>
                                  <div className='d-flex flex-column'>
                                    <div className='fw-bold mb-3'>Appointment Audit Details</div>
                                    <span className='d-flex mb-2'><span className='me-2 fw-bold'>Submitted via:</span> {Number(meetingSummary.vosSubmissionMode) === 1 ? 'Digital VOS' : Number(meetingSummary.vosSubmissionMode) === 0 ? 'Manual' : '-'}</span>
                                    <span className='d-flex mb-2'><span className='me-2 fw-bold'>Client Approval Method:</span> {Number(meetingSummary.signedVia) === 1 ? 'Email' : Number(meetingSummary.signedVia) === 2 ? 'Mobile' : 'N/A'}</span>
                                    {/* <span className='d-flex mb-2'>
                                      <i className='fa-solid fa-file me-2 text-muted align-self-center' style={{fontSize: '12px'}} />
                                      <span className='me-2 fw-bold'>Invoice ID:</span>
                                      {meetingSummary.invoiceNo ? (
                                        <a href={`/invoice/${meetingSummary.invoiceHeaderCode}`} target='_blank' rel='noopener noreferrer' className='text-primary text-decoration-underline'>{meetingSummary.invoiceNo}</a>
                                      ) : '-'}
                                    </span>
                                    <span className='d-flex mb-2'>
                                      <i className='fa-solid fa-tag me-2 text-muted align-self-center' style={{fontSize: '12px'}} />
                                      <span className='me-2 fw-bold'>Voucher ID:</span>
                                      {meetingSummary.voucherNo ? (
                                        <a href={`/voucher/${meetingSummary.voucherHeaderCode}`} target='_blank' rel='noopener noreferrer' className='text-primary text-decoration-underline'>{meetingSummary.voucherNo}</a>
                                      ) : '-'}
                                    </span> */}
                                    <div className='border-top my-2 pt-2' />
                                    {renderAttendanceAuditLines()}
                                  </div>
                                </div>
                              </div>
                              {showOsiSubmissionDetailsCard && (
                                <div className='col-md-6'>
                                  <OSISubmissionDetailsCard
                                    title={osiSubmissionDetailsCardTitle}
                                    meetingSummary={meetingSummary}
                                  />
                                </div>
                              )}
                            </div>
                            {renderBotAttendanceCard()}
                            {/* Client Submitted VOS + Interpreter Submitted VOS (digital only) */}
                            {isDigitalVos ? (
                            <div className='row g-3 mb-3'>
                              <div className='col-md-6'>
                                <div className='card border rounded p-3'>
                                  <div className='fw-bold mb-3'>Client Submitted VOS</div>
                                  {hasRequesterVOSSubmission ? (<>
                                  <span className={vosRowClass('startTime')}><i className='fa-solid fa-clock me-2 text-muted align-self-center' style={{fontSize: '12px'}} /><span className='me-2 fw-bold'>Start Time:</span> {(meetingSummary.reqStartDate || meetingSummary.startDate) ? moment(meetingSummary.reqStartDate || meetingSummary.startDate).format('hh:mm A') : '-'}</span>
                                  <span className={vosRowClass('endTime')}><i className='fa-solid fa-clock me-2 text-muted align-self-center' style={{fontSize: '12px'}} /><span className='me-2 fw-bold'>End Time:</span> {(meetingSummary.reqEndDate || meetingSummary.endDate) ? moment(meetingSummary.reqEndDate || meetingSummary.endDate).format('hh:mm A') : '-'}</span>
                                  <span className={vosRowClass('duration')}><i className='fa-solid fa-clock me-2 text-muted align-self-center' style={{fontSize: '12px'}} /><span className='me-2 fw-bold'>Duration:</span> {(() => { const s = meetingSummary.reqStartDate || meetingSummary.startDate; const e = meetingSummary.reqEndDate || meetingSummary.endDate; if (!s || !e) return '-'; const m = moment(e).diff(moment(s), 'minutes'); return `${Math.floor(m / 60)}h ${m % 60}m` })()}</span>
                                  <span className={vosRowClass('breakTime')}><i className='fa-solid fa-mug-hot me-2 text-muted align-self-center' style={{fontSize: '12px'}} /><span className='me-2 fw-bold'>Break Time (mins):</span> {(meetingSummary.requesterBreakTimeMinutes ?? meetingSummary.RequesterBreakTimeMinutes) != null ? (meetingSummary.requesterBreakTimeMinutes ?? meetingSummary.RequesterBreakTimeMinutes) : '-'}</span>
                                  <span className={vosRowClass('mileage')}><i className='fa-solid fa-car me-2 text-muted align-self-center' style={{fontSize: '12px'}} /><span className='me-2 fw-bold'>Mileage Of Drive (miles):</span> {(meetingSummary.requesterMilage ?? meetingSummary.RequesterMilage ?? meetingSummary.milage) != null ? (meetingSummary.requesterMilage ?? meetingSummary.RequesterMilage ?? meetingSummary.milage) : '-'}</span>
                                  <span className={vosRowClass('roundTrip')}><i className='fa-solid fa-route me-2 text-muted align-self-center' style={{fontSize: '12px'}} /><span className='me-2 fw-bold'>Round trip:</span> {(meetingSummary.requesterIsRoundTrip ?? meetingSummary.RequesterIsRoundTrip ?? meetingSummary.isRoundTrip) ? 'Yes' : 'No'}</span>
                                  <span className={vosRowClass('travelTime')}><i className='fa-solid fa-briefcase me-2 text-muted align-self-center' style={{fontSize: '12px'}} /><span className='me-2 fw-bold'>Travel Time:</span> {formatVosTravelTime(
                                    meetingSummary.requesterTravelTimeH ?? meetingSummary.RequesterTravelTimeH ?? meetingSummary.travalTimeH,
                                    meetingSummary.requesterTravelTimeM ?? meetingSummary.RequesterTravelTimeM ?? meetingSummary.travalTimeM
                                  )}</span>
                                  <div className='mt-3'>
                                    <VOSSignatureImage fileUrl={meetingSummary.reqSignUrl} label='Client Signature' />
                                  </div>
                                  </>) : (<>Not Yet Confirmed or Disputed</>)}
                                </div>
                              </div>
                              <div className='col-md-6'>
                                <div className='card border rounded p-3'>
                                  <div className='fw-bold mb-3'>Interpreter Submitted VOS</div>
                                  <span className={vosRowClass('startTime')}><i className='fa-solid fa-clock me-2 text-muted align-self-center' style={{fontSize: '12px'}} /><span className='me-2 fw-bold'>Start Time:</span> {meetingSummary.startDate ? moment(meetingSummary.startDate).format('hh:mm A') : '-'}</span>
                                  <span className={vosRowClass('endTime')}><i className='fa-solid fa-clock me-2 text-muted align-self-center' style={{fontSize: '12px'}} /><span className='me-2 fw-bold'>End Time:</span> {meetingSummary.endDate ? moment(meetingSummary.endDate).format('hh:mm A') : '-'}</span>
                                  <span className={vosRowClass('duration')}><i className='fa-solid fa-clock me-2 text-muted align-self-center' style={{fontSize: '12px'}} /><span className='me-2 fw-bold'>Duration:</span> {meetingSummary.startDate && meetingSummary.endDate ? (() => { const m = moment(meetingSummary.endDate).diff(moment(meetingSummary.startDate), 'minutes'); return `${Math.floor(m / 60)}h ${m % 60}m` })() : '-'}</span>
                                  <span className={vosRowClass('breakTime')}><i className='fa-solid fa-mug-hot me-2 text-muted align-self-center' style={{fontSize: '12px'}} /><span className='me-2 fw-bold'>Break Time (mins):</span> {(() => { const v = readOsiBreakTimeMinutes(meetingSummary as Record<string, unknown>); return v != null ? v : '-' })()}</span>
                                  <span className={vosRowClass('mileage')}><i className='fa-solid fa-car me-2 text-muted align-self-center' style={{fontSize: '12px'}} /><span className='me-2 fw-bold'>Mileage Of Drive (miles):</span> {meetingSummary.milage != null ? meetingSummary.milage : '-'}</span>
                                  <span className={vosRowClass('roundTrip')}><i className='fa-solid fa-route me-2 text-muted align-self-center' style={{fontSize: '12px'}} /><span className='me-2 fw-bold'>Round trip:</span> {meetingSummary.isRoundTrip ? 'Yes' : 'No'}</span>
                                  <span className={vosRowClass('travelTime')}><i className='fa-solid fa-briefcase me-2 text-muted align-self-center' style={{fontSize: '12px'}} /><span className='me-2 fw-bold'>Travel Time:</span> {formatVosTravelTime(meetingSummary?.travalTimeH, meetingSummary?.travalTimeM)}</span>
                                  <div className='mt-3'>
                                    <VOSSignatureImage fileUrl={meetingSummary.terpSignUrl} label='Interpreter Signature' />
                                  </div>
                                </div>
                              </div>
                            </div>
                            ) : null}
                            </>
                            )}
                            <div className='row g-3 mb-3'>
                              <div className='col-12'>
                                <MeetingSummaryExtensionsCard
                                  extensions={extensionRequests}
                                  loading={extensionsLoading}
                                />
                              </div>
                            </div>
                            {showDigitalVosFormViewer && (
                              <div className='row mb-3'>
                                <div className='col-12'>
                                  <DigitalVosFormViewer
                                    fileName={`VOS Form ${appointmentDetails.code}-${moment().format('MM/DD/YYYY')}.pdf`}
                                    previewText='View VOS Form'
                                    input={{
                                      appointment: appointmentDetails,
                                      meetingSummary,
                                      extensions: extensionRequests,
                                      osiNotes: osiNotes ?? [],
                                    }}
                                  />
                                </div>
                              </div>
                            )}
                            {vosFormFileUrl && !showDigitalVosFormViewer && (
                              <div className='row mb-3'>
                                <div className='col-12'>
                                  <OSIDocumentViewer
                                    fileUrl={vosFormFileUrl}
                                    fileName={`VOS Fill Form ${appointmentDetails.code}-${moment().format('MM/DD/YYYY')}`}
                                    previewText='View VOS Form'
                                  />
                                </div>
                              </div>
                            )}


                            <div className='w-100'>
                              <span className='me-2 fw-bold'>Additional Expenses</span>
                              {meetingSummary.osiExpensesList?.length > 0 ? (
                                <div
                                  className='table-responsive'
                                  style={{minHeight: '250px', overflowY: 'auto'}}
                                >
                                  <table className='table table-row-dashed table-row-gray-300 align-middle gs-2 gy-2 table-hover'>
                                    <thead>
                                      <tr className='fw-semibold text-muted text-uppercase '>
                                        <th className='min-w-100px '>Description</th>
                                        <th className='min-w-100px '>Amount</th>
                                        <th className='min-w-50px text-end'>View</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {meetingSummary.osiExpensesList?.map(
                                        (item: any, index: any) => (
                                          <tr>
                                            <td>{item?.description} </td>
                                            <td>{item?.amount}</td>
                                            <td className='text-end'>
                                              {item?.fileName ? (
                                                <OSIDocumentViewModal
                                                  osiCode={meetingSummary?.code}
                                                  documentCode={item?.code}
                                                  fileName={item?.fileName}
                                                />
                                              ) : (
                                                <span className='text-muted'>-</span>
                                              )}
                                            </td>
                                          </tr>
                                        )
                                      )}
                                    </tbody>
                                  </table>
                                </div>
                              ) : (
                                <div className='card bg-white mb-2 mx-2'>
                                  <div className='py-5 d-flex flex-column align-content-center justify-content-center'>
                                    <div className='text-center'>
                                      <div className='symbol symbol-200px '>
                                        <img src='/media/other/nodata.png' alt='' />
                                      </div>
                                    </div>
                                    <div className='d-flex text-center w-100 align-content-center justify-content-center fw-semibold fs-3 text-gray-400'>
                                      No additional expenses added
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className='col-md-6 col-sm-12 pt-2 mb-3 border border-gray-500 rounded border-dotted p-5 mt-2'>
                          <div className='d-flex justify-content-between align-items-center mb-3'>
                            <div className='d-flex'>
                              <h3 className='d-flex fs-3 fw-semibold mb-3'>Notes</h3>
                            </div>
                            <div className='d-fex'>
                              <button
                                className='btn text-white btn-primary btn-sm mx-1'
                                data-bs-toggle='modal'
                                data-bs-target='#kt_modal_5'
                                style={{fontSize: '12px'}}
                              >
                                <KTSVG
                                  path='/media/icons/duotune/general/gen005.svg'
                                  className='svg-icon-muted'
                                />
                                Add Note
                              </button>
                            </div>
                          </div>
                          <div className='separator my-3'></div>
                          <div
                            className='scrollable-notes'
                            style={{maxHeight: '50vh', overflowY: 'auto'}}
                          >
                            {osiNotes?.length > 0 ? (
                              osiNotes?.map((item: any) => (
                                <div className='card bg-white mb-2 border border-dotted border-gray-400 border-1 mx-2'>
                                  <div className='card-body p-4'>
                                    <div className='d-flex justify-content-between flex-nowrap w-100'>
                                      <div className='d-flex align-items-center w-100'>
                                        <div className='symbol-group symbol-hover me-3'>
                                          {item.avatar ? (
                                            <div className='symbol symbol-circle symbol-50px'>
                                              <ProfileImg
                                                imagePath={item.avatar}
                                                alt=''
                                                className='rounded-circle'
                                                style={{objectFit: 'cover'}}
                                              />
                                            </div>
                                          ) : (
                                            <div className='symbol symbol-circle symbol-50px overflow-hidden me-3'>
                                              <div
                                                className={clsx(
                                                  'symbol-label fs-3',
                                                  'badge-light-success',
                                                  `bg-light-success`
                                                )}
                                              >
                                                <span style={{fontSize: '20px'}}>
                                                  {(item?.insertedBy ?? '')
                                                    .charAt(0)
                                                    .toUpperCase() +
                                                    (item?.insertedBy ?? '')
                                                      .charAt(1)
                                                      .toUpperCase()}
                                                </span>
                                              </div>
                                            </div>
                                          )}
                                        </div>
                                        <div className='d-flex flex-column w-100'>
                                          <div className='d-flex justify-content-between w-100 flex-wrap'>
                                            <div className='d-flex flex-wrap'>
                                              {/* <span className='fw-bold d-flex align-items-center fs-6 me-1 me-3'>
                                                {item?.note}
                                              </span> */}
                                              <div className='d-flex'>
                                                <span className='badge  badge-secondary px-3 fs-8'>
                                                  {item?.insertedBy ?? 'N/A'}
                                                </span>
                                              </div>
                                            </div>

                                            <div className='d-flex text-gray-600'>
                                              <span className='fs-8'>
                                                <i className='bi bi-calendar-check me-2'></i>
                                                {moment(item.insertedDateTime).format(
                                                  'MM/DD/YY hh:mm A'
                                                )}
                                              </span>
                                            </div>
                                          </div>

                                          <div className='d-flex flex-column flex-1 mt-1'>
                                            <span className='fs-7'>{item?.note ?? 'N/A'}</span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ))
                            ) : (
                              <div className='card bg-white mb-2 mx-2'>
                                <div className='py-5 d-flex flex-column align-content-center justify-content-center'>
                                  <div className='text-center'>
                                    <div className='symbol symbol-200px '>
                                      <img src='/media/other/nodata.png' alt='' />
                                    </div>
                                  </div>
                                  <div className='d-flex text-center w-100 align-content-center justify-content-center fw-semibold fs-3 text-gray-400'>
                                    No matching records found
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </>
                    ) : isBotMeetingSuccessful ? (
                      <div className='col-12 pt-2'>
                        {renderBotAttendanceCard()}
                        <div className='d-flex text-muted small mb-3'>
                          <i className='fa-solid fa-circle-info me-2 align-self-center' style={{fontSize: '12px'}} />
                          VOS has not been submitted yet — times shown are bot-recorded.
                        </div>
                        <div className='py-5 d-flex flex-column align-content-center justify-content-center'>
                          <div className='text-center'>
                            <div className='symbol symbol-150px '>
                              <img src='/media/other/work-in-progress.gif' alt='' />
                            </div>
                          </div>
                          <div className='d-flex text-center w-100 align-content-center justify-content-center fw-semibold fs-3 text-gray-400'>
                            Appointment details have not been submitted yet.
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className='col-12 pt-2'>
                        {renderBotAttendanceCard()}
                        <div className='py-5 d-flex flex-column align-content-center justify-content-center'>
                          <div className='text-center'>
                            <div className='symbol symbol-150px '>
                              <img src='/media/other/work-in-progress.gif' alt='' />
                            </div>
                          </div>
                          <div className='d-flex text-center w-100 align-content-center justify-content-center fw-semibold fs-3 text-gray-400'>
                            Appointment details have not been submitted yet.
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
            {isOpenCancelSeriesSelectionModal && (
              <CancelSeriesSelectionModal
                appointmentId={Number(appointmentDetails?.code ?? id)}
                onClose={() => setIsOpenCancelSeriesSelectionModal(false)}
                onConfirm={handleCancelSeriesSelectionConfirm}
              />
            )}
            {showSuboptimalAssignmentModal && suboptimalSelectedInterpreter && (
              <SuboptimalAssignmentModal
                recommendedInterpreters={getRecommendedInterpreters()}
                selectedInterpreter={suboptimalSelectedInterpreter}
                onClose={handleCloseSuboptimalModal}
                onAssignRecommended={handleRecommendedAssignFromSuboptimal}
                onConfirmOriginallySelected={handleConfirmOriginallySelected}
              />
            )}
            {showRecurringSeriesSelectionModal && (
              <RecurringSeriesSelectionModal
                mode={recurringSeriesSelectionMode}
                appointmentId={Number(appointmentDetails?.code ?? id)}
                interpreterId={
                  recurringSeriesSelectionMode === 'unassign'
                    ? pendingUnassignValues?.interpreterId
                    : pendingAssignDetails?.interpreterId
                }
                isSubmitting={isAssignUnassignInProgress}
                onClose={() => {
                  if (!isAssignUnassignInProgress) {
                    setShowRecurringSeriesSelectionModal(false)
                  }
                }}
                onConfirm={handleRecurringSeriesSelectionConfirm}
              />
            )}
            {isOpenCancelConfirmationModal && (
              <CancelConfirmationModal
                title='Confirmation'
                content={message}
                onSubmit={async (payload) => await handleAppoinmentCancelation(payload)}
                setOpen={setIsOpenCancelConfirmationModal}
                isConfirmed={appointmentDetails?.status === 2}
                variant={
                  currentUser?.result?.userType === 'CONSUMER' ? 'client' : 'admin'
                }
                allowAdvancedCancellationTypes={
                  !isBulkCancalation || selectedAppointmentIdsForCancel.length <= 1
                }
              />
            )}
            {isSmsActivityOpen && id && (
              <SmsActivityModal
                appointmentId={Number(id)}
                onClose={() => setIsSmsActivityOpen(false)}
              />
            )}

            {isRebroadcastModalOpen && id && (
              <RebroadcastModal
                appointmentId={Number(id)}
                showDistanceRadius={appointmentDetails?.communicationTypeIdentification === 'ON_SITE'}
                aiAssignmentInScope={isAiAssignmentInScope(
                  appointmentDetails?.fK_CommunicationType
                )}
                onClose={() => setIsRebroadcastModalOpen(false)}
                onSuccess={() => {
                  fetchAppoinmentDetails()
                  setAiAssignmentSummaryRefreshKey((key) => key + 1)
                }}
              />
            )}
            {markUnavailableTarget && (
              <MarkUnavailableModal
                interpreterName={markUnavailableTarget?.name ?? 'this interpreter'}
                onClose={() => setMarkUnavailableTarget(null)}
                onConfirm={handleConfirmMarkUnavailable}
              />
            )}

            {/* Consumer-only cancel info modal */}
            {showConsumerCancelModal && (
              <>
                <div className='modal fade show d-block' tabIndex={-1} role='dialog'>
                  <div className='modal-dialog'>
                    <div className='modal-content'>
                      <div className='modal-header py-2'>
                        <h4 className='modal-title'>Cancellation Information</h4>
                        <div
                          className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                          style={{cursor: 'pointer'}}
                          onClick={() => setShowConsumerCancelModal(false)}
                        >
                          <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon svg-icon-2x' />
                        </div>
                      </div>
                      <div className='modal-body'>
                        <p>
                          This appointment is within the cancellation threshold. Please contact
                          Ad Astra support for assistance at
                          <a href='mailto:interpreting@ad-astrainc.com' className='ms-1'>
                            interpreting@ad-astrainc.com
                          </a>
                          .
                        </p>
                      </div>
                      <div className='modal-footer py-3'>
                        <button
                          type='button'
                          className='btn btn-primary btn-sm'
                          onClick={() => setShowConsumerCancelModal(false)}
                        >
                          OK
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='modal-backdrop fade show'></div>
              </>
            )}

            {showConsumerCancelSuccessModal && cancelledAppointmentSnapshot && (
              <>
                <div className='modal fade show d-block' tabIndex={-1} role='dialog'>
                  <div className='modal-dialog modal-dialog-centered'>
                    <div className='modal-content'>
                      <div className='modal-header py-2'>
                        <h4 className='modal-title'>Appointment Cancelled</h4>
                        <div
                          className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                          style={{cursor: 'pointer'}}
                          onClick={() => setShowConsumerCancelSuccessModal(false)}
                        >
                          <KTSVG
                            path='/media/icons/duotune/arrows/arr061.svg'
                            className='svg-icon svg-icon-2x'
                          />
                        </div>
                      </div>
                      <div className='modal-body'>
                        <p className='mb-4'>
                          Your appointment has been successfully cancelled. This cancellation is
                          non-billable.
                        </p>
                        <p className='fw-bold mb-2'>Appointment Details:</p>
                        <ul className='mb-0'>
                          <li>
                            <strong>ID:</strong> {cancelledAppointmentSnapshot?.code}
                          </li>
                          <li>
                            <strong>Date:</strong>{' '}
                            {moment(cancelledAppointmentSnapshot?.startTime).format('MM/DD/YYYY')}
                          </li>
                          <li>
                            <strong>Start Time:</strong>{' '}
                            {moment(cancelledAppointmentSnapshot?.startTime).format('h:mm A')}
                          </li>
                          <li>
                            <strong>Language Pair:</strong>{' '}
                            {cancelledAppointmentSnapshot?.languageFrom} to{' '}
                            {cancelledAppointmentSnapshot?.languageTo}
                          </li>
                        </ul>
                      </div>
                      <div className='modal-footer py-3'>
                        <button
                          type='button'
                          className='btn btn-primary btn-sm'
                          onClick={() => setShowConsumerCancelSuccessModal(false)}
                        >
                          OK
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='modal-backdrop fade show'></div>
              </>
            )}

            {/* Recurring Appointment Unassign Modal */}
            {showRecurringUnassignModal && (
              <>
                <div className="modal-backdrop fade show"></div>
                <div className='modal fade show mt-10' style={{display: 'block'}} tabIndex={-1} id='RecurringAppointmentUnassignModal'>
                  <div className='modal-dialog'>
                    <div className='modal-content'>
                      <div className='modal-header py-2'>
                        <h4 className='modal-title'>Recurring Unassignment</h4>
                        <div
                          className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                          aria-label='Close'
                          style={{cursor: 'pointer'}}
                        onClick={() => {
                          if (!isAssignUnassignInProgress) {
                            setShowRecurringUnassignModal(false)
                            setPendingUnassignValues(null)
                          }
                        }}
                        >
                          <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon svg-icon-2x' />
                        </div>
                      </div>
                      <div className='modal-body'>
                        <h5 className='fw-normal fs-5' style={{textAlign: 'center'}}>
                          Do you want to unassign this interpreter from all recurring appointments?
                        </h5>
                      </div>
                      <div className='modal-footer py-3 d-flex justify-content-between gap-2'>
                        <button
                          type='button'
                          className='btn btn-primary btn-sm'
                          disabled={isAssignUnassignInProgress}
                          onClick={() => handleConfirmUnassign(false)}
                        >
                          {isAssignUnassignInProgress && recurringModalLoadingAction === 'only' ? (
                            <>
                              <span className='spinner-border spinner-border-sm align-middle me-2'></span>
                              Unassigning...
                            </>
                          ) : (
                            'Only this'
                          )}
                        </button>
                        <button
                          type='button'
                          className='btn btn-primary btn-sm'
                          disabled={isAssignUnassignInProgress}
                          onClick={() => openRecurringSeriesSelection('unassign')}
                        >
                          Selected appointments
                        </button>
                        <button
                          type='button'
                          className='btn btn-success btn-sm'
                          disabled={isAssignUnassignInProgress}
                          onClick={() => handleConfirmUnassign(true)}
                        >
                          {isAssignUnassignInProgress && recurringModalLoadingAction === 'all' ? (
                            <>
                              <span className='spinner-border spinner-border-sm align-middle me-2'></span>
                              Unassigning...
                            </>
                          ) : (
                            'Yes'
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}

            <div className='modal fade' tabIndex={-1} id='kt_approve_confirm'>
              <div className='modal-dialog'>
                <div className='modal-content'>
                  <div className='modal-header py-2'>
                    <h4 className='modal-title'>Confirmation</h4>
                    <div
                      className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                      data-bs-dismiss='modal'
                      aria-label='Close'
                    >
                      <KTSVG
                        path='/media/icons/duotune/arrows/arr061.svg'
                        className='svg-icon svg-icon-2x'
                      />
                    </div>
                  </div>
                  <div className='modal-body'>
                    <div className='text-center mb-5'>
                      <div className='symbol symbol-100px '>
                        <img src='/media/other/process.gif' alt='' />
                      </div>
                    </div>
                    <h4 className='fw-normal fs-5' style={{textAlign: 'center'}}>
                      Are you sure you would like to approve this meeting summary?
                    </h4>
                  </div>
                  <div className='modal-footer py-3'>
                    <button type='button' className='btn btn-light btn-sm' data-bs-dismiss='modal'>
                      Close
                    </button>

                    <button
                      type='button'
                      className='btn btn-success btn-sm'
                      data-bs-dismiss='modal'
                      onClick={() => handleChangeStatus(2)}
                    >
                      Approve
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className='modal fade' tabIndex={-1} id='kt_vos_accept_dispute_confirm'>
              <div className='modal-dialog'>
                <div className='modal-content'>
                  <div className='modal-header py-2'>
                    <h4 className='modal-title'>Confirmation</h4>
                    <div
                      className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                      data-bs-dismiss='modal'
                      aria-label='Close'
                    >
                      <KTSVG
                        path='/media/icons/duotune/arrows/arr061.svg'
                        className='svg-icon svg-icon-2x'
                      />
                    </div>
                  </div>
                  <div className='modal-body'>
                    <div className='text-center mb-5'>
                      <div className='symbol symbol-100px '>
                        <img src='/media/other/process.gif' alt='' />
                      </div>
                    </div>
                    <h4 className='fw-normal fs-5' style={{textAlign: 'center'}}>
                      Are you sure you would like to accept the requester&apos;s VOS changes?
                    </h4>
                  </div>
                  <div className='modal-footer py-3'>
                    <button type='button' className='btn btn-light btn-sm' data-bs-dismiss='modal'>
                      Close
                    </button>
                    <button
                      type='button'
                      className='btn btn-success btn-sm'
                      data-bs-dismiss='modal'
                      disabled={isVosDisputeActionLoading}
                      onClick={async () => {
                        await handleVosAcceptDispute()
                      }}
                    >
                      Accept
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className='modal fade' tabIndex={-1} id='kt_vos_reject_dispute_confirm'>
              <div className='modal-dialog'>
                <div className='modal-content'>
                  <div className='modal-header py-2'>
                    <h4 className='modal-title'>Confirmation</h4>
                    <div
                      className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                      data-bs-dismiss='modal'
                      aria-label='Close'
                    >
                      <KTSVG
                        path='/media/icons/duotune/arrows/arr061.svg'
                        className='svg-icon svg-icon-2x'
                      />
                    </div>
                  </div>
                  <div className='modal-body'>
                    <div className='text-center mb-5'>
                      <div className='symbol symbol-100px '>
                        <img src='/media/other/rejected.gif' alt='' />
                      </div>
                    </div>
                    <h4 className='fw-normal fs-5' style={{textAlign: 'center'}}>
                      Are you sure you would like to reject the requester&apos;s VOS changes?
                    </h4>
                  </div>
                  <div className='modal-footer py-3'>
                    <button type='button' className='btn btn-light btn-sm' data-bs-dismiss='modal'>
                      Close
                    </button>
                    <button
                      type='button'
                      className='btn btn-danger btn-sm'
                      data-bs-dismiss='modal'
                      disabled={isVosDisputeActionLoading}
                      onClick={async () => {
                        await handleVosRejectDispute()
                      }}
                    >
                      Reject
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className='modal fade' tabIndex={-1} id='kt_reject_confirm'>
              <div className='modal-dialog'>
                <Formik
                  initialValues={{reason: ''}}
                  validationSchema={addRejectNoteSchema}
                  onSubmit={async (values, {setSubmitting, resetForm}) => {
                    setSubmitting(true)
                    try {
                      try {
                        let response = await axios.put(
                          `${API_URL}/Appoinment/osi-submission-admin-response`,
                          {
                            code: meetingSummary?.code,
                            status: 3,
                            reason: values.reason,
                          }
                        )
                        if (response.data.status === 'S') {
                          resetForm()
                          toaster('success', response.data.text ?? 'Successfuly updated')
                          const modal = document.getElementById('kt_reject_confirm')
                          if (modal) {
                            const modalInstance = Modal.getInstance(modal)
                            if (modalInstance) modalInstance.hide()
                          }
                          await fetchAfterSubmitOSISubmmission()
                        } else {
                          toaster('error', response.data.text ?? 'Fail Actions')
                        }
                      } catch (error) {
                        console.error(error)
                      }
                    } catch (ex) {
                      console.error(ex)
                    }
                  }}
                >
                  {({
                    handleChange,
                    handleBlur,
                    setFieldValue,
                    errors,
                    values,
                    touched,
                    isValid,
                    dirty,
                    isSubmitting,
                    handleSubmit,
                    resetForm,
                    ...formik
                  }) => (
                    <Form>
                      <div className='modal-content'>
                        <div className='modal-header py-2'>
                          <h4 className='modal-title'>Confirmation</h4>
                          <div
                            className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                            data-bs-dismiss='modal'
                            aria-label='Close'
                            onClick={() => resetForm()}
                          >
                            <KTSVG
                              path='/media/icons/duotune/arrows/arr061.svg'
                              className='svg-icon svg-icon-2x'
                            />
                          </div>
                        </div>
                        <div className='modal-body'>
                          <div className='text-center mb-5'>
                            <div className='symbol symbol-100px '>
                              <img src='/media/other/rejected.gif' alt='' />
                            </div>
                          </div>
                          <div className='mb-3'>
                            <label
                              htmlFor='exampleFormControlInput1'
                              className='required form-label fs-7 mb-1  fs-7 mb-1'
                            >
                              Write a reason
                            </label>
                            <textarea
                              placeholder='write reason..'
                              name='reason'
                              id='reason'
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.reason}
                              className='form-control form-control-sm custom-input-height  custom-input-height  form-select-white mb-lg-0'
                            ></textarea>
                            {errors.reason && touched.reason && (
                              <div className='fv-plugins-message-container'>
                                <div className='fv-help-block'>
                                  <span role='alert'>{errors.reason}</span>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                        <div className='modal-footer py-3'>
                          <button
                            type='button'
                            className='btn btn-light btn-sm'
                            data-bs-dismiss='modal'
                            onClick={() => resetForm()}
                          >
                            Close
                          </button>

                          <button
                            type='button'
                            className='btn btn-danger btn-sm'
                            disabled={isSubmitting || !isValid}
                            onClick={() => handleSubmit()}
                          >
                            Reject
                          </button>
                        </div>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
            <div className='modal fade' tabIndex={-1} id='forcefully_assign_interpreters_confirm'>
              <div className='modal-dialog'>
                <div className='modal-content'>
                  <div className='modal-header py-2'>
                    <h4 className='modal-title'>Confirmation</h4>
                    <div
                      className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                      data-bs-dismiss='modal'
                      aria-label='Close'
                      onClick={() => {
                        setForcefullyAssignInterpretersConfirmDetails(null)
                        setNonRecommendedAssignReason(null)
                      }}
                    >
                      <KTSVG
                        path='/media/icons/duotune/arrows/arr061.svg'
                        className='svg-icon svg-icon-2x'
                      />
                    </div>
                  </div>
                  <div className='modal-body'>
                    <div className='table-responsive' style={{maxHeight: '200px', overflowY: 'auto'}}>
                      <table className='table table-sm table-bordered table-hover'>
                        <thead className='table-light'>
                          <tr className='fw-semibold text-muted text-uppercase text-center'>
                            <th className='min-w-100px'>Client</th>
                            <th className='min-w-100px'>Linguist</th>
                            <th className='min-w-100px'>Rate/Hour</th>
                            <th className='min-w-100px'>Rate/Minute</th>
                            <th className='min-w-100px'>Profit Margin</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr className='text-center'>
                            <td className='text-truncate'>{forcefullyAssignInterpretersConfirmDetails?.customer ?? 'N/A'}</td>
                            <td className='text-truncate'>{forcefullyAssignInterpretersConfirmDetails?.name ?? 'N/A'}</td>
                            <td>
                              <input
                                type='number'
                                value={updatedRate ?? ''}
                                className='form-control form-control-sm text-center'
                                onChange={(e) => {
                                  const newRate = e.target.value ? parseFloat(e.target.value) : null;
                                  setUpdatedRate(newRate);
                                }}
                              />
                              {(!updatedRate || updatedRate <= 0) && (
                                <div className='text-danger mt-1' style={{fontSize: '11px'}}>
                                  Rate must be greater than 0
                                </div>
                              )}
                            </td>
                            <td className='text-truncate'>
                              {updatedRate ? (updatedRate / 60).toFixed(2) :
                                forcefullyAssignInterpretersConfirmDetails?.rate?.match(/\d+/)?.[0]
                                  ? (parseFloat(forcefullyAssignInterpretersConfirmDetails?.rate?.match(/\d+/)?.[0]) / 60).toFixed(2)
                                  : ''}
                            </td>
                            <td className='text-truncate'>
                              {forcefullyAssignInterpretersConfirmDetails?.customerRate == 0 ? (
                                <span className="text-danger" style={{ fontSize: '12px' }}>
                                  Customer rate is not added
                                </span>
                              ) : updatedRate && forcefullyAssignInterpretersConfirmDetails && forcefullyAssignInterpretersConfirmDetails.customerRate ? (
                                `${(((forcefullyAssignInterpretersConfirmDetails.customerRate - updatedRate) / forcefullyAssignInterpretersConfirmDetails.customerRate) * 100).toFixed(2)}`
                              ) : forcefullyAssignInterpretersConfirmDetails?.rate?.match(/\d+/)?.[0] ? (
                                `${(((forcefullyAssignInterpretersConfirmDetails.customerRate - parseFloat(forcefullyAssignInterpretersConfirmDetails.rate.match(/\d+/)?.[0])) / forcefullyAssignInterpretersConfirmDetails.customerRate) * 100).toFixed(2)}`
                              ) : (
                                'N/A'
                              )}%
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div className='modal-footer py-3'>
                    <button
                      type='button'
                      className='btn btn-light btn-sm'
                      data-bs-dismiss='modal'
                      onClick={() => {
                        setForcefullyAssignInterpretersConfirmDetails(null)
                        setNonRecommendedAssignReason(null)
                      }}
                    >
                      Close
                    </button>
                    <button
                      type='button'
                      className='btn btn-success btn-sm'
                      data-bs-dismiss='modal'
                      disabled={!updatedRate || updatedRate <= 0 || isAssignUnassignInProgress}
                      onClick={() =>
                        handleAssignClick(
                          forcefullyAssignInterpretersConfirmDetails?.statusId,
                          forcefullyAssignInterpretersConfirmDetails?.appointmentId,
                          forcefullyAssignInterpretersConfirmDetails?.interpreterId,
                          forcefullyAssignInterpretersConfirmDetails?.rate?.match(/\d+/)?.[0]
                            ? parseFloat(
                                forcefullyAssignInterpretersConfirmDetails.rate.match(/\d+/)[0]
                              )
                            : 0,
                          forcefullyAssignInterpretersConfirmDetails?.customerRate ?? undefined,
                          forcefullyAssignInterpretersConfirmDetails?.customerRateId,
                          forcefullyAssignInterpretersConfirmDetails?.interpreterRateId,
                          nonRecommendedAssignReason?.reasonId,
                          nonRecommendedAssignReason?.reason,
                          nonRecommendedAssignReason?.reasonDetail
                        )
                      }
                    >
                      {isAssignUnassignInProgress ? (
                        <>
                          <span className='spinner-border spinner-border-sm align-middle me-2'></span>
                          Assigning...
                        </>
                      ) : (
                        'Assign'
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className='modal fade' tabIndex={-1} id='edited_rates_model'>
              <div className='modal-dialog'>
                <div className='modal-content'>
                  <div className='modal-header py-2'>
                    <h4 className='modal-title'>Appointment ID : {appointmentDetails?.code}</h4>
                    <div
                      className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                      data-bs-dismiss='modal'
                      aria-label='Close'
                      onClick={() => setForcefullyAssignInterpretersConfirmDetails(null)}
                    >
                      <KTSVG
                        path='/media/icons/duotune/arrows/arr061.svg'
                        className='svg-icon svg-icon-2x'
                      />
                    </div>
                  </div>
                  <div className='modal-body'>
                    <div className='table-responsive'>
                      <table className='table table-sm table-bordered table-hover'>
                        <thead className='table-light'>
                          <tr className='fw-semibold text-muted text-uppercase text-center'>
                            <th className='min-w-100px'>Client</th>
                            <th className='min-w-100px'>Linguist</th>
                            <th className='min-w-100px'>Global Rate</th>
                            <th className='min-w-100px'>Edited Rate</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr className='text-center'>
                            <td className='text-truncate'>
                              {forcefullyAssignInterpretersConfirmDetails?.customer ?? 'N/A'}
                            </td>
                            <td className='text-truncate'>
                              {forcefullyAssignInterpretersConfirmDetails?.name ?? 'N/A'}
                            </td>
                            <td className='text-truncate'>
                              $
                              {forcefullyAssignInterpretersConfirmDetails?.appointmentCharges
                                ?.interpreterRate ?? 'N/A'}
                            </td>
                            <td className='text-truncate'>
                              $
                              {forcefullyAssignInterpretersConfirmDetails?.appointmentCharges
                                ?.interpreterUpdatedRate ?? 'N/A'}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div className='mt-3'>
                      <span className='fw-bold'>Edited By:</span>{' '}
                      {forcefullyAssignInterpretersConfirmDetails?.appointmentCharges?.updatedBy ??
                        'N/A'}
                    </div>
                  </div>
                  <div className='modal-footer py-3'>
                    <button
                      type='button'
                      className='btn btn-light btn-sm'
                      data-bs-dismiss='modal'
                      onClick={() => setForcefullyAssignInterpretersConfirmDetails(null)}
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className='modal fade' tabIndex={-1} id='kt_osi_settings_info'>
              <div className='modal-dialog'>
                <div className='modal-content'>
                  <div className='modal-header py-2'>
                    <h4 className='modal-title'>OSI Settings</h4>
                    <div
                      className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                      data-bs-dismiss='modal'
                      aria-label='Close'
                    >
                      <i className='fa fa-times'></i>
                    </div>
                  </div>
                  <div className='modal-body'>
                    <div className='row g-3'>
                      <div className='col-12'>
                        {/* OSI Boolean Settings as disabled checkboxes - removed ExpensesPayable/Chargeable for Interpreter/Client */}
                        <div className='form-check mb-2'>
                          <input type='checkbox' className='form-check-input' checked={!!initialValuesOSI.isMileagePayableForInterpreter} disabled readOnly />
                          <label className='form-check-label'>Mileage Payable For Interpreter</label>
                        </div>
                        <div className='form-check mb-2'>
                          <input type='checkbox' className='form-check-input' checked={!!initialValuesOSI.isMileageChargeableForClient} disabled readOnly />
                          <label className='form-check-label'>Mileage Chargeable For Client</label>
                        </div>
                        <div className='form-check mb-2'>
                          <input type='checkbox' className='form-check-input' checked={!!initialValuesOSI.isTravelTimePayableForInterpreter} disabled readOnly />
                          <label className='form-check-label'>Travel Time Payable For Interpreter</label>
                        </div>
                        <div className='form-check mb-2'>
                          <input type='checkbox' className='form-check-input' checked={!!initialValuesOSI.isTravelTimeChargeableForClient} disabled readOnly />
                          <label className='form-check-label'>Travel Time Chargeable For Client</label>
                        </div>
                        <div className='form-check mb-2'>
                          <input type='checkbox' className='form-check-input' checked={!!initialValuesOSI.isTimeChargeableForInterpreter} disabled readOnly />
                          <label className='form-check-label'>Time Chargeable For Interpreter</label>
                        </div>
                        <div className='form-check mb-2'>
                          <input type='checkbox' className='form-check-input' checked={!!initialValuesOSI.isTimeChargeableForClient} disabled readOnly />
                          <label className='form-check-label'>Time Chargeable For Client</label>
                        </div>
                        {/* OSI Appointment Details as disabled text inputs */}
                        <div className='mb-2'>
                          <label className='form-label'>Start Time</label>
                          <input type='text' className='form-control' value={initialValuesOSI.startTime || ''} disabled />
                        </div>
                        <div className='mb-2'>
                          <label className='form-label'>End Time</label>
                          <input type='text' className='form-control' value={initialValuesOSI.endTime || ''} disabled />
                        </div>
                        <div className='mb-2'>
                          <label className='form-label'>Travel Hours</label>
                          <input type='text' className='form-control' value={initialValuesOSI.travelHours || ''} disabled />
                        </div>
                        <div className='mb-2'>
                          <label className='form-label'>Travel Minutes</label>
                          <input type='text' className='form-control' value={initialValuesOSI.travelMinutes || ''} disabled />
                        </div>
                        <div className='mb-2'>
                          <label className='form-label'>Mileage of Drive</label>
                          <input type='text' className='form-control' value={initialValuesOSI.milageOfDrive || ''} disabled />
                        </div>
                        {/* Additional Expenses as plain text, now with Payable/Chargeable checkboxes on edit */}
                        {expenseList && expenseList.length > 0 && (
                          <div className='mb-2'>
                            <label className='form-label'>Additional Expenses</label>
                            <ul className='list-unstyled mb-0'>
                              {expenseList.map((exp: any, idx: number) => (
                                <li key={idx} className='mb-3'>
                                  <span className='fw-bold'>{exp.description || 'No Description'}</span>: ${exp.amount || '0.00'}
                                  {/* Only show checkboxes if editing (isOsiEdit && !readOnly) */}
                                  {isOsiEdit && !showOsiReadOnly && (
                                    <div className='d-flex flex-row mt-2'>
                                      <div className='form-check me-3'>
                                        <input
                                          type='checkbox'
                                          className='form-check-input'
                                          checked={!!exp.isExpensesPayableForInterpreter}
                                          onChange={e => {
                                            const updated = [...expenseList]
                                            updated[idx].isExpensesPayableForInterpreter = e.target.checked
                                            setExpenseList(updated)
                                          }}
                                        />
                                        <label className='form-check-label'>Expenses Payable For Interpreter</label>
                                      </div>
                                      <div className='form-check'>
                                        <input
                                          type='checkbox'
                                          className='form-check-input'
                                          checked={!!exp.isExpensesChargeableForClient}
                                          onChange={e => {
                                            const updated = [...expenseList]
                                            updated[idx].isExpensesChargeableForClient = e.target.checked
                                            setExpenseList(updated)
                                          }}
                                        />
                                        <label className='form-check-label'>Expenses Chargeable For Client</label>
                                      </div>
                                    </div>
                                  )}
                                </li>
                              ))}
                            </ul>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className='modal-footer py-3'>
                    <button type='button' className='btn btn-light btn-sm' data-bs-dismiss='modal'>Close</button>
                  </div>
                </div>
              </div>
            </div>

            {/* Recurring Appointment Assign Modal */}
            {showRecurringAssignModal && (
              <>
              {/* Modal Backdrop */}
                <div className="modal-backdrop fade show"></div>
                {/* Modal Dialog */}
              <div className='modal fade show mt-10' style={{display: 'block'}} tabIndex={-1} id='RecurringAppointmentAssignModal'>
                <div className='modal-dialog'>
                  <div className='modal-content'>
                    <div className='modal-header py-2'>
                      <h4 className='modal-title'>Recurring Assignment</h4>
                      <div
                        className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                        aria-label='Close'
                        style={{cursor: 'pointer'}}
                        onClick={() => {
                          if (!isAssignUnassignInProgress) {
                            setShowRecurringAssignModal(false)
                            setPendingAssignDetails(null)
                          }
                        }}
                      >
                        <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon svg-icon-2x' />
                      </div>
                    </div>
                    <div className='modal-body'>
                      <h5 className='fw-normal fs-5' style={{textAlign: 'center'}}>
                        Do you want to assign this interpreter to all recurring appointments?
                      </h5>
                    </div>
                    <div className='modal-footer py-3 d-flex justify-content-between gap-2'>
                      <button
                        type='button'
                        className='btn btn-primary btn-sm'
                        disabled={isAssignUnassignInProgress}
                        onClick={() => handleRecurringAssign(false)}
                      >
                        {isAssignUnassignInProgress && recurringModalLoadingAction === 'only' ? (
                          <>
                            <span className='spinner-border spinner-border-sm align-middle me-2'></span>
                            Assigning...
                          </>
                        ) : (
                          'Only this'
                        )}
                      </button>
                      <button
                        type='button'
                        className='btn btn-primary btn-sm'
                        disabled={isAssignUnassignInProgress}
                        onClick={() => openRecurringSeriesSelection('assign')}
                      >
                        Selected appointments
                      </button>
                      <button
                        type='button'
                        className='btn btn-success btn-sm'
                        disabled={isAssignUnassignInProgress}
                        onClick={() => handleRecurringAssign(true)}
                      >
                        {isAssignUnassignInProgress && recurringModalLoadingAction === 'all' ? (
                          <>
                            <span className='spinner-border spinner-border-sm align-middle me-2'></span>
                            Assigning...
                          </>
                        ) : (
                          'Yes'
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              </>
            )}

            {showMissingDocsModal && (
              <>
                <div className="modal-backdrop fade show"></div>
                <div className='modal fade show mt-10' style={{display: 'block'}} tabIndex={-1}>
                  <div className='modal-dialog modal-dialog-centered'>
                    <div className='modal-content'>
                      <div className='modal-header py-2'>
                        <h4 className='modal-title'>Missing Compliance Documents</h4>
                        <div
                          className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                          aria-label='Close'
                          style={{cursor: 'pointer'}}
                          onClick={() => {
                            setShowMissingDocsModal(false)
                            setMissingDocsInterpreter(null)
                            setMissingDocuments([])
                          }}
                        >
                          <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon svg-icon-2x' />
                        </div>
                      </div>
                      <div className='modal-body'>
                        {isLoadingMissingDocs ? (
                          <div className='d-flex justify-content-center py-5'>
                            <span className='spinner-border spinner-border-sm'></span>
                          </div>
                        ) : (
                          <>
                            <p className='mb-3'>
                              <strong>{missingDocsInterpreter?.name}</strong>
                            </p>
                            {missingDocuments.length > 0 ? (
                              <table className='table table-row-dashed table-row-gray-300 align-middle gs-2 gy-2'>
                                <thead>
                                  <tr className='fw-semibold text-muted text-uppercase'>
                                    <th>Document</th>
                                    <th>Status</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {missingDocuments.map((doc: any, index: number) => (
                                    <tr key={index}>
                                      <td>{doc.name}</td>
                                      <td>
                                        {doc.isMissing ? (
                                          <span className='badge badge-light-danger'>Missing</span>
                                        ) : (
                                          <span className='badge badge-light-success'>Uploaded</span>
                                        )}
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            ) : (
                              <p className='text-muted'>No compliance requirements configured for this customer.</p>
                            )}
                          </>
                        )}
                      </div>
                      <div className='modal-footer py-3'>
                        <button
                          type='button'
                          className='btn btn-secondary btn-sm'
                          onClick={() => {
                            setShowMissingDocsModal(false)
                            setMissingDocsInterpreter(null)
                            setMissingDocuments([])
                          }}
                        >
                          Close
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}

          </div>
        </div>
        {(isLoading || isRevertingApproval || isAssignUnassignInProgress) && <CommonLoading />}
      </div>

      <ProfileNotesModal
        show={showClientNotesModal && Boolean(appointmentDetails?.fK_Customer)}
        title='Client Profile Notes'
        onClose={() => setShowClientNotesModal(false)}
      >
        <AccountNotesView accountId={appointmentDetails?.fK_Customer} readOnly />
      </ProfileNotesModal>

      <ProfileNotesModal
        show={Boolean(notesInterpreter?.fK_Interpreter)}
        title='Interpreter Profile Notes'
        onClose={() => setNotesInterpreter(null)}
      >
        <LinguistNotesView linguistId={notesInterpreter?.fK_Interpreter} readOnly />
      </ProfileNotesModal>
    </>
  )
}
